import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import isEqual from 'react-fast-compare';
import copy from 'fast-copy';
import { useTranslation } from 'react-i18next';
import React, { useCallback, useEffect, useRef, useState } from 'react';

import _ from 'lodash';

import Splitter from 'm-react-splitters';

import { Button, FilledInput, LinearProgress as LoadingOverlay, Select, MenuItem, InputLabel, FormControl, withStyles } from '@material-ui/core';

import {
  GridLinkOperator, DataGridPro, useGridApiRef, GridFooter, GridFilterInputValue, frFR, enUS,
  GridToolbarContainer, GridToolbarFilterButton, gridColumnsTotalWidthSelector,
  GridColumnMenu, GridColumnMenuProps, GridColumnMenuItemProps, GridColumnMenuContainer,
  GridFilterMenuItem, SortGridMenuItems, HideGridColMenuItem, GridColumnsMenuItem,
  GridPanelFooter, GridAddIcon, getGridStringOperators, GridColTypeDef
} from '@mui/x-data-grid-pro';

import Swal from 'sweetalert2'

import {
  PROMISE_PENDING,
  isPromisePending,
  promiseStatus
} from 'promise-status-async';

import { getRandomPassword, getDateWithoutTimezone, compareVersionStrings } from '../../../Functions/utils';
// import { update } from '../../../Functions/admin';

import Print from './Print';
import Export from './Export';
import ExportToPDF from './ExportToPDF';
import Columns from './Columns/Columns';
import ReportSelect from "./ReportSelect";

import { useAppContext } from '../../../Context/App/Provider';
import { useEventContext } from '../../../Context/Event/Provider';
import {
  getColumns, getColumnsForModule, updateColumns, updateColumnsForModule,
  getSortModel, getSortModelForModule,

} from '../../../Functions/columns';

import { useReportingContext } from '../../../Context/Reporting/Provider';
import { formatReportingHeader, colors, roles, useStateWithCallback } from '../../../Shared/utils';
import {
  changeReportingColumns, changeReportingSortColumns, changeSettings, getSelectedLocations, getSelectedGroups,
  toggleSidebar, translatedGridFilters, activeGridFilter, getPreciseTime, getTimeAsZDateTime, decodeHTMLEntities
} from '../../../Functions/utils';

import {
  getDeployments, getReportGenerated, getMultiReportGenerated,
  getMultiReportArchiveGenerated, getMultiReportArchiveGeneratedStatus,
  getReports, getWelcomeScreenManualInputs, getSDSQuestions, getScriptHeaders, getMobileOthersData,
  getExtDiskHealthAndPerf
} from '../../../Functions/reporting';

import HistoryDetails from './HistoryDetails';
import ReportingSubCharts from './ReportingSubCharts/ReportingSubCharts';

import Typography from "@material-ui/core/Typography";
import { filterOperators } from "../../../Shared/gridFilters";

import { getAllAvailableColumns } from "./Columns/getAllAvailableColumns.js"

import './Reporting.css';
import './splitters.css'
import '../../SweetAlert.css'


import { diag_code_ids } from "../../../Shared/diagcode"
import { devicesTypeValues, toastTimerValue } from '../../../Shared/utils';

const line_separator = " / ";

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
async function pauseMe(millis) {
  await sleep(millis);
}


class CustomSplitter extends Splitter {
  componentWillUnmount() {
    window.removeEventListener('resize', this.getSize);
  }
}


const StyledDataGrid = withStyles({
  root: {
    "& .MuiDataGrid-renderingZone": {
      maxHeight: "none !important",
      "& .MuiDataGrid-row": {
        "&:nth-child(2n+1)": {
          backgroundColor: "rgba(255, 235, 255, .3)"
        }
      }
    },
    "& .MuiDataGrid-virtualScrollerRenderZone": {
      "& .MuiDataGrid-row": {
        "&:nth-child(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" }
      }
    },
    "& .MuiDataGrid-cell": {
      lineHeight: "unset !important",
      maxHeight: "none !important",
      whiteSpace: "normal"
    },
    "& .MuiDataGrid-row": {
      maxHeight: "none !important"
    }
  },


  // root: {
  //   '& .MuiDataGrid-cell': {
  //     wordBreak: 'break-all',
  //     maxHeight: 'fit-content!important',
  //     overflow: 'auto',
  //     whiteSpace: 'initial!important',
  //     lineHeight: '16px!important',
  //     display: 'flex!important',
  //     alignItems: 'center',
  //     paddingTop: '10px!important',
  //     paddingBottom: '10px!important'
  //   },
  //   '&.MuiDataGrid-cell div': {
  //     maxHeight: 'inherit',
  //     width: '100%',
  //     whiteSpace: 'initial',
  //     lineHeight: '16px'
  //   }
  // },
  virtualScrollerContent: {
    height: '50% !important',
    overflow: 'scroll'
  }
})(DataGridPro);


const DeduplicatedStringColumnType = {
  extendType: 'string',
  filterOperators: getGridStringOperators().filter(
    (operator) => {
      // console.log("149 - operator=", operator);
      return operator.value === 'is' || operator.value === 'not' || operator.value === 'isAnyOf'
    }
  )
};

// const selectedHistoryDetails = (deployment, setDeployment) => {
//   console.log("116 - deployment=", deployment);
//   return (deployment ? <HistoryDetails deployment={deployment} setDeployment={setDeployment} /> : null);
// };


export default function Reporting() {
  const { t } = useTranslation();
  const apiRef = useGridApiRef();

  const [{
    settings, sidebar, user, loading,
    storedFilteredRows, storedMaxRowLines, storedHeaderLinesRatio, storedColumns,
    storedDeployments, storedWithExtraColumns, storedSortModel, storedReports,
    storedWelcomeScreenManualInputs, storedSdsQuestions, storedScriptHeaders, storedMobileOthersData,
    storedSdsExtraDiskHealthFlag, storedSdsExtraDiskPerfFlag,
    storedRowIndex, storedPageNumber, storedPanePrimaryHeight, storedUniqueCount
  }, appDispatch] = useAppContext();

  const [{ reportingColumns, scenario, scenarios, module, pickers, selected, filterModel }, dispatch] = useReportingContext();
  const [{ deploymentsStatus, reportsStatus, groupsLocationsStatus, scenariosStatus, reportingColumnsStatus
    /*scenariosLoading, refreshDeployments, deploymentsLoaded, refreshReportingColumns, reportingColumnsLoaded, locationsPending, groupsPending, refreshReports*/ }, eventDispatch] = useEventContext();

  const period = settings.period;
  const prevScenario = useRef(scenario);
  const prevPeriod = useRef(settings.period);

  const prevMode = useRef(settings.mode);
  const prevModule = useRef(module);

  const cancelation = useRef(getRandomPassword());
  const [cancelled, setCancelled] = useState(false);

  const [reportCurrentCount, setReportCurrentCount] = useState(0);
  const [reportMaxCount, setReportMaxCount] = useState(0);


  //const [loading, setLoading] = useState(false);
  // const [refetchLoading, setRefetchLoading] = useState(false);

  // const [refresh, setRefresh] = useState(false);
  // const [apply, setApply] = useState(false);
  const [reloadFromStore, setReloadFromStore] = useState(true);

  const [welcomeScreenManualInputs, setWelcomeScreenManualInputs] = useState(storedWelcomeScreenManualInputs || []);
  const [sdsQuestions, setSdsQuestions] = useState(storedSdsQuestions || []);
  const [scriptHeaders, setScriptHeaders] = useState(storedScriptHeaders || []);
  const [mobileOthersData, setMobileOthersData] = useState(storedMobileOthersData || []);

  const [sdsExtraDiskHealthFlag, setSdsExtraDiskHealthFlag] = useState(storedSdsExtraDiskHealthFlag || false);
  const [sdsExtraDiskPerfFlag, setSdsExtraDiskPerfFlag] = useState(storedSdsExtraDiskPerfFlag || false);

  const [withExtraColumns, setWithExtraColumns] = useState(storedWithExtraColumns || []);

  const [deployment, setDeployment] = useState(null);
  //const [deployments, setDeployments] = useState(storedDeployments || []);
  const [deployments, setDeployments] = useState([]);
  const [showColumnsMenu, setShowColumnsMenu] = useState(false);
  const [selectionModel, setSelectionModel] = useState([]);

  const [reports, setReports] = useState(storedReports || []);
  const [selectedReport, setSelectedReport] = useState();
  const [reportsOpen, setReportsOpen] = React.useState(false);

  const [model, setModel] = useStateWithCallback({ filtered: null, selected: [] });

  const [columns, setColumns] = useState(storedColumns || []); // ||
  const [deduplicatedColumns, setDeduplicatedColumns] = useState([]);
  const [deduplicatedRows, setDeduplicatedRows] = useState([]);
  const [forced, setForced] = useState(false);
  const [uniqueCount, setUniqueCount] = useState(storedUniqueCount || 0);

  const [activeSortModel, setActiveSortModel] = useState([]);
  // const [sortModel, setSortModel] = useState(storedSortModel || []);
  const [sortModel, setSortModel] = useState([]);

  const [highlightedRow, setHighlightedRow] = useState(null);

  const [filteredRows, setFilteredRows] = useState(storedFilteredRows || []);
  const [maxRowLines, setMaxRowLines] = useState(storedMaxRowLines || 0);
  const [headerLinesRatio, setHeaderLinesRatio] = useState(storedHeaderLinesRatio || 1);

  const [duplicateNetworkCard, setDuplicateNetworkCard] = useState(false);

  const [forceRowIndex, setForceRowIndex] = useState(false);
  const [savedRowIndex, setSavedRowIndex] = useState(0);
  const [savedPageNumber, setSavedPageNumber] = useState();
  // const [savedColumnIndex, setSavedColumnIndex] = useState(0);


  const CustomUserItem = (input) => {
    const { t } = useTranslation();
    const { hideMenu, currentColumn, ...other } = input.props;

    return (
      <MenuItem
        column={currentColumn}
        onClick={(e) => {          
          e.stopPropagation();
          setShowColumnsMenu(true);
          hideMenu(e);
        }}
      >
        {t('reporting.columns.show_menu')}
      </MenuItem>
    );
  }

  const CustomUserItemDeduplicate = (input) => {
    const { t } = useTranslation();
    const { hideMenu, currentColumn, ...other } = input.props;

    return (
      <MenuItem
        column={currentColumn}
        onClick={(e) => {
          e.stopPropagation();

          console.log("266 - CustomUserItemDeduplicate=", e);
          //input.props.currentColumn.deduplicate = input.props.currentColumn.deduplicate !== undefined ? (!input.props.currentColumn.deduplicate) : true;

          const index = deduplicatedColumns.indexOf(input.props.currentColumn.field);
          const newValue = (index === -1);

          let indexFilter = -1;
          let i, leni;
          for (i = 0, leni = filterModel.items.length; i < leni; i++) {
            const item = filterModel.items[i];
            if (
              item.columnField === input.props.currentColumn.field &&
              item.operatorValue === "string_Deduplicate"
            ) {
              indexFilter = i;
              break;
            }
          }


          const deduplicatedColumnsTmp = [...deduplicatedColumns];
          const filterModelTmp = { ...filterModel };
          console.log("296 - filterModelTmp=", filterModelTmp);

          if (newValue) {
            deduplicatedColumnsTmp.push(input.props.currentColumn.field);

            if (indexFilter == -1) {
              // Add in filter
              // console.log("296 - Add in filter=", filterModelTmp, input.props.currentColumn.field);

              let idTmp = Math.floor(Math.random() * (65535) + 1);
              let found = filterModelTmp.items.find((item) => {
                return item.id === idTmp;
              });

              while (found) {
                idTmp = Math.floor(Math.random() * (65535) + 1);
                found = filterModelTmp.items.find((item) => {
                  return item.id === idTmp;
                });
              }

              const newFilter = {
                columnField: input.props.currentColumn.field,
                id: idTmp,
                operatorValue: "string_Deduplicate",
                value: undefined
              }

              filterModelTmp.items.push(newFilter);
              // filterModelTmp.linkOperator = "and";
              dispatch({ filterModel: filterModelTmp });
              console.log("316 - Add in filter=", filterModelTmp, newFilter);

            }
          }
          else {
            deduplicatedColumnsTmp.splice(index, 1);

            if (indexFilter != -1) {
              console.log("299 - Remove from filter=", filterModelTmp, indexFilter);
              filterModelTmp.items.splice(indexFilter, 1);
              console.log("304 - Removed from filter=", filterModelTmp, indexFilter);
              dispatch({ filterModel: filterModelTmp });
            }
          }
          setDeduplicatedColumns(deduplicatedColumnsTmp);


          //*
          //console.log("282 - filterModel=", filterModel);
          // const filterModelTmp = filterModel.slice();
          // let indexFilter = -1;
          // let i, leni;
          // for (i = 0, leni = filterModel.items.length; i < leni; i++) {
          //   const item = filterModel.items[i];
          //   if (
          //       item.columnField === input.props.currentColumn.field && 
          //       item.operatorValue === "string_Deduplicate"
          //     ) {
          //     indexFilter = i;
          //     break;
          //   }
          // }

          // if (indexFilter == -1) {
          //   // Add in filter
          //   console.log("296 - Add in filter=", filterModel, input.props.currentColumn.field);
          // }
          // else {
          //   // remove in filter at indexFilter 
          //   console.log("296 - remove from filter=", filterModel, indexFilter);


          // }

          // const indexInFilter = filterModel.items.indexOf(input.props.currentColumn.field);
          // const newValueInFilter = (indexInFilter === -1);

          // const deduplicatedColumnsTmp = [...deduplicatedColumns];
          // if (newValue) {
          //   deduplicatedColumnsTmp.push(input.props.currentColumn.field);
          // }
          // else {
          //   deduplicatedColumnsTmp.splice(index, 1);
          // }

          // if (filterModel && filterModel.items) {
          //   const deduplicatedColumnsTmp = [];

          //   for (const item of filterModel.items) {
          //     if (
          //       item.operatorValue === "string_Deduplicate" && (
          //         item.columnField === "system_$$_serial_number" ||
          //         (item.columnField === "network_card_$$_mac" && duplicateNetworkCard) ||
          //         item.columnField === "disk_$$_serial_number" ||
          //         item.columnField === "disk_wipe_$$_serial" ||
          //         item.columnField === "disk_wipe_$$_uuid"
          //       )
          //     ) {
          //       deduplicatedColumnsTmp.push(item.columnField);
          //     }
          //   }
          // }
          hideMenu(e);
        }
        }
      >
        <span>
          {deduplicatedColumns.indexOf(input.props.currentColumn.field) !== -1 ? t('reporting.deduplicated') + "   " : t('reporting.deduplicate')}
        </span>

        <span
          className={"material-icons"}
          title={t('global.favorite')}
          style={{
            textAlign: 'left',
            color: deduplicatedColumns.indexOf(input.props.currentColumn.field) !== -1 ? 'rgb(var(--favorite-color))' : 'rgb(var(--nofavorite-color))'
          }}
        >
          {deduplicatedColumns.indexOf(input.props.currentColumn.field) !== -1 ? 'check' : ''}
        </span>

      </MenuItem>
    );
  }

  const CustomColumnMenu = (props) => {
    const { hideMenu, currentColumn, ...other } = props;

    let showDeduplicate = false;
    if (
      currentColumn.field === "system_$$_serial_number" ||
      (currentColumn.field === "network_card_$$_mac" && duplicateNetworkCard) ||
      currentColumn.field === "disk_$$_serial_number" ||
      currentColumn.field === "disk_wipe_$$_serial" ||
      currentColumn.field === "disk_wipe_$$_uuid" ||
      currentColumn.field === "disks_wipe_$$_serial" ||
      currentColumn.field === "disks_wipe_$$_uuid"
    )
      showDeduplicate = true;

    // console.log("263 - currentColumn=", currentColumn);   // Device Serial Number, MAC Address, Disk Serial, Disk UUID
    return (
      <GridColumnMenuContainer
        hideMenu={hideMenu}
        currentColumn={currentColumn}
        {...props}
      >
        <SortGridMenuItems onClick={hideMenu} column={currentColumn} />
        <GridFilterMenuItem onClick={hideMenu} column={currentColumn} />
        <CustomUserItem props={props}></CustomUserItem>

        {showDeduplicate &&
          <CustomUserItemDeduplicate props={props}></CustomUserItemDeduplicate>
        }

      </GridColumnMenuContainer>
    );
  }


  const getInterpretedData = (params) => {

    let lines = String(params.formattedValue).split(line_separator);
    const title = t('reporting.line') + params.id + '(' + lines + ')';

    if ("disk_$$_bus" === params.field) {
      return (
        lines.map(line => {
          return getDiskBus(line);
        })
      )
    }

    if ("disk_$$_health" === params.field || "disk_wipe_$$_health" === params.field || "disks_wipe_$$_health" === params.field) {
      return (
        lines.map(line => {
          return getDiskHealth(line).text;
        })
      )
    }

    if ("battery_$$_power_state" === params.field) {
      return (
        lines.map(line => {
          return getBatteryPowerState(line).text;
        })
      )
    }

    if ("disk_$$_hpa" === params.field || "disk_$$_dco" === params.field) {
      return (
        lines.map(line => {
          // console.log("287 - getDiskHpaAndDco(line).alternateText=", getDiskHpaAndDco(line).alternateText);

          return getDiskHpaAndDco(line).alternateText;
          // const testValue = getDiskHpaAndDco(line);
          // if (testValue.text !== ' ')
          //   return testValue.text;
          // else 
          //   return testValue.alternateTexttext;
        })
      )
    }

    if ("deployments_$$_duration" === params.field) {
      return (
        lines.map(line => {
          let timeString = "";
          if (line !== 'undefined') {
            const duration = parseInt(line);

            let seconds = Math.floor((duration / 1000) % 60);
            let minutes = Math.floor((duration / (1000 * 60)) % 60);
            let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

            minutes = (hours > 0 && minutes < 10) ? "0" + minutes : minutes;
            seconds = (minutes > 0 && seconds < 10) ? "0" + seconds : seconds;

            timeString = (hours > 0 ? hours + "h " : "") + ((hours > 0 || minutes > 0) ? minutes + "min " : "") + seconds + "sec";
          }

          return timeString;
        })
      )
    }


    if (
      "disk_$$_rpm" === params.field
    ) {
      return (
        lines.map(line => {
          return getRPMStyle(line).text;
        })
      )
    }

    if (
      "other_$$_bluetooth" === params.field ||
      "other_$$_biometrics" === params.field ||
      "other_$$_cardreader" === params.field
    ) {

      // console.log("lines=", lines) ;
      return (
        lines.map(line => {
          return getBooleanStyle(line).alternateText;
        })
      )
    }

    if (
      "screen_$$_touch_screen" === params.field
    ) {

      // console.log("lines=", lines) ;
      return (
        lines.map(line => {
          const screen_txt = (line === "1" ? "true" : "false");
          return getBooleanStyle(screen_txt).alternateText;
        })
      )
    }

    if (
      "disk_wipe_$$_result" === params.field
    ) {      
      return (
        lines.map(line => {
          const data = getSmartThresholdExceededResultStyle(line);
          return data.text;
        })
      )
    }

    if (
      "device_wipe_$$_result" === params.field
    ) {      
      return (
        lines.map(line => {
          const [result, extra] = line.split('_$$_');                
          const data = getResultStyle(result);
          return data.text + (extra !== undefined ? "(" + extra + ")" : "");
        })
      )
    }

    if (
      "general_$$_global_result" === params.field || 
      "diag_general_$$_global_result" === params.field ||
      "deployments_$$_result" === params.field || "imaging_$$_imaging_result" === params.field ||
      "disks_wipe_$$_result" === params.field
    ) {

      // console.log("323 - lines=", params.field, lines);
      return (
        lines.map(line => {
          return getResultStyle(line).text;
        })
      )
    }


    if (
      "sbar_$$_activation_result" === params.field
    ) {

      return (
        lines.map(line => {
          return getSbarActivationResultStyle(line).text;
        })
      )
    }


    if (
      // CPU
      "diag_cpu_$$_full_test" === params.field ||
      "diag_cpu_$$_general_purpose_instructions" === params.field ||
      "diag_cpu_$$_floating_point_unit_instructions" === params.field ||
      "diag_cpu_$$_prime_number_test" === params.field ||
      "diag_cpu_$$_maximum_heat" === params.field ||
      "diag_cpu_$$_mmx" === params.field ||
      "diag_cpu_$$_sse" === params.field ||
      "diag_cpu_$$_sse2" === params.field ||
      "diag_cpu_$$_sse3" === params.field ||
      "diag_cpu_$$_aes" === params.field ||
      "diag_cpu_$$_sse41" === params.field ||
      "diag_cpu_$$_sse42" === params.field ||
      "diag_cpu_$$_sse4a" === params.field ||
      "diag_cpu_$$_avx" === params.field ||
      "diag_cpu_$$_fma3" === params.field ||
      "diag_cpu_$$_apple_cpu_test" === params.field ||

      // Memory
      "diag_memory_$$_ram_multi_process_torture" === params.field ||
      "diag_memory_$$_ram" === params.field ||
      "diag_memory_$$_apple_memory_test" === params.field ||

      // Storage
      "diag_storage_$$_hdd_short_smart_test" === params.field ||
      "diag_storage_$$_hdd_long_smart_test" === params.field ||
      "diag_storage_$$_hdd_linear_read_test" === params.field ||
      "diag_storage_$$_hdd_random_read_test" === params.field ||
      "diag_storage_$$_smart_attributes" === params.field ||
      "diag_storage_$$_hdd_smart_status" === params.field ||
      "diag_storage_$$_apple_storage_test" === params.field ||
      "diag_storage_$$_optical_drive_read_test" === params.field ||

      // Video adapter
      // "diag_video_adapter_$$_gpu_test" === params.field ||
      "diag_video_adapter_$$_2d_local_video_memory" === params.field ||
      "diag_video_adapter_$$_2d_all_available_memory" === params.field ||
      "diag_video_adapter_$$_2d_lines_and_bitmaps" === params.field ||
      "diag_video_adapter_$$_2d_emc_scrolling_characters" === params.field ||
      "diag_video_adapter_$$_2d_emc_reference_test_pattern" === params.field ||
      "diag_video_adapter_$$_3d" === params.field ||
      "diag_video_adapter_$$_advanced_GPU_test" === params.field ||
      "diag_video_adapter_$$_gpgpu" === params.field ||
      "diag_video_adapter_$$_apple_gpu_test" === params.field ||

      // Network
      "diag_network_$$_wired_lan" === params.field ||
      "diag_network_$$_wifi_wan" === params.field ||
      "diag_network_$$_apple_wired" === params.field ||
      "diag_network_$$_apple_wifi" === params.field ||
      "diag_network_$$_apple_bluetooth" === params.field ||

      // Audio
      "diag_audio_$$_internal_speaker" === params.field ||
      "diag_audio_$$_internal_microphone" === params.field ||
      "diag_audio_$$_output_jack" === params.field ||
      "diag_audio_$$_input_jack" === params.field ||
      "diag_audio_$$_combo_jack" === params.field ||
      "diag_audio_$$_apple_audio_test" === params.field ||

      // Screen
      "diag_screen_$$_display_ports" === params.field ||
      "diag_screen_$$_apple_hdmi_controller_test" === params.field ||
      "diag_screen_$$_dead_pixel_test" === params.field ||
      "diag_screen_$$_screen_calibration_test" === params.field ||
      "diag_screen_$$_touchscreen" === params.field ||

      // User Inputs
      "diag_user_inputs_$$_keyboard" === params.field ||
      "diag_user_inputs_$$_keyboard_status_led" === params.field ||
      "diag_user_inputs_$$_apple_keyboard_test" === params.field ||
      "diag_user_inputs_$$_apple_touch_id_test" === params.field ||
      "diag_user_inputs_$$_apple_touch_bar_test" === params.field ||
      "diag_user_inputs_$$_mouse_test" === params.field ||
      "diag_user_inputs_$$_touchpad" === params.field ||
      "diag_user_inputs_$$_apple_trackpad_test" === params.field ||
      "diag_user_inputs_$$_trackpoint" === params.field ||

      // Battery
      "diag_battery_$$_battery_wear_level" === params.field ||
      "diag_battery_$$_battery_charging_test" === params.field ||
      "diag_battery_$$_battery_drain_test" === params.field ||
      "diag_battery_$$_apple_battery_test" === params.field ||

      // Sensors
      "diag_sensors_$$_accelerometer" === params.field ||
      "diag_sensors_$$_lid_sensor" === params.field ||
      "diag_sensors_$$_apple_lid_sensor" === params.field ||
      "diag_sensors_$$_apple_ambient_ligh_sensor" === params.field ||
      "diag_sensors_$$_apple_accelerometer_gyroscope_test" === params.field ||

      // Other
      "diag_other_$$_card_reader" === params.field ||
      "diag_other_$$_apple_card_reader" === params.field ||
      "diag_other_$$_suspend_mode_test" === params.field ||
      "diag_other_$$_webcam" === params.field ||
      "diag_other_$$_apple_webcam" === params.field ||
      "diag_other_$$_apple_case_handle_test" === params.field ||
      "diag_other_$$_apple_serial_number_test" === params.field ||
      "diag_other_$$_apple_smc_test" === params.field ||
      "diag_other_$$_apple_firmware_test" === params.field ||
      "diag_other_$$_apple_fan_test" === params.field ||
      "diag_other_$$_apple_power_management_test" === params.field ||
      "diag_other_$$_apple_power_adapter_test" === params.field ||
      "diag_other_$$_apple_io_card" === params.field ||
      "diag_other_$$_apple_antenna_connector_board_test" === params.field ||
      "diag_other_$$_quick_test" === params.field
    ) {

      // console.log("lines=", lines) ;
      return (
        lines.map(line => {
          const [result, extra] = line.split('_$$_');
          const data = getDiagnosticResultStyle(result);

          return data.text + (extra !== undefined ? "(" + extra + ")" : "");
        })
      )
    }

    if (
      "tests_mobiles_$$_tests_mobiles_$$_" === params.field.substring(0, 34)
    ) {

      return (
        lines.map(line => {
          return getMCETestsStyle(line).text;
        })
      )
    }

    if (
      "manual_inputs_mobiles_$$_manual_inputs_mobiles_$$_" === params.field.substring(0, 61)
    ) {

      return (
        lines.map(line => {
          return getMCETestsStyle(line).text;
        })
      )
    }

    if (
      "disks_wipe_$$_smart_attributes_$$_" === params.field.substring(0, 34)
    ) {

      // console.log("508 - lines=", lines);
      return (
        lines.map(line => {
          return line;
        })
      )
    }

    if (
      "disk_wipe_$$_smart_attributes_$$_" === params.field.substring(0, 33)
    ) {

      // console.log("734 - lines=", lines);
      return (
        lines.map(line => {
          return line;
        })
      )
    }



    if (
      "other_mobiles_$$_others_input_value_$$_" === params.field.substring(0, 39)
    ) {
      console.log("505 - lines=", lines);
      return (
        lines.map(line => {
    //       return getMCETestsStyle(line).text;
          return line;
        })
      )
    }

    if (
      "general_$$_date" === params.field ||
      "general_mobiles_$$_date" === params.field ||
      "disks_wipe_$$_date" === params.field
    ) {
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: '2-digit'
      };

      return (
        lines.map(line => {
          if (line !== "null") {
            return new Date(getTimeAsZDateTime(line)).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
          }
          return "";
        })
      );
    }

    if (
      "bios_$$_date" === params.field
    ) {
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      };
      // console.log("7294 - bios_$$_date=", lines);

      return (
        lines.map(line => {
          if (line !== "null") {
            return new Date(line).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
          }
          return "";
        })
      );
    }

    if (
      "cpu_$$_nominal_frequency" === params.field ||
      "cpu_$$_maximum_frequency" === params.field ||
      "ram_bank_$$_speed" === params.field
    ) {

      return (
        lines.map(line => {
          if (line !== "undefined") {
            return line + " MHz";
          }
          return "";
        })
      );
    }

    if (
      "cpu_$$_l1cache" === params.field ||
      "cpu_$$_l2cache" === params.field ||
      "cpu_$$_l3cache" === params.field
    ) {

      return (
        lines.map(line => {
          if (line !== "undefined") {
            return line + " KB";
          }
          return "";
        })
      );
    }

    if (
      "disk_$$_total_size" === params.field ||
      "disk_$$_real_capacity" === params.field ||
      "imaging_$$_added_usedSpace" === params.field
    ) {

      // console.log("7370 - SIZE=", lines);
      return (
        lines.map(line => {
          if (line !== "undefined") {
            let dataTxt = '0 B';

            if (line !== 0) {
              let decimals = 2;

              const k = 1024;
              const dm = decimals < 0 ? 0 : decimals;
              const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
              const i = Math.floor(Math.log(line) / Math.log(k));
              return parseFloat((line / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            }
          }
          return "";
        })
      );
    }

    if (
      "ram_bank_$$_total_amount" === params.field ||
      "ram_bank_$$_size" === params.field
    ) {
      return (
        lines.map(line => {
          if (line !== "undefined") {
            let dataTxt = '0 B';

            if (line !== 0) {
              line = 1048576 * line;   // to get value in bytes          
              let decimals = 2;

              const k = 1024;
              const dm = decimals < 0 ? 0 : decimals;
              const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
              const i = Math.floor(Math.log(line) / Math.log(k));
              dataTxt = parseFloat((line / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
              return dataTxt;
            }
          }
          return "";
        })
      );
    }

    if (
      "ram_bank_$$_rank" === params.field
    ) {
      return (
        lines.map(line => {
          if (line !== "undefined") {

            let dataTxt = "";
            switch (line) {
              case "1":
                return "Single";
                break;

              case "2":
                return "Dual";
                break;

              case "4":
                return "Quad";
                break;

              default:
                return "Unknown";
            }
          }
          return "";
        })
      );
    }

    if (
      "battery_$$_designed_capacity" === params.field ||
      "battery_$$_full_charged_capacity" === params.field ||
      "battery_$$_current_capacity" === params.field
    ) {

      return (
        lines.map(line => {
          if (line !== "undefined") {
            return line + " mWH";
          }
          return "";
        })
      );
    }

    if (
      "battery_$$_rate" === params.field
    ) {

      return (
        lines.map(line => {
          if (line !== "undefined" && line !== "") {
            return line + " mW";
          }
          return "";
        })
      );
    }

    if (
      "battery_$$_voltage" === params.field
    ) {

      return (
        lines.map(line => {
          if (line !== "undefined") {
            return (line / 1000) + " V";
          }
          return "";
        })
      );
    }

    if (
      "battery_$$_wear_level" === params.field ||
      "battery_$$_health_level" === params.field
    ) {

      return (
        lines.map(line => {
          if (line !== "undefined" && line !== "") {
            if (parseInt(line, 10) > 100)
              return "-- %";
            else
              return line + " %";
          }
          return "";
        })
      );
    }

    if (
      // "disk_$$_computed_health" === params.field ||
      // "disk_$$_computed_perf" === params.field ||
      "disk_wipe_$$_computed_health" === params.field ||
      "disk_wipe_$$_computed_perf" === params.field ||
      "disks_wipe_$$_computed_health" === params.field ||
      "disks_wipe_$$_computed_perf" === params.field
    ) {

      return (
        lines.map(line => {
          // if (line === "")
          //   line = " ";
          if (line !== "undefined" && line !== "") {
            if (parseInt(line, 10) > 100)
              return "-- %";
            else {
              if (line === " " || line === " ")
                return line;
            else
              return line + " %";
          }
          }
          return "";
        })
      );
    }

    if (
      "disk_wipe_$$_disk_health_percentage" === params.field ||
      "disks_wipe_$$_disk_health_percentage" === params.field
    ) {

      // console.log("1016 - lines=", lines);
      return (
        lines.map(line => {
          if (line !== "undefined" && line !== "") {
            if (parseInt(line, 10) > 100)
              return "-- %";
            else {
              if (line === " " || line === " ")
                return line;
              else
                return line + " %";
            }
          }
          return "";
        })
      );
    }

    if (
      "battery_$$_health_level" === params.field
    ) {

      return (
        lines.map(line => {
          if (line !== "undefined" && line !== "") {
            if (parseInt(line, 10) > 100)
              return "-- %";
            else
              return (100 - parseInt(line, 10)) + " %";
          }
          return "";
        })
      );
    }

    if (
      "sbar_$$_activation_type" === params.field ||
      "trade_in_$$_code" === params.field
    ) {

      return (
        lines.map(line => {
          if (line !== "undefined") {
            return line.toUpperCase();
          }
          return "";
        })
      );
    }

    if (
      "deployments_$$_image_deployed_os" === params.field
    ) {
      // console.log("1069 - lines=", lines);
      return (
        lines.map(line => {
          if (line !== "undefined") {

            const regex = /(?:WINVISTA_)([0-9]+)(_?)(.*)/i;  // 
            const items = line.match(regex);

            let os_version = "Windows";
            let architecture = "32";
            let dataTxt = "";

            if (items) {
              switch (items[1]) {
                case '7':
                  os_version = "Windows 7 ";
                  break;

                case '8':
                  os_version = "Windows 8 ";
                  break;

                case '10':
                  os_version = "Windows 10 ";
                  break;

                case '11':
                  os_version = "Windows 11 ";
                  break;

                default:
                  os_version = "Windows ";
              }

              switch (items[3]) {
                default:
                case '32':
                  architecture = "32 bits";
                  break;

                case '64':
                  architecture = "64 bits";
                  break;

                case 'ARM64':
                  architecture = "ARM 64 bits";
                  break;
              }
              dataTxt = os_version + architecture;
            }
            else
              dataTxt = line;

            // const dataTxt = line.toUpperCase();
            return dataTxt;
          }
          return "";
        })
      );
    }


    if ("hexadecimal_viewer_$$_result" === params.field) {
      return (
        lines.map(line => {
          return getHexadecimalViewerStyle(line).text;
        })
      )
    }

    if ("hexadecimal_viewer_$$_disk_validated" === params.field) {
      return (
        lines.map(line => {
          const data = getDiskValidatedStyle(line);
          if (data.checked !== " ")
            return (data.checked + ' : ' + data.validated);
        })
      )
    }



    if ("locks_$$_lock_bios_admin_password" === params.field) {
      return (
        lines.map(line => {
          return getBIOSAdminPasswordLockStyle(line).text !== ' ' ? getBIOSAdminPasswordLockStyle(line).text : "";
        })
      )
    }

    if ("locks_$$_lock_bios_computrace_status" === params.field) {
      return (
        lines.map(line => {
          console.log("1157 - getBIOSComputraceStatusStyle(line)=", getBIOSComputraceStatusStyle(line));
          return getBIOSComputraceStatusStyle(line).text !== ' ' ? getBIOSComputraceStatusStyle(line).text : "";
        })
      )
    }


    if (
      "disk_$$_ppid" === params.field ||
      "disk_wipe_$$_ppid" === params.field ||
      "disks_wipe_$$_ppid" === params.field
    ) {
      // console.log("1175 - lines=", lines);
      return (
        lines.map(line => {
          if (line !== "undefined" && line !== "") {
            return line;
          }
          return "No PPID";
        })
      );
    }


    if (
      "video_card_$$_allocated_memory_size" === params.field
    ) {

      return (
        lines.map(line => {
          if (line && line !== "undefined" && line !== "0" && line !== "" && line !== "null") {
            return line + " MB";
          }
          return "";
        })
      );
    }

    if (
      "video_card_$$_memory_bus" === params.field
    ) {

      return (
        lines.map(line => {
          if (line && line !== "undefined" && line !== "0" && line !== "" && line !== "null") {
            return line + " bits";
          }
          return "";
        })
      );
    }




    // PICEASOFT :
    if (
      "locks_mobiles_$$_rooted_jailbroken" === params.field ||
      "locks_mobiles_$$_blacklisted" === params.field ||
      "locks_mobiles_$$_samsung_reactivation_lock" === params.field ||
      "locks_mobiles_$$_ios_mdm_configured" === params.field ||
      "locks_mobiles_$$_zero_touch_enrollment" === params.field
    ) {
      return (
        lines.map(line => {
          let newLine = line;
          switch (line) {
            case '1':
            case '32767':
              newLine = "No";
              break;

            case '32778':
            case '32775':
              newLine = "Yes";
              break;

            case '32777':
              newLine = "Warning";
              break;

            case '32785':
              newLine = "Failed";
              break;

            case 'null':
            case null:
              newLine = "Unknown";
              break;
          }

          return getRedYesStyle(newLine).text;
          // if (data.checked !== " ")
          //   return (data.checked + ' : ' + data.validated);
        })
      )
    }

    if (
      "locks_mobiles_$$_google_fpr_lock" === params.field ||
      "locks_mobiles_$$_find_my_iphone" === params.field
    ) {
      return (
        lines.map(line => {
          let newLine = line;
          switch (line) {
            case '1':
              newLine = "Disabled";
              break;

            case '32773':
            case '32774':
              newLine = "Enabled";
              break;

            case 'null':
            case null:
              newLine = "Unknown";
              break;
          }

          return getRedYesStyle(newLine).text;
          // if (data.checked !== " ")
          //   return (data.checked + ' : ' + data.validated);
        })
      )
    }

    if (
      "locks_mobiles_$$_sim_lock" === params.field
    ) {
      return (
        lines.map(line => {
          let newLine = line;
          switch (line) {
            case '1':
            case 1:
              newLine = "N/A";
              break;

            case '2':
            case '3':
            case '4':
            case 2:
            case 3:
            case 4:
              newLine = "Enabled";
              break;

            case '5':
            case 5:
              newLine = "Disabled";
              break;

            case '6':
            case 6:
              newLine = "SIM not ready";
              break;

            case '7':
            case 7:
              newLine = "SIM disabled";
              break;

            case '8':
            case 8:
              newLine = "SIM Error";
              break;

            case '9':
            case 9:
              newLine = "SIM Restricted";
              break;

            case '0':
            case 'null':
            case 0:
            case null:
              newLine = "Unknown";
              break;
          }

          return getSimLockStyle(newLine).text;
          // if (data.checked !== " ")
          //   return (data.checked + ' : ' + data.validated);
        })
      )
    }

    if (
      "locks_mobiles_$$_device_genuine" === params.field ||
      "locks_mobiles_$$_battery_genuine" === params.field
    ) {
      return (
        lines.map(line => {
          let newLine = line;
          switch (line) {
            case '1':
              newLine = "Yes";
              break;

            case '32782':
            case '32784':
              newLine = "No";
              break;

            case 'null':
            case null:
              newLine = "Unknown";
              break;
          }

          return getGreenYesStyle(newLine).text;
          // if (data.checked !== " ")
          //   return (data.checked + ' : ' + data.validated);
        })
      )
    }


    if (
      "general_mobiles_$$_grade" === params.field 
    ) {
      return (
        lines.map(line => {
          let newLine = line;
          switch (line) {
            case '1':
              newLine = "Lowest";
              break;

            case '1':
              newLine = "C -";
              break;

            case '2':
              newLine = "C +";
              break;

            case '3':
              newLine = "B -";
              break;

            case '4':
              newLine = "B +";
              break;

            case '5':
              newLine = "A -";
              break;

            case '6':
              newLine = "A +";
              break;

            case 'null':
            case null:
              newLine = "Undefined";
              break;
          }
          return newLine;
        })
      )
    }

    if (      
      "hardware_battery_mobiles_$$_grade" === params.field
    ) {
      return (
        lines.map(line => {
          let newLine = line;
          switch (line) {
            case '1':
              newLine = "D -";
              break;

            case '2':
              newLine = "D";
              break;

            case '3':
              newLine = "D +";
              break;

            case '4':
              newLine = "C -";
              break;

            case '5':
              newLine = "C";
              break;

            case '6':
              newLine = "C +";
              break;

            case '7':
              newLine = "B -";
              break;

            case '8':
              newLine = "B";
              break;

            case '9':
              newLine = "B +";
              break;

            case '10':
              newLine = "A -";
              break;

            case '11':
              newLine = "A";
              break;

            case '12':
              newLine = "A +";
              break;

            case '0':
            case 'null':
            case null:
              newLine = "Undefined";
              break;
          }
          return newLine;
        })
      )
    }

    if (
      "operations_mobiles_$$_wipe" === params.field 
    ) {
      return (
        lines.map(line => {
          let newLine = line;
          switch (line) {
            case '1':
            case 1:
              newLine = "Success";
              break;

            case '2':
            case 2:
              newLine = "Failure";
              break;

            case '3':
            case 3:
              newLine = "Success but nothing was done";
              break;

            case '4':
            case 4:
              newLine = "Skipped";
              break;

            case '5':
            case 5:
              newLine = "Cancelled";
              break;
          }

          // console.log("1198 - newLine=", newLine);
          // console.log("1199 - getMCEWipeResultStyle(newLine)=", getMCEWipeResultStyle(newLine));
          return getMCEWipeResultStyle(newLine).text;
          // if (data.checked !== " ")
          //   return (data.checked + ' : ' + data.validated);
        })
      )
    }

    if (
      "general_mobiles_$$_overall_result" === params.field
    ) {
      return (
        lines.map(line => {

          return getResultStyle(line).text;
          // if (data.checked !== " ")
          //   return (data.checked + ' : ' + data.validated);
        })
      )
    }


    if (
      "bootimage_$$_secure_boot" === params.field ||
      "bootimage_$$_t2_security" === params.field
    ) {

      return (
        lines.map(line => {
          const [result, extra] = line.split('_$$_');
          const data = getBootImageSecureResultStyle(result);

          return data.text + (extra !== undefined ? "(" + extra + ")" : "");
        })
      )
    }

    if (
      "network_card_$$_protocol_version" === params.field
    ) {

      return (
        lines.map(line => {
          const [result, extra] = line.split('_$$_');
          const text = getWifiVersionText(result);
          return text;
        })
      )
    }


    return (
      lines.map((line, index) => {
        if (
          line !== "undefined" &&
          line !== "null"
        ) {
          if (line === "")
            line = " ";
          return (line)
        }
        else
          return ("")
      })
    )
  };

  const fixAndParse = (inText) => {
    let fixed = inText;

    fixed = fixed.replace(/\n/g, ' ');
    fixed = fixed.replace(/\r/g, ' ');

    fixed = fixed.replace(/[^\x20-\x7F]/g, x => "\\u" + ("000" + x.codePointAt(0).toString(16)).slice(-4));

    fixed = fixed.replace(/\\/g, '\\\\');
    fixed = fixed.replace(/\n/g, ' ');
    fixed = fixed.replace(/\r/g, ' ');
    fixed = fixed.replace(/\t/g, '   ');
    fixed = fixed.replace(/&lt;/g, '<');
    fixed = fixed.replace(/&gt;/g, '>');
    fixed = fixed.replace(/&amp;/g, '&');

    try {
      let jsonFixed = JSON.parse(fixed);

      for (const key of Object.keys(jsonFixed)) {

        if (typeof jsonFixed[key] === 'string') {
        jsonFixed[key] = jsonFixed[key].replace(/&quot;/g, '\"');
        jsonFixed[key] = jsonFixed[key].replace(/&apos;/g, '\'');

        var r = /\\u([\d\w]{4})/gi;
        jsonFixed[key] = jsonFixed[key].replace(r, function (match, grp) {
          return String.fromCharCode(parseInt(grp, 16));
        });
      }

      }
      return jsonFixed;
    }
    catch (e) {
      console.log("779 - Error=", e);
      console.log("780 - inText=", inText);
      console.log("781 - fixed=", fixed);
    }
    return {};
  }

  const getDiskBus = (InText) => {
    if (parseInt(InText) >= 0 && parseInt(InText) <= 17) {
      const tableDiskBus = ["UNKNOWN", "SCSI", "ATAPI", "ATA", "1394", "SSA", "Fibre Channel", "USB", "RAID", "iSCSI", "SAS", "SATA", "SD", "MMC", "Virtual", "File Backed Virtual", "Storage Spaces", "NVMe"];
      return tableDiskBus.at(parseInt(InText));
    }
    return "";
  };

  const getDiskHealth = (InText) => {
    // const tableDiskHealth = ["UNKNOWN", "GOOD", "BAD", "WARNING"];
    switch (InText) {
      default:
        return {
          text: " ",
          color: "black"
        }

      case "-1":
        return {
          text: "UNKNOWN",
          color: "grey"
        }
        break;

      case "1":
        return {
          text: "GOOD",
          color: "green"
        }
        break;

      case "2":
        return {
          text: "BAD",
          color: "red"
        }
        break;

      case "3":
        return {
          text: "WARNING",
          color: "orange"
        }
        break;
    }
  };


  const getBatteryPowerState = (InText) => {
    switch (InText) {
      default:
        return {
          text: " ",
          color: "black"
        }
        break;

      case "1":
        return {
          text: "POWER_ON_LINE NOT_CHARGING",
          color: "orange"
        }
        break;

      case "2":
        return {
          text: "DISCHARGING",
          color: "green"
        }
        break;

      case "3":
        return {
          text: "POWER_ON_LINE & DISCHARGING",
          color: "orange"
        }
        break;

      case "4":
        return {
          text: "CHARGING WHEREAS NOT POWER_ON_LINE",
          color: "red"
        }
        break;

      case "5":
        return {
          text: "POWER_ON_LINE & CHARGING",
          color: "green"
        }
        break;

      case "6":
        return {
          text: "CHARGING & DISCHARGING",
          color: "red"
        }
        break;

      case "7":
        return {
          text: "POWER_ON_LINE & CHARGING & DISCHARGING",
          color: "red"
        }
        break;

      case "8":
        return {
          text: "NOT POWER_ON_LINE & NOT DISCHARGING, LOW_CHARGE",
          color: "red"
        }
        break;

      case "9":
        return {
          text: "POWER_ON_LINE & NOT_CHARGING, LOW_CHARGE",
          color: "orange"
        }
        break;

      case "10":
        return {
          text: "DISCHARGING, LOW_CHARGE",
          color: "green"
        }
        break;

      case "11":
        return {
          text: "POWER_ON_LINE & DISCHARGING, LOW_CHARGE",
          color: "orange"
        }
        break;

      case "12":
        return {
          text: "CHARGING WHEREAS NOT POWER_ON_LINE, LOW_CHARGE",
          color: "red"
        }
        break;

      case "13":
        return {
          text: "POWER_ON_LINE & CHARGING, LOW_CHARGE",
          color: "green"
        }
        break;

      case "14":
        return {
          text: "CHARGING & DISCHARGING, LOW_CHARGE",
          color: "red"
        }
        break;

      case "15":
        return {
          text: "POWER_ON_LINE & CHARGING & DISCHARGING, LOW_CHARGE",
          color: "red"
        }
        break;
    }
  };


  /*
  [SDS DASHBOARD][REPORTING] Uniformize values
      "OK", "PASSED" should be uniformized to "PASSED"
      "FAIL", "FAILED", "FAILURE", "KO" should be uniformized to "FAILED"
  */
  const getResultStyle = (InText) => {
    switch (InText.toUpperCase()) {
      default:
        return {
          text: "", //(InText !== "null" && InText !== "NULL" && InText !== "undefined" ? InText : ""),
          // text: InText,
          color: "black"
        }
        break;

      case "OK":
        return {
          text: "PASSED",
          ico: "check",
          color: "green"
        }
        break;

      case "KO":
      case "FAIL":
      case "FAILED":
      case "FAILURE":
        return {
          text: "FAILED",
          ico: "close",
          color: "red"
        }
        break;

      case "WARNING":
      case "CANCEL":
      case "CANCELED":
      case "ABORTED":
      case "SKIPPED":  // ??
      case "INTERRUPTED":
        return {
          text: InText,
          ico: "close",
          color: "orange"
        }
        break;

      case "REMOVED":
        return {
          text: "WARNING - REMOVED",
          ico: "close",
          color: "orange"
        }
        break;

      case "ONGOING":
        return {
          text: "ONGOING",
          ico: "not_interested",
          color: "grey"
        }
        break;
    }
  };

  /*
  14:13:16.358 8616 - lines= disk_wipe_$$_result 
Array [ "SMART THRESHOLD EXCEEDED (197)", "SMART THRESHOLD EXCEEDED (197)" ]​
0: "SMART THRESHOLD EXCEEDED (197)"​
1: "SMART THRESHOLD EXCEEDED (197)"
  */
  const getSmartThresholdExceededResultStyle = (InText) => {

    if (InText.toUpperCase().substring(0, 26) === "SMART THRESHOLD EXCEEDED (") {
      const smartCodes = InText.toUpperCase().substring(26, InText.length - 1).split(',');
      let newText = t('reporting.data.smart_threshold_exceeded') + ' (';

      let smartCodesText = "";
      smartCodes.forEach(o => {
        if (smartCodesText !== "")
          smartCodesText = smartCodesText + ", ";
        smartCodesText = smartCodesText + t('reporting.data.smart_code_' + parseInt(o));
      });

      newText = 'FAILED - ' + newText + smartCodesText + ')';
      return {
        text: newText,
        ico: "close",
        color: "red"
      };

    }
    else
      return getResultStyle(InText);
  };



  const getDiagnosticResultStyle = (InText) => {
    switch (InText.toUpperCase()) {
      default:
        return {
          text: " ", // InText,
          color: "black"
        }
        break;

      case 0:
      case "0":
        return {
          text: "PASSED",
          ico: "check",
          color: "green"
        }
        break;

      case 1:
      case "1":
        return {
          text: "FAILED",
          ico: "close",
          color: "red"
        }
        break;

      case 2:
      case "2":
        return {
          text: "SKIPPED",
          ico: "close",
          color: "orange"
        }
        break;
    }
  };

  const getDiskHpaAndDco = (InText) => {
    switch (InText) {
      default:
        return {
          text: " ",
          color: "lightgrey",
          ico: "",
          alternateText: " ",
          alternateTextForPDF: " "
        }
        break;

      case "-1":
        return {
          text: " ",
          color: "lightgrey",
          ico: "question_mark",
          alternateText: "?",
          alternateTextForPDF: "?"
        }
        break;

      case "0":
        return {
          text: " ",
          color: "black",
          ico: "check",
          alternateText: "✔",
          alternateTextForPDF: "1"
        }
        break;

      case "1":
        return {
          text: " ",
          color: "black",
          ico: "close",
          alternateText: "✘",
          alternateTextForPDF: "0"
        }
        break;
    }
  };


  const getRPMStyle = (InText) => {
    const value = parseInt(InText);
    if (value === 0)
      return {
        text: "?",
        color: "black",
        ico: ""
      };

    if (value === 1)
      return {
        text: "N/A",
        color: "black",
        ico: ""
      };

    if (value >= 2 && value <= 1024)
      return {
        text: "?",
        color: "black",
        ico: ""
      };

    if (value >= 1025 && value <= 65534)
      return {
        text: InText + " RPM",
        color: "black",
        ico: ""
      };

    if (value === 65535)
      return {
        text: '?',
        color: "black",
        ico: ""
      };

    return {
      text: "?",
      color: "black",
      ico: ""
    };
  };


  const getBooleanStyle = (InText) => {
    switch (InText) {
      default:
        return {
          text: " ",
          color: "lightgrey",
          ico: "",
          alternateText: "",
          alternateTextForPDF: ""
        }
        break;

      case 'true':
        return {
          text: " ",
          color: "black",
          ico: "check",
          alternateText: "✔",
          alternateTextForPDF: "1"
        }
        break;

      case 'false':
        return {
          text: " ",
          color: "lightgrey",
          ico: "close",
          alternateText: "✗",
          alternateTextForPDF: "0"
        }
        break;
    }
  };


  const getSbarActivationResultStyle = (InText) => {
    switch (InText) {
      default:
        return {
          text: " ",
          color: "lightgrey",
          ico: ""
        }
        break;

      case '0x90001000':  // SBAR_NOT_FOUND
        return {
          text: "FAILED (Re-activation missing)",
          ico: "close",
          color: "red"
        }
        break;

      case '0x90001001':  // SBAR_ACTIVATION_UNKNOWN	
        return {
          text: "FAILED",
          ico: "close",
          color: "red"
        }
        break;

      case '0x90001002':  // SBAR_REACTIVATION_UNKNOWN
        return {
          text: "FAILED (Re-activation unknown)",
          ico: "close",
          color: "red"
        }
        break;

      case '0x90002000':  // SBAR_ALREADY_ACTIVATED_BASIC	
      case '0x90002001':  // SBAR_ALREADY_ACTIVATED_BASIC	
      case '0x90002002':  // SBAR_ALREADY_ACTIVATED_BASIC	
        return {
          text: "PASSED (Already activated)",
          ico: "check",
          color: "green"
        }
        break;

      case '0x90003000':  // SBAR_ACTIVATED_BASIC	
      case '0x90003001':  // SBAR_ACTIVATED_PREMIUM	
      case '0x90003002':  // SBAR_ACTIVATED_ENTERPRISE
        return {
          text: "PASSED",
          ico: "check",
          color: "green"
        }
        break;

      case '0x90004000':  // SBAR_REACTIVATED_BASIC	
      case '0x90004001':  // SBAR_REACTIVATED_PREMIUM
      case '0x90004002':  // SBAR_REACTIVATED_ENTERPRISE
        return {
          text: "PASSED (Re-activated)",
          ico: "check",
          color: "green"
        }
        break;
    }
  };


  const getMCETestsStyle = (InText) => {
    // console.log("1516 - InText=", InText);
    switch (InText.toUpperCase()) {
      default:
        return {
          text: " ",
          color: "lightgrey",
          ico: ""
        }
        break;

      // MCE
      case 'PASS':
      case 'PASSED':
        return {
          text: "PASSED",
          ico: "check",
          color: "green"
        }
        break;

      case 'CANCELLED':
      case 'SKIPPED':
      case 'WARNING':
      case 'USER HAS SKIPPED THE TEST CASE':
        return {
          text: InText.toUpperCase(),
          ico: "close",
          color: "orange"
        }
        break;

      case 'ABORTED':
      case 'FAILURE':
        return {
          text: InText.toUpperCase(),
          ico: "close",
          color: "red"
        }
        break;


      // PICEASOFT
      case '1':
        return {
          text: t(`piceasoft_test_case_status.${InText}`).toUpperCase(),
          ico: "check",
          color: "green"
        }
        break;

      case '2':
        return {
          text: t(`piceasoft_test_case_status.${InText}`).toUpperCase(),
          ico: "close",
          color: "red"
        }
        break;

      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8':
      case '9':
        return {
          text: t(`piceasoft_test_case_status.${InText}`).toUpperCase(),
          ico: "close",
          color: "orange"
        }
        break;

    }
  };


  const getMCEWipeResultStyle = (InText) => {
    // console.log("1516 - InText=", InText);
    switch (InText.toUpperCase()) {
      default:
        return {
          text: "UNKNOWN",
          color: "lightgrey",
          ico: ""
        }
        break;

      // PICEASOFT
      case 'SUCCESS':
        return {
          text: "SUCCESS",
          ico: "check",
          color: "green"
        }
        break;

      case 'FAILURE':
        return {
          text: "FAILURE",
          ico: "close",
          color: "red"
        }
        break;

      case 'SUCCESS BUT NOTHING WAS DONE':
        return {
          text: "SUCCESS (but nothing was done)",
          ico: "check",
          color: "green"
        }
        break;

      case 'SKIPPED':
        return {
          text: "SKIPPED",
          ico: "close",
          color: "orange"
        }
        break;

      case 'CANCELLED':
        return {
          text: "CANCELLED",
          ico: "close",
          color: "orange"
        }
        break;
    }
  };



  const getHexadecimalViewerStyle = (InText) => {

    if (InText === "null") {
      return {
        text: " ",
        color: "lightgrey",
        ico: ""
      }
    }
    switch (InText.toUpperCase()) {
      default:
        return {
          text: "UNKNOWN",
          ico: "close",
          color: "orange"
        }
        break;

      case 0:
      case "0":
        return {
          text: "PASSED",
          ico: "check",
          color: "green"
        }
        break;

      case 1:
      case "1":
        return {
          text: "CANCELLED",
          ico: "close",
          color: "orange"
        }
        break;

      case 2:
      case "2":
      case 3:
      case "3":
        return {
          text: "FAILED",
          ico: "close",
          color: "red"
        }
        break;
    }
  };



  const getDiskValidatedStyle = (InText) => {

    if (InText === "undefined") {
      return {
        checked: " ",
        text: " ",
        color: "lightgrey"
      }
    }
    const checked = InText.substring(0, InText.length - 4);
    const validatedValue = InText.substring(InText.length - 1, InText.length);

    switch (validatedValue) {
      default:
        return {
          checked: checked,
          text: " ",
          color: "lightgrey",
        }
        break;

      case "UNKNOWN":
        return {
          checked: checked,
          validated: "UNKNOWN",
          color: "red"
        }
        break;

      case 0:
      case "0":
        return {
          checked: checked,
          validated: "FAILED",
          color: "red"
        }
        break;

      case 1:
      case "1":
        return {
          checked: checked,
          validated: "PASSED",
          color: "green"
        }
        break;
    }
  };


  const getRedYesStyle = (InText) => {
    if (InText === "null") {
      return {
        text: " ",
        color: "lightgrey",
        ico: ""
      }
    }
    switch (InText.toUpperCase()) {
      default:
        return {
          text: " ",
          color: "lightgrey",
          ico: ""
        }
        break;

      case "YES":
        return {
          text: "YES",
          ico: "close",
          color: "red"
        }
        break;

      case "NO":
        return {
          text: "NO",
          ico: "check",
          color: "green"
        }
        break;

      case "ENABLED":
        return {
          text: "ENABLED",
          ico: "close",
          color: "red"
        }
        break;

      case "DISABLED":
        return {
          text: "DISABLED",
          ico: "check",
          color: "green"
        }
        break;

      case "WARNING":
        return {
          text: "WARNING",
          ico: "close",
          color: "orange"
        }
        break;

      case "FAILED":
        return {
          text: "FAILED",
          ico: "close",
          color: "orange"
        }
        break;
    }
  };


  const getGreenYesStyle = (InText) => {
    if (InText === "null") {
      return {
        text: " ",
        color: "lightgrey",
        ico: ""
      }
    }
    switch (InText.toUpperCase()) {
      default:
        return {
          text: " ",
          color: "lightgrey",
          ico: ""
        }
        break;

      case "YES":
        return {
          text: "YES",
          ico: "check",
          color: "green"
        }
        break;

      case "NO":
        return {
          text: "NO",
          ico: "close",
          color: "red"
        }
        break;
    }
  };



  const getSimLockStyle = (InText) => {
    if (InText === "undefined") {
      return {
        text: " ",
        color: "lightgrey",
        ico: ""
      }
    }
    switch (InText.toUpperCase()) {
      default:
        return {
          text: " ",
          color: "lightgrey",
          ico: ""
        }
        break;

      case "NULL":
        return {
          text: "NULL",
          color: "orange"
        }
        break;

      case "N/A":
        return {
          text: "N/A",
          color: "orange"
        }
        break;

      case "ENABLED":
        return {
          text: "ENABLED",
          ico: "close",
          color: "red"
        }
        break;

      case "DISABLED":
        return {
          text: "DISABLED",
          ico: "check",
          color: "green"
        }
        break;

      case "SIM NOT READY":
        return {
          text: "SIM NOT READY",
          ico: "close",
          color: "orange"
        }
        break;

      case "SIM DISABLED":
        return {
          text: "SIM DISABLED",
          ico: "close",
          color: "orange"
        }
        break;

      case "SIM ERROR":
        return {
          text: "SIM ERROR",
          ico: "close",
          color: "orange"
        }
        break;

      case "SIM RESTRICTED":
        return {
          text: "SIM RESTRICTED",
          ico: "close",
          color: "orange"
        }
        break;
    }
  };


  const getBIOSAdminPasswordLockStyle = (InText) => {
    if (InText === "undefined" || InText == "null") {
      return {
        text: " ",
        color: "lightgrey",
        ico: ""
      }
    }
    switch (InText.toUpperCase()) {
      default:
        return {
          text: "Unknown",
          color: "black",
          ico: ""
        }
        break;

      case 0:
      case "0":
        return {
          text: "Not usable",
          color: "black"
        }
        break;

      case 1:
      case "1":
        return {
          text: "Password required",
          color: "black"
        }
        break;

      case 2:
      case "2":
        return {
          text: "No password",
          color: "black"
        }
        break;
    }
  };

  const getBIOSComputraceStatusStyle = (InText) => {
    if (InText === "undefined" || InText == "null") {
      return {
        text: " ",
        color: "lightgrey",
        ico: ""
      }
    }

    switch (InText.toUpperCase()) {
      default:
        return {
          text: "Unknown",
          color: "black",
          ico: ""
        }
        break;

      case 0:
      case "0":
        return {
          text: "Disabled",
          color: "black"
        }
        break;

      case 1:
      case "1":
        return {
          text: "Activated",
          color: "black"
        }
        break;

      case 2:
      case "2":
        return {
          text: "Not detected",
          color: "black"
        }
        break;
    }
  };


  const getPPIDStyle = (InText) => {
    switch (InText.toUpperCase()) {
      case "":
      case "NULL":
      case "UNDEFINED":
      case "NO PPID":
        return {
          text: "No PPID",
          color: "grey"
        }
        break;

      default:
        return {
          text: InText,
          color: "black"
        }
        break;
    }
  };



  const getBootImageSecureResultStyle = (InText) => {
    switch (InText.toUpperCase()) {
      default:
        return {
          text: "N/A", // InText,
          color: "black"
        }
        break;

      case 0:
      case "0":
        return {
          text: "No",
          color: "black"
        }
        break;

      case 1:
      case "1":
        return {
          text: "Yes",
          color: "black"
        }
        break;

      case "NULL":
      case "UNDEFINED":
        return {
          text: " ",
          color: "black"
        }
        break;
    }
  };



  const getWifiVersionText = (InText) => {
    /*
            0	unknown
            1	deprecated
            2	deprecated
            3	infrared
            4	Wi-Fi 2 (802.11a)
            5	Wi-Fi 1 (802.11)
            6	Wi-Fi 3 (802.11g)
            7	Wi-Fi 4 (802.11n)
            8	Wi-Fi 5 (802.11ac)
            9	WiGig (802.11ad)
            10	Wi-Fi 6/6E (802.11ax)
            11	Wi-Fi 7 (802.11be)
    */
    switch (InText) {
      case "0": {
        return "unknown";
      }

      case "1":
      case "2": {
        return "deprecated";
      }

      case "3": {
        return "infrared";
      }

      case "4": {
        return "Wi-Fi 2 (802.11a)";
      }

      case "5": {
        return "Wi-Fi 1 (802.11)";
      }

      case "6": {
        return "Wi-Fi 3 (802.11g)";
      }

      case "7": {
        return "Wi-Fi 4 (802.11n)";
      }

      case "8": {
        return "Wi-Fi 5 (802.11ac)";
      }

      case "9": {
        return "WiGig (802.11ad)";
      }

      case "10": {
        return "Wi-Fi 6/6E (802.11ax)";
      }

      case "11": {
        return "Wi-Fi 7 (802.11be)";
      }
    }
    return ""; //" ";
  };

  // const rowsToPrint = () => {
  //   console.log("262 - model=", model);
  //   const filtered = model.filtered ?? deployments;

  //   // .slice() creates a new array
  //   const rows = filtered.slice().filter(dep => (
  //     model.selected.length > 0 ? model.selected.includes(dep.id) : dep.id > 0
  //   ));

  //   return rows;
  // };

  const processDownloads = async (arrayTmp) => {

    if (arrayTmp && arrayTmp.result) {

    for (const result of arrayTmp.result) {

        // console.log("2192 - download ", result.filename);

      let str = result.data.data;
      var byteArray = new Uint8Array(str.length);
      for (var x = 0; x < byteArray.length; x++) {
        byteArray[x] = str[x];
      }
      var data = new Blob([byteArray]); //, {type: "application/octet-stream"});
      var url = window.URL.createObjectURL(data);

      var link = document.createElement('a');
      // link.type = "data:application/pdf"
      link.type = "data:application/octet-stream"
      link.download = result.filename;
      link.target = "_blank"
      link.href = url;

      // console.log("536 - link=", link);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

        window.URL.revokeObjectURL(url);
    }
    // console.log("1266 - Done :", arrayTmp);
  }
      }


  const processColumns = (newNewRows) => {
    // console.log("2781 - processColumns...", newNewRows);

    let mapRowSize = new Map();
    let reportingColumnsCopy = [];

    const localFilteredRows = [];

    setActiveSortModel([]);

    // ADD GROUP AND LOCATION COLUMNS IF ADMIN -------------------------------------
    if (user.roleId <= roles.stAdmin) {

      const foundGroup = withExtraColumns.find((element) => {
        return element.field === "general_$$_group";
      });

      const foundLocation = withExtraColumns.find((element) => {
        return element.field === "general_$$_location";
      });

    const newColum1 = {
        field: 'general_$$_group',
      headerName: t('reporting.columns.general.group'),
      print: false,
        type: 'string',
        width: foundGroup ? foundGroup.width : 200,
        resizable: true,
        disableReorder: true,
        extraColumn: true
    }
    // console.log("4007 - newColum=", newColum);
    reportingColumnsCopy.push(newColum1);


    const newColum2 = {
        field: 'general_$$_location',
      headerName: t('reporting.columns.general.location'),
      print: false,
        type: 'string',
        width: foundLocation ? foundLocation.width : 200,
        resizable: true,
        disableReorder: true,
        extraColumn: true
    }
    // console.log("4007 - newColum=", newColum);
    reportingColumnsCopy.push(newColum2);
  }
  else /*if (user.roleId === roles.admin)*/ {

      const foundLocation = withExtraColumns.find((element) => {
        return element.field === "general_$$_location";
      });

    const newColum = {
        field: 'general_$$_location',
      headerName: t('reporting.columns.general.location'),
      print: false,
        type: 'string',
        width: foundLocation ? foundLocation.width : 200,
        resizable: true,
        disableReorder: true,
        extraColumn: true
    }
    // console.log("4007 - newColum=", newColum);
    reportingColumnsCopy.push(newColum);
  }

  Array.prototype.push.apply(reportingColumnsCopy, reportingColumns);
    // console.log("1591 - reportingColumnsCopy=", reportingColumnsCopy);


    // ADD OTHERS/QUESTIONS/... EXTRA COLUMNS -------------------------------------
  let reportingColumnsExtra101_Others = [];
  let reportingColumnsExtra145_Others = [];
  let reportingColumnsExtraTestsMobiles = [];
  let reportingColumnsExtraManualInputsMobiles = [];
  let reportingColumnsExtraOthersMobiles = [];
    let reportingColumnsExtraSmartAttributes = [];
    // let reportingColumnsExtraDiagComments = [];

  let deploymentsIndex = -1;
    const tmpDeployments = newNewRows ? newNewRows : deployments;

    // console.log("2864 - tmpDeployments=", tmpDeployments);
    for (const deployment of tmpDeployments) {

    deploymentsIndex++;

      // if (showColumnsMenu)
      //   continue;

      const sdsQuestions101List = deployment.sdsquestions101_data && deployment.sdsquestions101_data.split("<sds_questions>");
      const sdsQuestions145List = deployment.sdsquestions145_data && deployment.sdsquestions145_data.split("<sds_questions>");
      // const sdsScriptsList = deployment.sdsScripts_data && deployment.sdsScripts_data.split("<sds_scripts>");
      // const sdsBootImgList = deployment.sdsBootImg_data && deployment.sdsBootImg_data.split("<sds_bootimg>");
      // console.log("2228 - sdsBootImgList=", sdsBootImgList);

      // console.log("2369 - reportingColumnsCopy=", reportingColumnsCopy);
      const sdsDiskWipeSmartAttributesList = deployment.disk_wipe_smartAttibutes_data && deployment.disk_wipe_smartAttibutes_data.split("<smart>");
      // console.log("2369 - sdsDiskWipeSmartAttributesList=", sdsDiskWipeSmartAttributesList);

    const sdsMobilesList = getSdsMobilesList(deployment);

    let row = {};
    for (const column of reportingColumnsCopy) {

      row.key = deploymentsIndex;
        row.id = localFilteredRows.length + 1;
      if (column.field === "welcome_screen_$$_other_manual_inputs" && sdsQuestions101List) {

        sdsQuestions101List.forEach(input => {

            if (input.module_id) {
          const inputsData = fixAndParse(input);
          if (inputsData.xtra_id === "null") {
              const foundOtherManualInputs = withExtraColumns.find((element) => {
                return element.field === ("welcome_screen_$$_other_manual_inputs_$$_" + inputsData.xtra_desc);
              });

          const extraColumn = {
                width: foundOtherManualInputs ? foundOtherManualInputs.width : 250,
            print: false,
                  field: 'welcome_screen_$$_other_manual_inputs_$$_' + inputsData.xtra_desc,
              // headerName: "1068 - Manual inputs – Welcome screen – " + inputsData.xtra_desc,
              // t(`reporting.columns.manual_input.sds_questions`) + " #" + question.xtra_id + " : " + question.xtra_desc;
              // headerName: t('reporting.columns.manual_input.sub_title') + ' \u2013 ' + t('reporting.columns.welcome_screen.sub_title') + ' \u2013 1066 ' + inputsData.xtra_desc,
            customHeaderName: false,
            parentTitle: null,
                  type: 'string',
                resizable: true,
                disableReorder: true,
                extraColumn: true
          }

            const alreadyIn = reportingColumnsExtra101_Others.find((element) => {
            return element.field === extraColumn.field;
          });

          if (!alreadyIn)
              reportingColumnsExtra101_Others.push(extraColumn);
          }
          else {
            // console.log("1081 - inputsData=", inputsData);
          }
            }
        });
      }


      if (column.field === "questions_form_$$_other_questions" && sdsQuestions145List) {

        sdsQuestions145List.forEach(input => {
            if (input.module_id) {
          const inputsData = fixAndParse(input);

          // console.log("==> 1100 - inputsData=", inputsData);
          if (inputsData.xtra_id === "null") {

            // console.log("1103 - inputsData=", inputsData);
              const foundOtherQuestions = withExtraColumns.find((element) => {
                return element.field === ("questions_form_$$_other_questions_$$_" + inputsData.xtra_desc);
              });

        const extraColumn = {
                width: foundOtherQuestions ? foundOtherQuestions.width : 250,
          print: false,
              field: "questions_form_$$_other_questions_$$_" + inputsData.xtra_desc,
              // headerName: "1068 - Manual inputs – Welcome screen – " + inputsData.xtra_desc,
              // t(`reporting.columns.manual_input.sds_questions`) + " #" + question.xtra_id + " : " + question.xtra_desc;
              // headerName: t('reporting.columns.manual_input.sub_title') + ' \u2013 ' + t('reporting.columns.welcome_screen.sub_title') + ' \u2013 1066 ' + inputsData.xtra_desc,
          customHeaderName: false,
          parentTitle: null,
          type: "string",
                resizable: true,
                disableReorder: true,
                extraColumn: true
        }

            const alreadyIn = reportingColumnsExtra145_Others.find((element) => {
          return element.field === extraColumn.field;
        });

        if (!alreadyIn)
              reportingColumnsExtra145_Others.push(extraColumn);
          }
          else {
            // console.log("1081 - inputsData=", inputsData);
          }
            }
        });
      }


      if (column.field === "tests_mobiles_$$_tests_mobiles") {
        if (sdsMobilesList.tests) {

          sdsMobilesList.tests.forEach(input => {
            const inputsData = fixAndParse(input);

              const foundTestsMobile = withExtraColumns.find((element) => {
                return element.field === ("tests_mobiles_$$_tests_mobiles_$$_" + inputsData.xtra_desc);
              });

            const extraColumn = {
                width: foundTestsMobile ? foundTestsMobile.width : 250,
              print: false,
              field: "tests_mobiles_$$_tests_mobiles_$$_" + inputsData.xtra_desc,
              headerName: "Tests mobiles – " + inputsData.xtra_desc,
              customHeaderName: false,
              parentTitle: null,
              type: "string",
                resizable: true,
                disableReorder: true,
                extraColumn: true
            }

            const alreadyIn = reportingColumnsExtraTestsMobiles.find((element) => {
              return element.field === extraColumn.field;
            });

            if (!alreadyIn)
              reportingColumnsExtraTestsMobiles.push(extraColumn);

          });
        }
      }


      if (column.field === "manual_inputs_mobiles_$$_manual_inputs_mobiles") {
        if (sdsMobilesList.manualInputs) {

            // console.log("1559 - sdsMobilesList.manualInputs=", sdsMobilesList.manualInputs);

          sdsMobilesList.manualInputs.forEach(input => {
            const inputsData = fixAndParse(input);

              const foundInputsMobile = withExtraColumns.find((element) => {
                return element.field === ("manual_inputs_mobiles_$$_manual_inputs_mobiles_$$_" + inputsData.xtra_desc);
              });

            const extraColumn = {
                width: foundInputsMobile ? foundInputsMobile.width : 250,
              print: false,
              field: "manual_inputs_mobiles_$$_manual_inputs_mobiles_$$_" + inputsData.xtra_desc,
              headerName: "Manual inputs for mobiles – " + inputsData.xtra_desc,
              customHeaderName: false,
              parentTitle: null,
              type: "string",
                resizable: true,
                disableReorder: true,
                extraColumn: true
            }

            const alreadyIn = reportingColumnsExtraManualInputsMobiles.find((element) => {
              return element.field === extraColumn.field;
            });

            if (!alreadyIn)
              reportingColumnsExtraManualInputsMobiles.push(extraColumn);

          });
        }
      }


        if (column.field === "disks_wipe_$$_smart_attributes" && deployment.smartAttibutesData) {
          deployment.smartAttibutesData.forEach(attrib => {

            // console.log("2538 - attrib=", attrib);

            const foundSmartAttributes = withExtraColumns.find((element) => {
              return element.field === ("disks_wipe_$$_smart_attributes_$$_" + attrib.smartAttribute);
            });

            const extraColumn = {
              width: foundSmartAttributes ? foundSmartAttributes.width : 250,
              print: false,
              field: "disks_wipe_$$_smart_attributes_$$_normalized_" + attrib.smartAttribute,
              customHeaderName: false,
              parentTitle: null,
              type: "number",
              resizable: true,
              disableReorder: true,
              extraColumn: true,
              attibuteValue: attrib.smartAttribute,
              align: "right"
            }

            const alreadyIn = reportingColumnsExtraSmartAttributes.find((element) => {
              return element.field === extraColumn.field;
            });

            if (!alreadyIn)
              reportingColumnsExtraSmartAttributes.push(extraColumn);



            const extraColumn2 = {
              width: foundSmartAttributes ? foundSmartAttributes.width : 250,
              print: false,
              field: "disks_wipe_$$_smart_attributes_$$_raw_" + attrib.smartAttribute,
              customHeaderName: false,
              parentTitle: null,
              type: "number",
              resizable: true,
              disableReorder: true,
              extraColumn: true,
              attibuteValue: attrib.smartAttribute,
              align: "right"
            }

            const alreadyIn2 = reportingColumnsExtraSmartAttributes.find((element) => {
              return element.field === extraColumn2.field;
            });

            if (!alreadyIn2)
              reportingColumnsExtraSmartAttributes.push(extraColumn2);
          });
        }


        if (column.field === "disk_wipe_$$_smart_attributes" && sdsDiskWipeSmartAttributesList) {

          // console.log("2597 - sdsDiskWipeSmartAttributesList=", sdsDiskWipeSmartAttributesList);

          sdsDiskWipeSmartAttributesList.forEach(line => {

            let attrib = {};
            try {
              attrib = JSON.parse(line);
            }
            catch (e) {
              attrib = {};
            }
            // console.log("2538 - attrib=", attrib);

            const foundSmartAttributes = withExtraColumns.find((element) => {
              return element.field === ("disk_wipe_$$_smart_attributes_$$_" + attrib.smartAttribute);
            });

            const extraColumn = {
              width: foundSmartAttributes ? foundSmartAttributes.width : 250,
              print: false,
              field: "disk_wipe_$$_smart_attributes_$$_normalized_" + attrib.smartAttribute,
              customHeaderName: false,
              parentTitle: null,
              type: "number",
              resizable: true,
              disableReorder: true,
              extraColumn: true,
              attibuteValue: attrib.smartAttribute,
              align: "right"
            }
            const alreadyIn = reportingColumnsExtraSmartAttributes.find((element) => {
              return element.field === extraColumn.field;
            });
            if (!alreadyIn)
              reportingColumnsExtraSmartAttributes.push(extraColumn);

            const extraColumn2 = {
              width: foundSmartAttributes ? foundSmartAttributes.width : 250,
              print: false,
              field: "disk_wipe_$$_smart_attributes_$$_raw_" + attrib.smartAttribute,
              customHeaderName: false,
              parentTitle: null,
              type: "number",
              resizable: true,
              disableReorder: true,
              extraColumn: true,
              attibuteValue: attrib.smartAttribute,
              align: "right"
            }
            const alreadyIn2 = reportingColumnsExtraSmartAttributes.find((element) => {
              return element.field === extraColumn2.field;
            });
            if (!alreadyIn2)
              reportingColumnsExtraSmartAttributes.push(extraColumn2);
          });
        }




        // if (column.field === "other_mobiles_$$_others") {
        //   if (sdsMobilesList.others) {

        //     sdsMobilesList.others.forEach(input => {
        //       const inputsData = fixAndParse(input);

        //       const foundOtherMobiles = withExtraColumns.find((element) => {
        //         return element.field === ("other_mobiles_$$_others_$$_" + inputsData.xtra_desc);
        //       });

        //       const extraColumn = {
        //         width: foundOtherMobiles ? foundOtherMobiles.width : 250,
        //         print: false,
        //         field: "other_mobiles_$$_others_$$_" + inputsData.xtra_desc,
        //         headerName: "Others for mobiles – " + inputsData.xtra_desc,
        //         customHeaderName: false,
        //         parentTitle: null,
        //         type: "string",
        //         resizable: true,
        //         disableReorder: true,
        //         extraColumn: true
        //       }

        //       const alreadyIn = reportingColumnsExtraOthersMobiles.find((element) => {
        //         return element.field === extraColumn.field;
        //       });

        //       if (!alreadyIn)
        //         reportingColumnsExtraOthersMobiles.push(extraColumn);

        //     });
        //   }
        // }
    }
  }


    // ADD COMMENTS COLUMNS IF ADMIN -------------------------------------
  const pos = reportingColumnsCopy.map(e => e.field).indexOf("diag_common_$$_tests_comments");

    if (pos > -1) {
      const tmpReportingColumnsCopy = [];

    for (const column of reportingColumnsCopy) {
        if (column.field === "diag_common_$$_tests_comments") {
          column.hide = true;
        }
        tmpReportingColumnsCopy.push(column);
    }

    let colIndex = 0;
    for (const column of reportingColumnsCopy) {
      const splitTmp = column.field.split('_$$_');

      if (splitTmp) {
        // console.log("1937 - column=", column);

        const testsHardwareColumns = [
          'diag_cpu', 'diag_memory', 'diag_storage', 'diag_mainboard', 'diag_video_adapter', 'diag_network',
          'diag_audio', 'diag_screen', 'diag_user_inputs', 'diag_battery', 'diag_sensors', 'diag_other'
        ];

        const test = testsHardwareColumns.includes(splitTmp[0]);
        if (test) {
            const foundDiagComment = withExtraColumns.find((element) => {
              return element.field === ("diag_comment_$$_" + splitTmp[0] + "_$$_" + splitTmp[1]);
            });

          const extraColumn = {
              width: foundDiagComment ? foundDiagComment.width : 350,
            print: false,
            field: "diag_comment_$$_" + splitTmp[0] + "_$$_" + splitTmp[1],
            headerName: "Comments – " + splitTmp[1],
            customHeaderName: false,
            parentTitle: null,
            type: "string",
            resizable: true,
              disableReorder: true,
              extraColumn: true
          }
          tmpReportingColumnsCopy.splice(++colIndex, 0, extraColumn);
        }
      }
        colIndex++;
    }
    reportingColumnsCopy = [...tmpReportingColumnsCopy];
  }


  let index101 = reportingColumnsCopy.findIndex(col => col.field === "welcome_screen_$$_other_manual_inputs");
  if (index101 > -1 && reportingColumnsExtra101_Others.length > 0) {
    reportingColumnsCopy.splice(index101, 1);
    for (const elementToAdd of reportingColumnsExtra101_Others) {
      reportingColumnsCopy.splice(index101++, 0, elementToAdd);
    }
  }

  let index145 = reportingColumnsCopy.findIndex(col => col.field === "questions_form_$$_other_questions");
  if (index145 > -1 && reportingColumnsExtra145_Others.length > 0) {
    reportingColumnsCopy.splice(index145, 1);
    for (const elementToAdd of reportingColumnsExtra145_Others) {
      reportingColumnsCopy.splice(index145++, 0, elementToAdd);
    }
  }

  let indexTestsMobiles = reportingColumnsCopy.findIndex(col => col.field === "tests_mobiles_$$_tests_mobiles");
  if (indexTestsMobiles > -1 && reportingColumnsExtraTestsMobiles.length > 0) {
    reportingColumnsCopy.splice(indexTestsMobiles, 1);
    for (const elementToAdd of reportingColumnsExtraTestsMobiles) {
      reportingColumnsCopy.splice(indexTestsMobiles++, 0, elementToAdd);
    }
  }

  let indexManualInputsMobiles = reportingColumnsCopy.findIndex(col => col.field === "manual_inputs_mobiles_$$_manual_inputs_mobiles");
  if (indexManualInputsMobiles > -1 && reportingColumnsExtraManualInputsMobiles.length > 0) {
    reportingColumnsCopy.splice(indexManualInputsMobiles, 1);
    for (const elementToAdd of reportingColumnsExtraManualInputsMobiles) {
      reportingColumnsCopy.splice(indexManualInputsMobiles++, 0, elementToAdd);
    }
  }

  let indexOthersMobiles = reportingColumnsCopy.findIndex(col => col.field === "other_mobiles_$$_others");
  if (indexOthersMobiles > -1 && reportingColumnsExtraOthersMobiles.length > 0) {
    reportingColumnsCopy.splice(indexOthersMobiles, 1);
    for (const elementToAdd of reportingColumnsExtraOthersMobiles) {
      reportingColumnsCopy.splice(indexOthersMobiles++, 0, elementToAdd);
    }
  }

    let indexSmartAttributes = reportingColumnsCopy.findIndex(col => col.field === "disks_wipe_$$_smart_attributes");
    if (indexSmartAttributes > -1 && reportingColumnsExtraSmartAttributes.length > 0) {
      reportingColumnsCopy.splice(indexSmartAttributes, 1);

      const sorted = reportingColumnsExtraSmartAttributes.sort((a, b) => {
        return parseInt(a.attibuteValue) > parseInt(b.attibuteValue) ? 1 : -1;
      });
      // console.log("2793 - sorted =", sorted);

      for (const elementToAdd of sorted) {
        // console.log("2792 - add =", indexSmartAttributes, elementToAdd);
        reportingColumnsCopy.splice(indexSmartAttributes, 0, elementToAdd);
        indexSmartAttributes = indexSmartAttributes + 1;
      }
    }

    let indexSmartAttributes2 = reportingColumnsCopy.findIndex(col => col.field === "disk_wipe_$$_smart_attributes");
    if (indexSmartAttributes2 > -1 && reportingColumnsExtraSmartAttributes.length > 0) {
      reportingColumnsCopy.splice(indexSmartAttributes2, 1);

      const sorted = reportingColumnsExtraSmartAttributes.sort((a, b) => {
        return parseInt(a.attibuteValue) > parseInt(b.attibuteValue) ? 1 : -1;
      });
      // console.log("2889 - sorted =", sorted);

      for (const elementToAdd of sorted) {
        // console.log("2803 - add =", indexSmartAttributes2, elementToAdd);
        reportingColumnsCopy.splice(indexSmartAttributes2, 0, elementToAdd);
        indexSmartAttributes2 = indexSmartAttributes2 + 1;
      }
    }

    // FILL ROWS ----------------------------------
    // console.log("2155 - deployments=", tmpDeployments.length);
    // console.log("2525 - deployments=", tmpDeployments);

  deploymentsIndex = -1;
    
    for (const deployment of tmpDeployments) {
      // console.log("3238 - deployment=", deployment);
    deploymentsIndex++;

      const cpuList = deployment.cpu_data && deployment.cpu_data.split('<cpu>');
      const ramList = deployment.ram_data && deployment.ram_data.split('<ram>');
      const diskList = deployment.disk_data && deployment.disk_data.split('<disk>');
      const gpuList = deployment.gpu_data && deployment.gpu_data.split('<gpu>');
      const nicList = deployment.nic_data && deployment.nic_data.split('<nic>');
      const soundList = deployment.sound_data && deployment.sound_data.split('<sound>');
      const screenList = deployment.screen_data && deployment.screen_data.split('<screen>');
      const storageCtrlList = deployment.storage_ctrl_data && deployment.storage_ctrl_data.split('<storage_ctrl>');
      const webcamList = deployment.webcam_data && deployment.webcam_data.split('<webcam>');
      const batteryList = deployment.battery_data && deployment.battery_data.split('<battery>');
      const cddvdList = deployment.cddvd_data && deployment.cddvd_data.split('<cddvd>');
      const wipedList = deployment.wiped_data && deployment.wiped_data.split('<wiped>');
      const diskValidatedList = deployment.module_1141_disk_validated && deployment.module_1141_disk_validated.split('<sds_hexviewer>');

      const testsList = deployment.tests_data && deployment.tests_data.split('<tests>');

      const sdsQuestions101List = deployment.sdsquestions101_data && deployment.sdsquestions101_data.split('<sds_questions>');
      const sdsQuestions145List = deployment.sdsquestions145_data && deployment.sdsquestions145_data.split('<sds_questions>');
      const sdsScriptsList = deployment.sdsScripts_data && deployment.sdsScripts_data.split("<sds_scripts>");
      // const sdsHexadecimalViewerList = deployment.sdsScripts_data && deployment.sdsScripts_data.split("<sds_questions>");
      const sdsBootImgList = deployment.sdsBootImg_data && deployment.sdsBootImg_data.split("<sds_bootimg>");

      const extraDiskHealthList = deployment.extraDiskHealth && deployment.extraDiskHealth.split("<ext_disk>");
      const extraDiskPerfList = deployment.extraDiskPerf && deployment.extraDiskPerf.split("<ext_disk>");

    const sdsMobilesList = getSdsMobilesList(deployment);
    const sdsTestsMobilesList = sdsMobilesList && sdsMobilesList.tests;
    const sdsManualInputsMobilesList = sdsMobilesList && sdsMobilesList.manualInputs;
    const sdsOthersMobilesList = sdsMobilesList && sdsMobilesList.others;

      const sdsDiskWipeSmartAttributesList = deployment.disk_wipe_smartAttibutes_data && deployment.disk_wipe_smartAttibutes_data.split("<smart>");

      // console.log("3369 - sdsScriptsList=", sdsScriptsList);
      // console.log("2672 - sdsMobilesList.others=", sdsMobilesList.others);
      /*
      TYPE OF COLUMNS :
          'string' (default)
          'number'
          'date'
          'dateTime'
          'boolean'
          'singleSelect'
      */

      // console.log("3281 - reportingColumnsCopy=", reportingColumnsCopy);

    let row = {};
    for (const column of reportingColumnsCopy) {
      row.key = deploymentsIndex;
        row.id = localFilteredRows.length + 1;

      let count = 0;
      switch (column.field) {

        // General
        case "general_$$_date": {
          // const options = {
          //   year: 'numeric',
          //   month: '2-digit',
          //   day: '2-digit',
          //   hour: 'numeric',
          //   minute: '2-digit'
          // };
          // row.general_$$_date = new Date(getTimeAsZDateTime(deployment.date)).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
          row.general_$$_date = deployment.date;
            column.type = 'dateTime';
            // column.test = 'TEST_date';
          break;
        }

        case "general_$$_id": {
            row.general_$$_id = isNaN(deployment.deployment_id) ? deployment.deployment_id : parseInt(deployment.deployment_id);
          column.type = 'number';
            // column.test = 'TEST_id';
          break;
        }

        case "general_$$_global_result": {
            if (deployment.global_result)
          row.general_$$_global_result = deployment.global_result;
            else {
              let now = new Date();
              let testDate = new Date(deployment.date);
              let diff = Math.round(now.getTime() - testDate.getTime());

              if (diff > 86400000)
                row.general_$$_global_result = "INTERRUPTED";
              else
                row.general_$$_global_result = "ONGOING";
            }
            column.type = 'singleSelect';
            column.valueOptions = [
              'PASSED',
              'FAILED',
              'WARNING',
              'CANCEL',
              'ABORTED',
              'SKIPPED',
              'INTERRUPTED',
              'WARNING - REMOVED',
              'ONGOING'
            ]
          break;
        }

          case "general_$$_server_name": {
            row.general_$$_server_name = deployment.server_name;
            column.type = 'string';
            break;
          }

        case "general_$$_location": {
          row.general_$$_location = deployment.location;
          column.type = 'string';
          break;
        }

        case "general_$$_group": {
          row.general_$$_group = deployment.group;
          column.type = 'string';
          break;
        }
        //------------------------------------------------------------

        // hardware - system
        case "system_$$_manufacturer": {
          row.system_$$_manufacturer = deployment.system_manufacturer;
          column.type = 'string';
          break;
        }

        case "system_$$_product": {
          row.system_$$_product = deployment.system_product;
          column.type = 'string';
          break;
        }

        case "system_$$_serial_number": {
          row.system_$$_serial_number = deployment.system_serial;
          column.type = 'string';
          break;
        }

        case "system_$$_uuid": {
          row.system_$$_uuid = deployment.system_uuid;
          column.type = 'string';
          break;
        }

        case "system_$$_sku": {
          row.system_$$_sku = deployment.system_sku;
          column.type = 'string';
          break;
        }

        case "system_$$_chassis": {
          row.system_$$_chassis = deployment.enclosure_chassis;
          column.type = 'string';
          break;
        }

        case "system_$$_system_version": {
          row.system_$$_system_version = deployment.system_version;
          column.type = 'string';
          break;
        }
        //------------------------------------------------------------


        // hardware - cpu
          case "cpu_$$_total_sockets": {
            let cpu_calc = 0;
            if (!cpuList)
              break;
            cpuList.forEach(cpu => {
              cpu_calc++
            });

            row.cpu_$$_total_sockets = cpu_calc;
            column.type = 'number';
            break;
          }

          case "cpu_$$_free_sockets": {
            let cpu_calc = 0;
            if (!cpuList)
              break;
            cpuList.forEach(cpu => {
              const cpuData = fixAndParse(cpu);
              if (!cpuData.manufacturer && !cpuData.model && cpuData.nominal_frequency == 0)
                cpu_calc++
            });

            row.cpu_$$_free_sockets = cpu_calc;
            column.type = 'number';
            break;
          }

        case "cpu_$$_manufacturer": {
          let cpu_manufacturer = "";
          if (!cpuList)
            break;
          cpuList.forEach(cpu => {
            const cpuData = fixAndParse(cpu);

              if (cpuData.manufacturer !== "" && cpuData.model !== "" && cpuData.nominal_frequency !== '0') {
              count++;
              if (cpu_manufacturer !== "")
                cpu_manufacturer = cpu_manufacturer + line_separator;
              cpu_manufacturer += cpuData.manufacturer;
            }
          });

          row.cpu_$$_manufacturer = cpu_manufacturer;
          column.type = 'string';
          break;
        }

        case "cpu_$$_model": {
          let cpu_model = "";
          if (!cpuList)
            break;
          cpuList.forEach(cpu => {
            const cpuData = fixAndParse(cpu);

              if (cpuData.manufacturer !== "" && cpuData.model !== "" && cpuData.nominal_frequency !== '0') {
              count++;
              if (cpu_model !== "")
                cpu_model = cpu_model + line_separator;
              cpu_model += cpuData.model;
            }
          });

          row.cpu_$$_model = cpu_model;
          column.type = 'string';
          break;
        }

        case "cpu_$$_socket": {
          let cpu_socket = "";
          if (!cpuList)
            break;
          cpuList.forEach(cpu => {
            const cpuData = fixAndParse(cpu);

              if (cpuData.manufacturer !== "" && cpuData.model !== "" && cpuData.nominal_frequency !== '0') {
              count++;
              if (cpu_socket !== "")
                cpu_socket = cpu_socket + line_separator;
              cpu_socket += cpuData.socket;
            }
          });

          row.cpu_$$_socket = cpu_socket;
          column.type = 'string';
          break;
        }

        case "cpu_$$_cpuid": {
          let cpu_cpuid = "";
          if (!cpuList)
            break;
          cpuList.forEach(cpu => {
            const cpuData = fixAndParse(cpu);

              if (cpuData.manufacturer !== "" && cpuData.model !== "" && cpuData.nominal_frequency !== '0') {
              count++;
              if (cpu_cpuid !== "")
                cpu_cpuid = cpu_cpuid + line_separator;
              cpu_cpuid += cpuData.cpuid;
            }
          });

          row.cpu_$$_cpuid = cpu_cpuid;
          column.type = 'string';
          break;
        }

        case "cpu_$$_nominal_frequency": {
          let cpu_nominal_frequency = "";
          if (!cpuList)
            break;
          cpuList.forEach(cpu => {
            const cpuData = fixAndParse(cpu);

              if (cpuData.manufacturer !== "" && cpuData.model !== "" && cpuData.nominal_frequency !== '0') {
              count++;
              if (cpu_nominal_frequency !== "")
                cpu_nominal_frequency = cpu_nominal_frequency + line_separator;

              // TO DO : If we have to set an appropriate size label.
              // let cpu_calc = 1048576 * cpuData.nominal_frequency;   // to get value in bytes

              // let decimals = 2;
              // if (cpu_calc === 0)
              //   cpu_nominal_frequency += '0 Hz';
              // else {
              //   const k = 1024;
              //   const dm = decimals < 0 ? 0 : decimals;
              //   const sizes = ['Hz', 'KHz', 'MHz', 'GHz', 'THz', 'PHz', 'EHz', 'ZHz', 'YHz'];
              //   const i = Math.floor(Math.log(cpu_calc) / Math.log(k));
              //   cpu_nominal_frequency += parseFloat((cpu_calc / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
              // }
              cpu_nominal_frequency += cpuData.nominal_frequency; // + " MHz";
            }
          });

          row.cpu_$$_nominal_frequency = cpu_nominal_frequency;
          column.type = 'number';
          break;
        }

        case "cpu_$$_maximum_frequency": {
          let cpu_max_frequency = "";
          if (!cpuList)
            break;
          cpuList.forEach(cpu => {
            const cpuData = fixAndParse(cpu);

              if (cpuData.manufacturer !== "" && cpuData.model !== "" && cpuData.nominal_frequency !== '0') {
              count++;
              if (cpu_max_frequency !== "")
                cpu_max_frequency = cpu_max_frequency + line_separator;
              cpu_max_frequency += cpuData.max_frequency; // + " MHz";
            }
          });

          row.cpu_$$_maximum_frequency = cpu_max_frequency;
          column.type = 'number';
          break;
        }

        case "cpu_$$_cores": {
          let cpu_cores = "";
          if (!cpuList)
            break;
          cpuList.forEach(cpu => {
            const cpuData = fixAndParse(cpu);

              if (cpuData.manufacturer !== "" && cpuData.model !== "" && cpuData.nominal_frequency !== '0') {
              count++;
              if (cpu_cores !== "")
                cpu_cores = cpu_cores + line_separator;
              cpu_cores += cpuData.cores;
            }
          });

          row.cpu_$$_cores = cpu_cores;
          column.type = 'number';
          break;
        }

        case "cpu_$$_threads": {
          let cpu_threads = "";
          if (!cpuList)
            break;
          cpuList.forEach(cpu => {
            const cpuData = fixAndParse(cpu);

              if (cpuData.manufacturer !== "" && cpuData.model !== "" && cpuData.nominal_frequency !== '0') {
              count++;
              if (cpu_threads !== "")
                cpu_threads = cpu_threads + line_separator;
              cpu_threads += cpuData.threads;
            }
          });

          row.cpu_$$_threads = cpu_threads;
          column.type = 'number';
          break;
        }

        case "cpu_$$_l1cache": {
          let cpu_l1cache = "";
          if (!cpuList)
            break;
          cpuList.forEach(cpu => {
            const cpuData = fixAndParse(cpu);

              if (cpuData.manufacturer !== "" && cpuData.model !== "" && cpuData.nominal_frequency !== '0') {
              count++;
              if (cpu_l1cache !== "")
                cpu_l1cache = cpu_l1cache + line_separator;
              cpu_l1cache += cpuData.l1cache; // + " KB";
            }
          });

          row.cpu_$$_l1cache = cpu_l1cache;
          column.type = 'number';
          break;
        }

        case "cpu_$$_l2cache": {
          let cpu_l2cache = "";
          if (!cpuList)
            break;
          cpuList.forEach(cpu => {
            const cpuData = fixAndParse(cpu);

              if (cpuData.manufacturer !== "" && cpuData.model !== "" && cpuData.nominal_frequency !== '0') {
              count++;
              if (cpu_l2cache !== "")
                cpu_l2cache = cpu_l2cache + line_separator;
              cpu_l2cache += cpuData.l2cache; // + " KB";
            }
          });

          row.cpu_$$_l2cache = cpu_l2cache;
          column.type = 'number';
          break;
        }

        case "cpu_$$_l3cache": {
          let cpu_l3cache = "";
          if (!cpuList)
            break;
          cpuList.forEach(cpu => {
            const cpuData = fixAndParse(cpu);

              if (cpuData.manufacturer !== "" && cpuData.model !== "" && cpuData.nominal_frequency !== '0') {
              count++;
              if (cpu_l3cache !== "")
                cpu_l3cache = cpu_l3cache + line_separator;
              cpu_l3cache += cpuData.l3cache; // + " KB";;
            }
          });

          row.cpu_$$_l3cache = cpu_l3cache;
          column.type = 'number';
          break;
        }
        //------------------------------------------------------------


        // hardware - ram_bank
        case "ram_bank_$$_total_amount": {
          let ram_calc = 0;
          if (!ramList)
            break;

          // console.log("ramList=", ramList);
          ramList.forEach(ram => {
            const ramData = fixAndParse(ram);
            ram_calc += parseInt(ramData.size, 10);
          });

          // ram_calc = 1048576 * ram_calc;   // to get value in bytes          

          let decimals = 2;
          if (ram_calc === 0)
              row.ram_bank_$$_total_amount = 0; // B';
          else {
            // const k = 1024;
            // const dm = decimals < 0 ? 0 : decimals;
            // const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            // const i = Math.floor(Math.log(ram_calc) / Math.log(k));
            // row.ram_bank_$$_total_amount = parseFloat((ram_calc / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            row.ram_bank_$$_total_amount = ram_calc;
          }
            column.type = 'string';
          break;
        }

        case "ram_bank_$$_total_slots": {
          let ram_calc = 0;
          if (!ramList)
            break;
          ramList.forEach(ram => {
            ram_calc++
          });

          row.ram_bank_$$_total_slots = ram_calc;
          column.type = 'number';
          break;
        }

        case "ram_bank_$$_free_slots": {
          let ram_calc = 0;
          if (!ramList)
            break;
          ramList.forEach(ram => {
            const ramData = fixAndParse(ram);
            if (ramData.size === "0")
              ram_calc++
          });

          row.ram_bank_$$_free_slots = ram_calc;
          column.type = 'number';
          break;
        }

        case "ram_bank_$$_form_factor": {
          let ram_txt = "";
          if (!ramList)
            break;
          ramList.forEach(ram => {
            const ramData = fixAndParse(ram);
            if (ramData.size > 0) {
              ram_txt = ramData.form_factor
            }
          });

          row.ram_bank_$$_form_factor = ram_txt;
          column.type = 'string';
          break;
        }

        case "ram_bank_$$_manufacturer": {
          let ram_txt = "";
          if (!ramList)
            break;
          ramList.forEach(ram => {
            const ramData = fixAndParse(ram);
            if (ramData.size > 0) {
              count++;
              if (ram_txt !== "")
                ram_txt = ram_txt + line_separator;
              ram_txt += ramData.manufacturer
            }
          });

          row.ram_bank_$$_manufacturer = ram_txt;
          column.type = 'string';
          break;
        }

        case "ram_bank_$$_type": {
          let ram_txt = "";
          if (!ramList)
            break;
          ramList.forEach(ram => {
            const ramData = fixAndParse(ram);

            if (ramData.size > 0) {
              count++;
              if (ram_txt !== "")
                ram_txt = ram_txt + line_separator;
              ram_txt += ramData.type
            }
          });

          row.ram_bank_$$_type = ram_txt;
          column.type = 'string';
          break;
        }

        case "ram_bank_$$_speed": {
          let ram_txt = "";
          if (!ramList)
            break;
          ramList.forEach(ram => {
            const ramData = fixAndParse(ram);

            if (ramData.size > 0) {
              count++;
              if (ram_txt !== "")
                ram_txt = ram_txt + line_separator;
              ram_txt += (ramData.speed); // + " MHz");
            }
          });

          row.ram_bank_$$_speed = ram_txt;
          column.type = 'number';
          break;
        }

        case "ram_bank_$$_size": {
          let ram_txt = "";
          if (!ramList)
            break;
          ramList.forEach(ram => {
            const ramData = fixAndParse(ram);

            if (ramData.size > 0) {
              count++;
              if (ram_txt !== "")
                ram_txt = ram_txt + line_separator;

              // let ram_calc = 1048576 * ramData.size;   // to get value in bytes
              let ram_calc = ramData.size;   // to get value in bytes

              let decimals = 2;
              if (ram_calc === 0)
                ram_txt += '0'; // B';
              else {
                // const k = 1024;
                // const dm = decimals < 0 ? 0 : decimals;
                // const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
                // const i = Math.floor(Math.log(ram_calc) / Math.log(k));
                // ram_txt += parseFloat((ram_calc / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
                ram_txt += ram_calc; // parseFloat((ram_calc / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
              }
            }
          });

          row.ram_bank_$$_size = ram_txt;
            column.type = 'string';
          break;
        }

        case "ram_bank_$$_serial_number": {
          let ram_txt = "";
          if (!ramList)
            break;
          ramList.forEach(ram => {
            const ramData = fixAndParse(ram);

            if (ramData.size > 0) {
              count++;
              if (ram_txt !== "")
                ram_txt = ram_txt + line_separator;
              ram_txt += ramData.serial
            }
          });

          row.ram_bank_$$_serial_number = ram_txt;
          column.type = 'string';
          break;
        }

        case "ram_bank_$$_asset_tag": {
          let ram_txt = "";
          if (!ramList)
            break;
          ramList.forEach(ram => {
            const ramData = fixAndParse(ram);

            if (ramData.size > 0) {
              count++;
              if (ram_txt !== "")
                ram_txt = ram_txt + line_separator;
              ram_txt += ramData.asset_tag
            }
          });

          row.ram_bank_$$_asset_tag = ram_txt;
          column.type = 'string';
          break;
        }

        case "ram_bank_$$_part_number": {
          let ram_txt = "";
          if (!ramList)
            break;
          ramList.forEach(ram => {
            const ramData = fixAndParse(ram);

            if (ramData.size > 0) {
              count++;
              if (ram_txt !== "")
                ram_txt = ram_txt + line_separator;
              ram_txt += ramData.part_number
            }
          });

          row.ram_bank_$$_part_number = ram_txt;
          column.type = 'string';
          break;
        }

        case "ram_bank_$$_rank": {
          let ram_txt = "";
          if (!ramList)
            break;
          ramList.forEach(ram => {
            const ramData = fixAndParse(ram);

            if (ramData.size > 0) {
              count++;
              if (ram_txt !== "")
                ram_txt = ram_txt + line_separator;

              let rankTxt = "";
              // switch (ramData.rank) {
              //   case "1":
              //     rankTxt = "Single";
              //     break;

              //   case "2":
              //     rankTxt = "Dual";
              //     break;

              //   case "4":
              //     rankTxt = "Quad";
              //     break;

              //   default:
              //     rankTxt = "Unknown";
              // }
              ram_txt += ramData.rank; //rankTxt
            }
          });

          row.ram_bank_$$_rank = ram_txt;
          column.type = 'string';
          break;
        }
        //------------------------------------------------------------


        // hardware - disk
        case "disk_$$_nb_disks": {
          let disk_calc = 0;
          if (!diskList)
            break;
          diskList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.size > 0)
              disk_calc++
          });

          row.disk_$$_nb_disks = disk_calc;
          column.type = 'number';
          break;
        }

        case "disk_$$_total_size": {
          let disk_calc = 0;
          if (!diskList)
            break;
          diskList.forEach(disk => {
            const diskData = fixAndParse(disk);
            disk_calc += parseInt(diskData.size, 10);
          });

          let decimals = 2;
          if (disk_calc === 0)
            row.disk_$$_total_size = '0'; //  B';
          else {
            // const k = 1024;
            // const dm = decimals < 0 ? 0 : decimals;
            // const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            // const i = Math.floor(Math.log(disk_calc) / Math.log(k));
            // row.disk_$$_total_size = parseFloat((disk_calc / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            row.disk_$$_total_size = disk_calc;
          }
            column.type = 'string';
          break;
        }

        case "disk_$$_manufacturer": {
          let disk_txt = "";
          if (!diskList)
            break;
          diskList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.size > 0) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
              disk_txt += diskData.manufacturer
            }
          });

          row.disk_$$_manufacturer = disk_txt;
          column.type = 'string';
          break;
        }

        case "disk_$$_model": {
          let disk_txt = "";
          if (!diskList)
            break;
          diskList.forEach(disk => {
              // console.log("---------------");
              // console.log("disk=", disk);
            const diskData = fixAndParse(disk);
            if (diskData.size > 0) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
              disk_txt += diskData.model
            }
          });

          row.disk_$$_model = disk_txt;
          column.type = 'string';
          break;
        }

        case "disk_$$_advertized_capacity": {
          let disk_txt = "";
          if (!diskList)
            break;
          diskList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.size > 0) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
              disk_txt += diskData.size_commercial
            }
          });

          row.disk_$$_advertized_capacity = disk_txt;
            column.type = 'string';
          break;
        }

        case "disk_$$_real_capacity": {
          let disk_txt = "";
          if (!diskList)
            break;
          diskList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.size > 0) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;

              let disk_calc = diskData.size;

              let decimals = 2;
              if (disk_calc === 0)
                disk_txt += '0'; // B';
              else {
                // const k = 1024;
                // const dm = decimals < 0 ? 0 : decimals;
                // const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
                // const i = Math.floor(Math.log(disk_calc) / Math.log(k));
                // disk_txt += parseFloat((disk_calc / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
                disk_txt += disk_calc;
              }
            }
          });

          row.disk_$$_real_capacity = disk_txt;
          column.type = 'number';
          break;
        }

        case "disk_$$_type": {
          let disk_txt = "";
          if (!diskList)
            break;
          diskList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.size > 0) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
              disk_txt += diskData.disk_type
            }
          });

          row.disk_$$_type = disk_txt;
          column.type = 'string';
          break;
        }

        case "disk_$$_firmware": {
          let disk_txt = "";
          if (!diskList)
            break;
          diskList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.size > 0) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
              disk_txt += diskData.firmware
            }
          });

          row.disk_$$_firmware = disk_txt;
          column.type = 'string';
          break;
        }

        case "disk_$$_serial_number": {
          let disk_txt = "";
          if (!diskList)
            break;
          diskList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.size > 0) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
              disk_txt += diskData.serial
            }
          });

          row.disk_$$_serial_number = disk_txt;
          column.type = 'string';
          break;
        }

        case "disk_$$_connector": {
          let disk_txt = "";
          if (!diskList)
            break;
          diskList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.size > 0) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
              disk_txt += diskData.connector
            }
          });

          row.disk_$$_connector = disk_txt;
          column.type = 'string';
          break;
        }

        case "disk_$$_bus": {
          let disk_txt = "";
          if (!diskList)
            break;
          diskList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.size > 0) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
              disk_txt += diskData.bus
            }
          });

          row.disk_$$_bus = disk_txt;
          column.type = 'string';
          break;
        }

        case "disk_$$_world_wide_name": {
          let disk_txt = "";
          if (!diskList)
            break;
          diskList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.size > 0) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
              disk_txt += diskData.wwn
            }
          });

          row.disk_$$_world_wide_name = disk_txt;
          column.type = 'string';
          break;
        }

        case "disk_$$_ppid": {
          let disk_txt = "";
          if (!diskList)
            break;
          diskList.forEach(disk => {
            const diskData = fixAndParse(disk);
            if (diskData.size > 0) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;

                let ppidTxt = diskData.ppid;
                if (ppidTxt == "")
                  ppidTxt = "NO PPID";
                disk_txt += ppidTxt
            }
          });

          row.disk_$$_ppid = disk_txt;
          column.type = 'string';
          break;
        }

        case "disk_$$_health": {
          let disk_txt = "";
          if (!diskList)
            break;
          diskList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.size > 0) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
              disk_txt += diskData.health
            }
          });

          row.disk_$$_health = disk_txt;
            column.type = 'singleSelect';
            column.valueOptions = [
              'UNKNOWN',
              'GOOD',
              'BAD',
              'WARNING'
            ]
          break;
        }

        case "disk_$$_remapped_sectors": {
          let disk_txt = "";
          if (!diskList)
            break;
          diskList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.size > 0) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
              disk_txt += diskData.remapped_sector
            }
          });

          row.disk_$$_remapped_sectors = disk_txt;
          column.type = 'number';
          break;
        }

        case "disk_$$_bits_per_sector": {
          let disk_txt = "";
          if (!diskList)
            break;
          diskList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.size > 0) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
              disk_txt += diskData.bps
            }
          });

          row.disk_$$_bits_per_sector = disk_txt;
          column.type = 'number';
          break;
        }

        case "disk_$$_hpa": {
          let disk_txt = "";
          if (!diskList)
            break;
          diskList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.size > 0) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
              disk_txt += diskData.hpa
            }
          });

          row.disk_$$_hpa = disk_txt;
          column.type = 'string';
          break;
        }

        case "disk_$$_dco": {
          let disk_txt = "";
          if (!diskList)
            break;
          diskList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.size > 0) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
              disk_txt += diskData.dco
            }
          });

          row.disk_$$_dco = disk_txt;
          column.type = 'string';
          break;
        }

        case "disk_$$_rpm": {
          let disk_txt = "";
          if (!diskList)
            break;
          diskList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.size > 0) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
              disk_txt += diskData.rpm
            }
          });

          row.disk_$$_rpm = disk_txt;
          column.type = 'number';
          break;
        }


          // case "disk_$$_computed_health": {
          //   let disk_txt = "";
          //   if (!extraDiskHealthList)
          //     break;

          //   if (!diskList)
          //     break;

          //   diskList.forEach(disk => {
          //     console.log("4348 - ...");
          //     const diskData = fixAndParse(disk);

          //     extraDiskHealthList.forEach(extraDiskHealth => {
          //       const extraDiskHealthData = fixAndParse(extraDiskHealth);

          //       const regex = /(?<=ext_disk_health\[)[^\]]*(?=\])/i;
          //       const items = extraDiskHealthData.xtra_desc.match(regex);

          //       if (items && items[0] && items[0] == diskData.serial) {
          //         count++;
          //         if (disk_txt !== "")
          //           disk_txt = disk_txt + line_separator;
          //         disk_txt += extraDiskHealthData.xtra_value
          //       }
          //     });
          //   });

          //   row.disk_$$_computed_health = disk_txt;
          //   column.type = 'number';
          //   break;
          // }


          // case "disk_$$_computed_perf": {
          //   let disk_txt = "";

          //   if (!extraDiskPerfList)
          //     break;

          //   if (!diskList)
          //     break;

          //   diskList.forEach(disk => {
          //     const diskData = fixAndParse(disk);

          //     extraDiskPerfList.forEach(extraDiskPerf => {
          //       const extraDiskPerfData = fixAndParse(extraDiskPerf);

          //       const regex = /(?<=ext_disk_perf\[)[^\]]*(?=\])/i;
          //       const items = extraDiskPerfData.xtra_desc.match(regex);

          //       if (items && items[0] && items[0] == diskData.serial) {
          //         count++;
          //         if (disk_txt !== "")
          //           disk_txt = disk_txt + line_separator;
          //         disk_txt += extraDiskPerfData.xtra_value
          //       }
          //     });
          //   });

          //   row.disk_$$_computed_perf = disk_txt;
          //   column.type = 'number';
          //   break;
          // }



        //------------------------------------------------------------


        // hardware - motherboard
        case "motherboard_$$_manufacturer": {
          row.motherboard_$$_manufacturer = deployment.motherboard_manufacturer;
          column.type = 'string';
          break;
        }

        case "motherboard_$$_model": {
          row.motherboard_$$_model = deployment.motherboard_model;
          column.type = 'string';
          break;
        }

        case "motherboard_$$_version": {
          row.motherboard_$$_version = deployment.motherboard_version;
          column.type = 'string';
          break;
        }

        case "motherboard_$$_serial": {
          row.motherboard_$$_serial = deployment.motherboard_serial;
          column.type = 'string';
          break;
        }

        case "motherboard_$$_assettag": {
          row.motherboard_$$_assettag = deployment.motherboard_assettag;
          column.type = 'string';
          break;
        }

        case "motherboard_$$_tpm_version": {
          row.motherboard_$$_tpm_version = deployment.tpm_version;
          column.type = 'string';
          break;
        }
        //------------------------------------------------------------


        // hardware - bios
        case "bios_$$_manufacturer": {
          row.bios_$$_manufacturer = deployment.bios_vendor;
          column.type = 'string';
          break;
        }

        case "bios_$$_version": {
          row.bios_$$_version = deployment.bios_version;
          column.type = 'string';
          break;
        }

        case "bios_$$_date": {
          // const options = {
          //   year: 'numeric',
          //   month: '2-digit',
          //   day: '2-digit'
          // };
          // row.bios_$$_date = new Date(deployment.bios_date).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
          row.bios_$$_date = deployment.bios_date;
          column.type = 'string';
          break;
        }
        //------------------------------------------------------------


        // hardware - video_card
        // case "video_card_$$_manufacturer": {
        //   let gpu_txt = "";
        //   gpuList.forEach(gpu => {
        //     const gpuData = fixAndParse(gpu);

        //     if (gpuData.size > 0) {
        //       if (gpu_txt !== "")
        //         gpu_txt = gpu_txt + ' / ';
        //       gpu_txt += gpuData.vendor
        //     }
        //   });

        //   row.video_card_$$_manufacturer = gpu_txt
        //   column.type = 'string';
        //   break;
        // }


          case "video_card_$$_manufacturer": {
            let gpu_txt = "";
            if (!gpuList)
              break;
            gpuList.forEach(gpu => {
              const gpuData = fixAndParse(gpu);

              if (gpuData.pnp) {
                let tmpTxt = "";
                if (gpuData.pnp.startsWith("PCI\\VEN_8086&"))
                  tmpTxt = "Intel"
                else if (gpuData.pnp.startsWith("PCI\\VEN_10DE&"))
                  tmpTxt = "NVIDIA"
                else if (gpuData.pnp.startsWith("PCI\\VEN_1002&"))
                  tmpTxt = "AMD"
                else
                  tmpTxt = "unknown"

                count++;
                if (gpu_txt !== "")
                  gpu_txt = gpu_txt + line_separator;
                gpu_txt += tmpTxt
              }
            });

            row.video_card_$$_manufacturer = gpu_txt;
            column.type = 'string';
            break;
          }


        case "video_card_$$_model": {
          let gpu_txt = "";
          if (!gpuList)
            break;
          gpuList.forEach(gpu => {
            const gpuData = fixAndParse(gpu);

            if (gpuData.model) {
              count++;
              if (gpu_txt !== "")
                gpu_txt = gpu_txt + line_separator;
              gpu_txt += gpuData.model
            }
          });

          row.video_card_$$_model = gpu_txt;
          column.type = 'string';
          break;
        }

        case "video_card_$$_driver": {
          let gpu_txt = "";
          if (!gpuList)
            break;
          gpuList.forEach(gpu => {
            const gpuData = fixAndParse(gpu);

            if (gpuData.model) {
              count++;
              if (gpu_txt !== "")
                gpu_txt = gpu_txt + line_separator;
              gpu_txt += gpuData.driver
            }
          });

          row.video_card_$$_driver = gpu_txt;
          column.type = 'string';
          break;
        }

          case "video_card_$$_cores": {
            let gpu_txt = "";
            if (!gpuList)
              break;
            gpuList.forEach(gpu => {
              const gpuData = fixAndParse(gpu);

              if (gpuData.model) {
                count++;
                if (gpu_txt !== "")
                  gpu_txt = gpu_txt + line_separator;
                gpu_txt += gpuData.cores
              }
            });

            row.video_card_$$_cores = gpu_txt;
            column.type = 'string';
            break;
          }

          case "video_card_$$_allocated_memory_size": {
            let gpu_txt = "";
            if (!gpuList)
              break;
            gpuList.forEach(gpu => {
              const gpuData = fixAndParse(gpu);

              if (gpuData.ram) {
                count++;
                if (gpu_txt !== "")
                  gpu_txt = gpu_txt + line_separator;
                gpu_txt += gpuData.ram
              }
            });

            row.video_card_$$_allocated_memory_size = gpu_txt;
            column.type = 'string';
            break;
          }

          case "video_card_$$_memory_bus": {
            let gpu_txt = "";
            if (!gpuList)
              break;
            gpuList.forEach(gpu => {
              const gpuData = fixAndParse(gpu);

              if (gpuData.ram_bus_width) {
                count++;
                if (gpu_txt !== "")
                  gpu_txt = gpu_txt + line_separator;
                gpu_txt += gpuData.ram_bus_width
              }
            });

            row.video_card_$$_memory_bus = gpu_txt;
            column.type = 'string';
            break;
          }

          case "video_card_$$_name": {
            let gpu_txt = "";
            if (!gpuList)
              break;
            gpuList.forEach(gpu => {
              const gpuData = fixAndParse(gpu);

              if (gpuData.die_name) {
                count++;
                if (gpu_txt !== "")
                  gpu_txt = gpu_txt + line_separator;
                gpu_txt += gpuData.die_name
              }
            });

            row.video_card_$$_name = gpu_txt;
            column.type = 'string';
            break;
          }
        //------------------------------------------------------------


        // hardware - network_card
        case "network_card_$$_manufacturer": {
          let nic_txt = "";
          if (!nicList)
            break;
          nicList.forEach(nic => {
            const nicData = fixAndParse(nic);

            if (nicData.manufacturer) {
              count++;
              if (nic_txt !== "")
                nic_txt = nic_txt + line_separator;
              nic_txt += nicData.manufacturer
            }
          });

          row.network_card_$$_manufacturer = nic_txt;
          column.type = 'string';
          break;
        }

        case "network_card_$$_model": {
          let nic_txt = "";
          if (!nicList)
            break;
          nicList.forEach(nic => {
            const nicData = fixAndParse(nic);

            if (nicData.manufacturer) {
              count++;
              if (nic_txt !== "")
                nic_txt = nic_txt + line_separator;
              nic_txt += nicData.model
            }
          });

          row.network_card_$$_model = nic_txt;
          column.type = 'string';
          break;
        }

        case "network_card_$$_type": {
          let nic_txt = "";
          if (!nicList)
            break;
          nicList.forEach(nic => {
            const nicData = fixAndParse(nic);

            if (nicData.manufacturer) {
              count++;
              if (nic_txt !== "")
                nic_txt = nic_txt + line_separator;
              nic_txt += nicData.type
            }
          });

          row.network_card_$$_type = nic_txt;
          column.type = 'string';
          break;
        }

        case "network_card_$$_pnp": {
          let nic_txt = "";
          if (!nicList)
            break;
          nicList.forEach(nic => {
            const nicData = fixAndParse(nic);

            if (nicData.manufacturer) {
              count++;
              if (nic_txt !== "")
                nic_txt = nic_txt + line_separator;
              nic_txt += nicData.pnp
            }
          });

          row.network_card_$$_pnp = nic_txt;
          column.type = 'string';
          break;
        }

        case "network_card_$$_mac": {
          let nic_txt = "";
          if (!nicList)
            break;
          nicList.forEach(nic => {
            const nicData = fixAndParse(nic);

            if (nicData.manufacturer) {
              count++;
              if (nic_txt !== "")
                nic_txt = nic_txt + line_separator;
              nic_txt += nicData.mac
            }
          });

          row.network_card_$$_mac = nic_txt;
          column.type = 'string';
          break;
        }

        case "network_card_$$_driver": {
          let nic_txt = "";
          if (!nicList)
            break;
          nicList.forEach(nic => {
            const nicData = fixAndParse(nic);

            if (nicData.manufacturer) {
              count++;
              if (nic_txt !== "")
                nic_txt = nic_txt + line_separator;
              nic_txt += nicData.driver
            }
          });

          row.network_card_$$_driver = nic_txt;
          column.type = 'string';
          break;
        }

          case "network_card_$$_protocol_version": {
            let nic_txt = "";
            let nic_type_txt = "";

            if (!nicList)
              break;
            nicList.forEach(nic => {
              const nicData = fixAndParse(nic);

              if (nicData.manufacturer) {
                count++;
                if (nic_txt !== "") {
                  nic_txt = nic_txt + line_separator;
                  nic_type_txt = nic_type_txt + line_separator;
                }
                nic_txt += nicData.protocol_version;
                nic_type_txt += nicData.type;
              }
            });
            row.network_card_$$_protocol_version = nic_txt;
            row.network_card_$$_protocol_version_type = nic_type_txt;
            column.type = 'string';
            break;
          }

        //------------------------------------------------------------


        // hardware - sound
        // case "sound_card_$$_manufacturer": {
        //   let sound_txt = "";
        //   soundList.forEach(sound => {
        //     sound = sound.replace("\\", "\\\\");
        //     const soundData = fixAndParse(sound);

        //     if (soundData.manufacturer) {
        //       if (sound_txt !== "")
        //         sound_txt = sound_txt + ' / ';
        //       sound_txt += soundData.manufacturer
        //     }
        //   });

        //   row.sound_card_$$_manufacturer = sound_txt;
        //   column.type = 'string';
        //   break;
        // }

        case "sound_card_$$_model": {
          let sound_txt = "";
          if (!soundList)
            break;
          soundList.forEach(sound => {
            const soundData = fixAndParse(sound);

            if (soundData.model) {
              count++;
              if (sound_txt !== "")
                sound_txt = sound_txt + line_separator;
              sound_txt += soundData.model
            }
          });

          row.sound_card_$$_model = sound_txt;
          column.type = 'string';
          break;
        }

        case "sound_card_$$_pnp": {
          let sound_txt = "";
          if (!soundList)
            break;
          soundList.forEach(sound => {
            const soundData = fixAndParse(sound);

            if (soundData.model) {
              count++;
              if (sound_txt !== "")
                sound_txt = sound_txt + line_separator;
              sound_txt += soundData.pnp
            }
          });

          row.sound_card_$$_pnp = sound_txt;
          column.type = 'string';
          break;
        }

        case "sound_card_$$_driver": {
          let sound_txt = "";
          if (!soundList)
            break;
          soundList.forEach(sound => {
            const soundData = fixAndParse(sound);

            if (soundData.model) {
              count++;
              if (sound_txt !== "")
                sound_txt = sound_txt + line_separator;
              sound_txt += soundData.driver
            }
          });

          row.sound_card_$$_driver = sound_txt;
          column.type = 'string';
          break;
        }
        //------------------------------------------------------------


        // hardware - screen
        case "screen_$$_manufacturer": {
          let screen_txt = "";
          if (!screenList)
            break;
          screenList.forEach(screen => {
            const screenData = fixAndParse(screen);

            if (screenData.vendor) {
              count++;
              if (screen_txt !== "")
                screen_txt = screen_txt + line_separator;
              screen_txt += screenData.vendor;
            }
          });

          row.screen_$$_manufacturer = screen_txt;
          column.type = 'string';
          break;
        }

        case "screen_$$_model": {
          let screen_txt = "";
          if (!screenList)
            break;
          screenList.forEach(screen => {
            const screenData = fixAndParse(screen);

            if (screenData.vendor) {
              count++;
              if (screen_txt !== "")
                screen_txt = screen_txt + line_separator;
              screen_txt += screenData.model;
            }
          });

          row.screen_$$_model = screen_txt;
          column.type = 'string';
          break;
        }

        case "screen_$$_size": {
          let screen_txt = "";
          if (!screenList)
            break;
          screenList.forEach(screen => {
            const screenData = fixAndParse(screen);

            if (screenData.vendor) {
              count++;
              if (screen_txt !== "")
                screen_txt = screen_txt + line_separator;
              screen_txt += screenData.size;
            }
          });

          row.screen_$$_size = screen_txt;
          column.type = 'number';
          break;
        }

        case "screen_$$_resolution": {
          let screen_txt = "";
          if (!screenList)
            break;
          screenList.forEach(screen => {
            const screenData = fixAndParse(screen);

            if (screenData.vendor) {
              count++;
              if (screen_txt !== "")
                screen_txt = screen_txt + line_separator;
              screen_txt += (screenData.max_resol_x + " X " + screenData.max_resol_y);
            }
          });

          row.screen_$$_resolution = screen_txt;
          column.type = 'number';
          break;
        }

        case "screen_$$_serial_number": {
          let screen_txt = "";
          if (!screenList)
            break;
          screenList.forEach(screen => {
            const screenData = fixAndParse(screen);

            if (screenData.vendor) {
              count++;
              if (screen_txt !== "")
                screen_txt = screen_txt + line_separator;
              screen_txt += screenData.serial;
            }
          });

          row.screen_$$_serial_number = screen_txt;
          column.type = 'string';
          break;
        }

        case "screen_$$_touch_screen": {
          let screen_txt = "";
          if (!screenList)
            break;
          screenList.forEach(screen => {
            const screenData = fixAndParse(screen);

            if (screenData.vendor) {
              count++;
              if (screen_txt !== "")
                screen_txt = screen_txt + line_separator;
              // screen_txt = (screenData.touch === "1" ? "true" : "false");
              screen_txt = screenData.touch;
            }
          });

          row.screen_$$_touch_screen = screen_txt;
          column.type = 'string';
          break;
        }

        // case "screen_$$_driver": {
        //   let screen_txt = "";
        // if (!screenList)
        //     break;
        //   screenList.forEach(screen => {
        //     screen = screen.replace("\\", "\\\\");
        //     const screenData = fixAndParse(screen);

        //     if (screenData.vendor) {
        //       if (screen_txt !== "")
        //         screen_txt = screen_txt + ' / ';
        //       screen_txt += screenData.driver;
        //     }
        //   });

        //   row.screen_$$_driver = screen_txt;
        //   column.type = 'string';
        //   break;
        // }
        //------------------------------------------------------------


        // hardware - disk_controler
        case "disk_controler_$$_manufacturer": {
          let storageCtrl_txt = "";
          if (!storageCtrlList)
            break;
          storageCtrlList.forEach(storageCtrl => {
            const storageCtrlData = fixAndParse(storageCtrl);

            if (storageCtrlData.manufacturer) {
              count++;
              if (storageCtrl_txt !== "")
                storageCtrl_txt = storageCtrl_txt + line_separator;

              storageCtrl_txt += storageCtrlData.manufacturer;
            }
          });

          row.disk_controler_$$_manufacturer = storageCtrl_txt;
          column.type = 'string';
          break;
        }

        case "disk_controler_$$_model": {
          let storageCtrl_txt = "";
          if (!storageCtrlList)
            break;
          storageCtrlList.forEach(storageCtrl => {
            const storageCtrlData = fixAndParse(storageCtrl);

            if (storageCtrlData.manufacturer) {
              count++;
              if (storageCtrl_txt !== "")
                storageCtrl_txt = storageCtrl_txt + line_separator;

              storageCtrl_txt += storageCtrlData.model;
            }
          });

          row.disk_controler_$$_model = storageCtrl_txt;
          column.type = 'string';
          break;
        }

        case "disk_controler_$$_pnp": {
          let storageCtrl_txt = "";
          if (!storageCtrlList)
            break;
          storageCtrlList.forEach(storageCtrl => {
            const storageCtrlData = fixAndParse(storageCtrl);

            if (storageCtrlData.manufacturer) {
              count++;
              if (storageCtrl_txt !== "")
                storageCtrl_txt = storageCtrl_txt + line_separator;

              storageCtrl_txt += storageCtrlData.pnp;
            }
          });

          row.disk_controler_$$_pnp = storageCtrl_txt;
          column.type = 'string';
          break;
        }

        case "disk_controler_$$_driver": {
          let storageCtrl_txt = "";
          if (!storageCtrlList)
            break;
          storageCtrlList.forEach(storageCtrl => {
            const storageCtrlData = fixAndParse(storageCtrl);

            if (storageCtrlData.manufacturer) {
              count++;
              if (storageCtrl_txt !== "")
                storageCtrl_txt = storageCtrl_txt + line_separator;

              storageCtrl_txt += storageCtrlData.driver;
            }
          });

          row.disk_controler_$$_driver = storageCtrl_txt;
          column.type = 'string';
          break;
        }
        //------------------------------------------------------------


        // hardware - webcam
        // case "webcam_$$_manufacturer": {
        //   let webcam_txt = "";
        //   if (!webcamList)
        //     break;
        //     webcamList.forEach(webcam => {
        //       webcam = webcam.replace("\\", "\\\\");
        //     const webcamData = fixAndParse(webcam);

        //     if (webcamData.manufacturer) {
        //       if (webcam_txt !== "")
        //       webcam_txt = webcam_txt + ' / ';

        //       webcam_txt += webcamData.manufacturer;
        //     }
        //   });

        //   row.webcam_$$_manufacturer = webcam_txt;
        //   column.type = 'string';
        //   break;
        // }

        case "webcam_$$_model": {
          let webcam_txt = "";
          if (!webcamList)
            break;
          webcamList.forEach(webcam => {
            const webcamData = fixAndParse(webcam);

            if (webcamData.model) {
              count++;
              if (webcam_txt !== "")
                webcam_txt = webcam_txt + line_separator;

              webcam_txt += webcamData.model;
            }
          });

          row.webcam_$$_model = webcam_txt;
          column.type = 'string';
          break;
        }

        case "webcam_$$_pnp": {
          let webcam_txt = "";
          if (!webcamList)
            break;
          webcamList.forEach(webcam => {
            const webcamData = fixAndParse(webcam);

            if (webcamData.model) {
              count++;
              if (webcam_txt !== "")
                webcam_txt = webcam_txt + line_separator;

              webcam_txt += webcamData.pnp;
            }
          });

          row.webcam_$$_pnp = webcam_txt;
          column.type = 'string';
          break;
        }

        case "webcam_$$_driver": {
          let webcam_txt = "";
          if (!webcamList)
            break;
          webcamList.forEach(webcam => {
            const webcamData = fixAndParse(webcam);

            if (webcamData.model) {
              count++;
              if (webcam_txt !== "")
                webcam_txt = webcam_txt + line_separator;

              webcam_txt += webcamData.driver;
            }
          });

          row.webcam_$$_driver = webcam_txt;
          column.type = 'string';
          break;
        }
        //------------------------------------------------------------


        // hardware - battery
        case "battery_$$_manufacturer": {
          let battery_txt = "";

          if (!batteryList)
            break;
          batteryList.forEach(battery => {
            const batteryData = fixAndParse(battery);

              if (batteryData.chemistry) {
              count++;
              if (battery_txt !== "")
                battery_txt = battery_txt + line_separator;

              battery_txt += batteryData.vendor;
            }
          });

          row.battery_$$_manufacturer = battery_txt;
          column.type = 'string';
          break;
        }

        case "battery_$$_model": {
          let battery_txt = "";

          if (!batteryList)
            break;
          batteryList.forEach(battery => {
            const batteryData = fixAndParse(battery);

              if (batteryData.chemistry) {
              count++;
              if (battery_txt !== "")
                battery_txt = battery_txt + line_separator;

              battery_txt += batteryData.name;
            }

          });

          row.battery_$$_model = battery_txt;
          column.type = 'string';
          break;
        }

        case "battery_$$_chemistry": {
          let battery_txt = "";

          if (!batteryList)
            break;
          batteryList.forEach(battery => {
            const batteryData = fixAndParse(battery);

              if (batteryData.chemistry) {
              count++;
              if (battery_txt !== "")
                battery_txt = battery_txt + line_separator;

              battery_txt += batteryData.chemistry;
            }

          });

          row.battery_$$_chemistry = battery_txt;
          column.type = 'string';
          break;
        }

        case "battery_$$_designed_capacity": {
          let battery_txt = "";

          if (!batteryList)
            break;
          batteryList.forEach(battery => {
            const batteryData = fixAndParse(battery);

              if (batteryData.chemistry) {
              count++;
              if (battery_txt !== "")
                battery_txt = battery_txt + line_separator;

                if (batteryData.designed_cap === "4294967295" || batteryData.designed_cap === "4026531840")
                  batteryData.designed_cap = "--";

              // battery_txt += batteryData.designed_cap + " mWH";
              battery_txt += batteryData.designed_cap; // + " mWH";
            }

          });

          row.battery_$$_designed_capacity = battery_txt;
          column.type = 'number';
          break;
        }

        case "battery_$$_full_charged_capacity": {
          let battery_txt = "";

          if (!batteryList)
            break;
          batteryList.forEach(battery => {
            const batteryData = fixAndParse(battery);

              if (batteryData.chemistry) {
              count++;
              if (battery_txt !== "")
                battery_txt = battery_txt + line_separator;

                if (batteryData.fullcharged_cap === "4294967295" || batteryData.fullcharged_cap === "4026531840")
                  batteryData.fullcharged_cap = "--";

              battery_txt += batteryData.fullcharged_cap; // + " mWH";
            }

          });

          row.battery_$$_full_charged_capacity = battery_txt;
          column.type = 'number';
          break;
        }

        case "battery_$$_rate": {
          let battery_txt = "";

          if (!batteryList)
            break;
          batteryList.forEach(battery => {

            const batteryData = fixAndParse(battery);

              if (batteryData.chemistry) {
              count++;
              if (battery_txt !== "")
                battery_txt = battery_txt + line_separator;

              battery_txt += batteryData.rate; // + " mW";
            }

          });

          row.battery_$$_rate = battery_txt;
          column.type = 'number';
          break;
        }

        case "battery_$$_power_state": {
          let battery_txt = "";

          if (!batteryList)
            break;
          batteryList.forEach(battery => {
            const batteryData = fixAndParse(battery);

              if (batteryData.chemistry) {
              count++;
              if (battery_txt !== "")
                battery_txt = battery_txt + line_separator;

              battery_txt += batteryData.powerstate;
            }

          });

          row.battery_$$_power_state = battery_txt;
            column.type = 'singleSelect';
            column.valueOptions = [
              'POWER_ON_LINE NOT_CHARGING',
              'DISCHARGING',
              'POWER_ON_LINE & DISCHARGING',
              'CHARGING WHEREAS NOT POWER_ON_LINE',
              'POWER_ON_LINE & CHARGING',
              'CHARGING & DISCHARGING',
              'POWER_ON_LINE & CHARGING & DISCHARGING',
              'NOT POWER_ON_LINE & NOT DISCHARGING, LOW_CHARGE',
              'POWER_ON_LINE & NOT_CHARGING, LOW_CHARGE',
              'DISCHARGING, LOW_CHARGE',
              'POWER_ON_LINE & DISCHARGING, LOW_CHARGE',
              'CHARGING WHEREAS NOT POWER_ON_LINE, LOW_CHARGE',
              'POWER_ON_LINE & CHARGING, LOW_CHARGE',
              'CHARGING & DISCHARGING, LOW_CHARGE',
              'POWER_ON_LINE & CHARGING & DISCHARGING, LOW_CHARG'
            ]
          break;
        }

        case "battery_$$_current_capacity": {
          let battery_txt = "";

          if (!batteryList)
            break;
          batteryList.forEach(battery => {
            const batteryData = fixAndParse(battery);
              battery = battery.replaceAll("\n", "-");

              if (batteryData.chemistry) {
              count++;
              if (battery_txt !== "")
                battery_txt = battery_txt + line_separator;

              battery_txt += batteryData.current_cap; //  + " mWH";
            }
          });

          row.battery_$$_current_capacity = battery_txt;
          column.type = 'number';
          break;
        }

        case "battery_$$_voltage": {
          let battery_txt = "";

          if (!batteryList)
            break;
          batteryList.forEach(battery => {
            const batteryData = fixAndParse(battery);

              if (batteryData.chemistry) {
              count++;
              if (battery_txt !== "")
                battery_txt = battery_txt + line_separator;

              battery_txt += (batteryData.voltage); // / 1000) + " V";
            }
          });

          row.battery_$$_voltage = battery_txt;
          column.type = 'number';
          break;
        }

        case "battery_$$_cycle_count": {
          let battery_txt = "";

          if (!batteryList)
            break;
          batteryList.forEach(battery => {
            const batteryData = fixAndParse(battery);

              if (batteryData.chemistry) {
              count++;
              if (battery_txt !== "")
                battery_txt = battery_txt + line_separator;

              battery_txt += batteryData.cyclecount;
            }
          });

          row.battery_$$_cycle_count = battery_txt;
          column.type = 'number';
          break;
        }

        case "battery_$$_serial": {
          let battery_txt = "";
          if (!batteryList)
            break;
          batteryList.forEach(battery => {
            const batteryData = fixAndParse(battery);

              if (batteryData.chemistry) {
              count++;
              if (battery_txt !== "")
                battery_txt = battery_txt + line_separator;

              battery_txt += batteryData.serial;
            }
          });

          row.battery_$$_serial = battery_txt;
          column.type = 'string';
          break;
        }

        case "battery_$$_wear_level": {
          let battery_txt = "";

          if (!batteryList)
            break;
          batteryList.forEach(battery => {
            const batteryData = fixAndParse(battery);

              if (batteryData.chemistry) {
              count++;
              if (battery_txt !== "")
                battery_txt = battery_txt + line_separator;

              // if (parseInt(batteryData.wear_level, 10) > 100)
              //   battery_txt += "-- %";
              // else
                if (batteryData.wear_level === "4294967295" || batteryData.wear_level === "4026531840")
                  batteryData.wear_level = "--";

              battery_txt += (batteryData.wear_level); // + " %";
            }
          });

          row.battery_$$_wear_level = battery_txt;
          column.type = 'number';
          break;
        }

          case "battery_$$_health_level": {
            let battery_txt = "";

            if (!batteryList)
              break;
            batteryList.forEach(battery => {
              const batteryData = fixAndParse(battery);

              if (batteryData.chemistry) {
                count++;
                if (battery_txt !== "")
                  battery_txt = battery_txt + line_separator;
                battery_txt += (100 - batteryData.wear_level); // + " %";
              }
            });

            row.battery_$$_health_level = battery_txt;
            column.type = 'number';
            break;
          }
        //------------------------------------------------------------


        // hardware - cddvd
        case "optical_$$_manufacturer": {
          let cddvd_txt = "";

          if (!cddvdList)
            break;

          cddvdList.forEach(cddvd => {
            const cddvdData = fixAndParse(cddvd);

            if (cddvdData.manufacturer) {
              count++;
              if (cddvd_txt !== "")
                cddvd_txt = cddvd_txt + line_separator;

              cddvd_txt += cddvdData.manufacturer;
            }
          });

          row.optical_$$_manufacturer = cddvd_txt;
          column.type = 'string';
          break;
        }

        case "optical_$$_model": {
          let cddvd_txt = "";

          if (!cddvdList)
            break;
          cddvdList.forEach(cddvd => {
            const cddvdData = fixAndParse(cddvd);

            if (cddvdData.manufacturer) {
              count++;
              if (cddvd_txt !== "")
                cddvd_txt = cddvd_txt + line_separator;

              cddvd_txt += cddvdData.model;
            }
          });

          row.optical_$$_model = cddvd_txt;
          column.type = 'string';
          break;
        }

        case "optical_$$_firmware": {
          let cddvd_txt = "";

          if (!cddvdList)
            break;
          cddvdList.forEach(cddvd => {
            const cddvdData = fixAndParse(cddvd);

            if (cddvdData.manufacturer) {
              count++;
              if (cddvd_txt !== "")
                cddvd_txt = cddvd_txt + line_separator;

              cddvd_txt += cddvdData.firmware;
            }
          });

          row.optical_$$_firmware = cddvd_txt;
          column.type = 'string';
          break;
        }

        case "optical_$$_media": {
          let cddvd_txt = "";

          if (!cddvdList)
            break;
          cddvdList.forEach(cddvd => {
            const cddvdData = fixAndParse(cddvd);

            if (cddvdData.manufacturer) {
              count++;
              if (cddvd_txt !== "")
                cddvd_txt = cddvd_txt + line_separator;

              cddvd_txt += cddvdData.media;
            }
          });

          row.optical_$$_media = cddvd_txt;
          column.type = 'string';
          break;
        }
        //------------------------------------------------------------


        // Other
        case "other_$$_bluetooth": {
          row.other_$$_bluetooth = deployment.bluetooth;
            column.type = 'boolean';
          break;
        }

        case "other_$$_biometrics": {
          row.other_$$_biometrics = deployment.biometrics;
            column.type = 'boolean';
          break;
        }

        case "other_$$_cardreader": {
          row.other_$$_cardreader = deployment.cardreader;
            column.type = 'boolean';
          break;
        }
        //------------------------------------------------------------


        // device wipe - WIPED
        case "device_wipe_$$_result": {
            let text;
            text = deployment.module_1126_result;

            const smartExtraData = deployment.module_1126_closing_code;
            if (smartExtraData == 13) {
              const smartExtraDataText = t('reporting.data.smart_threshold_exceeded');
              text = text + "_$$_" + smartExtraDataText;
            }
            row.device_wipe_$$_result = text;

            column.type = 'singleSelect';
            column.valueOptions = [
              'PASSED',
              'FAILED',
              'WARNING',
              'CANCEL',
              'ABORTED',
              'SKIPPED',
              'INTERRUPTED',
              'WARNING - REMOVED',
              'ONGOING'
            ]

          break;
        }

          case "device_wipe_$$_nb_disks_wiped": {
            row.device_wipe_$$_nb_disks_wiped = deployment.module_1126_count;
            column.type = 'number';
            break;
          }

          // case "device_wipe_$$_closing_code": {
          //   row.device_wipe_$$_closing_code = deployment.module_1126_closing_code;
          //   column.type = 'string';
          //   break;
          // }

        // disk wipe - WIPED
        case "disk_wipe_$$_result": {
          let disk_txt = "";
          if (!wipedList)
            break;
          wipedList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.result) {
                // console.log("3954 - diskData.result=", diskData.result);
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
                //disk_txt += diskData.result

                if (diskData.result === "")
                  disk_txt += " ";
                else
              disk_txt += diskData.result
            }
          });

          row.disk_wipe_$$_result = disk_txt;
          column.type = 'string';
            // console.log("3964 - row.disk_wipe_$$_result =", row.disk_wipe_$$_result );
          break;
        }

        case "disk_wipe_$$_algorithm": {
          let disk_txt = "";
          if (!wipedList)
            break;
          wipedList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.result) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;

                if (diskData.algorithm === "")
                  disk_txt += " ";
                else
              disk_txt += diskData.algorithm
            }
          });

          row.disk_wipe_$$_algorithm = disk_txt;
          column.type = 'string';
          break;
        }

        case "disk_wipe_$$_eraser_rounds": {
          let disk_txt = "";
          if (!wipedList)
            break;
          wipedList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.result) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;

                if (diskData.eraser_rounds === "")
                  disk_txt += " ";
                else
              disk_txt += diskData.eraser_rounds
            }
          });

          row.disk_wipe_$$_eraser_rounds = disk_txt;
          column.type = 'number';
          break;
        }

        case "disk_wipe_$$_time": {
          let disk_txt = "";
          if (!wipedList)
            break;
          wipedList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.result) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
                //disk_txt += diskData.time

                if (diskData.time === "")
                  disk_txt += " ";
                else
              disk_txt += diskData.time
            }
          });

          row.disk_wipe_$$_time = disk_txt;
          column.type = 'string';
          break;
        }

        case "disk_wipe_$$_manufacturer": {
          let disk_txt = "";
          if (!wipedList)
            break;

          wipedList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.result) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
                //disk_txt += diskData.manufacturer

                if (diskData.manufacturer === "")
                  disk_txt += " ";
                else
              disk_txt += diskData.manufacturer
            }
          });
          row.disk_wipe_$$_manufacturer = disk_txt;
          column.type = 'string';
          break;
        }

        case "disk_wipe_$$_model": {
          let disk_txt = "";
          if (!wipedList)
            break;

          wipedList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.result) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
                //disk_txt += diskData.Model

                if (diskData.Model === "")
                  disk_txt += " ";
                else
                  disk_txt += diskData.Model
            }
          });
          row.disk_wipe_$$_model = disk_txt;
          column.type = 'string';
          break;
        }

        case "disk_wipe_$$_advertized_capacity": {
          let disk_txt = "";
          if (!wipedList)
            break;

          wipedList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.result) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
                //disk_txt += diskData.size_commercial

                if (diskData.size_commercial === "")
                  disk_txt += " ";
                else
              disk_txt += diskData.size_commercial
            }
          });

          row.disk_wipe_$$_advertized_capacity = disk_txt;
          column.type = 'number';
          break;
        }

        case "disk_wipe_$$_serial": {
          let disk_txt = "";
          if (!wipedList)
            break;

          wipedList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.result) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
                //disk_txt += diskData.serial

                if (diskData.serial === "")
                  disk_txt += " ";
                else
              disk_txt += diskData.serial

            }
          });
          row.disk_wipe_$$_serial = disk_txt;
          column.type = 'string';
          break;
        }

        case "disk_wipe_$$_health": {
          let disk_txt = "";
          if (!wipedList)
            break;

          wipedList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.result) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
                //disk_txt += diskData.health

                if (diskData.health === "")
                  disk_txt += " ";
                else
              disk_txt += diskData.health
            }
          });
          row.disk_wipe_$$_health = disk_txt;
            column.type = 'singleSelect';
            column.valueOptions = [
              'UNKNOWN',
              'GOOD',
              'BAD',
              'WARNING'
            ]
          break;
        }

        case "disk_wipe_$$_uuid": {
          let disk_txt = "";
          if (!wipedList)
            break;

          wipedList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.result && diskData.uuid) {
              const regex = /(?:Disk)([0-9]+)(?: - )(.+)/i;  // 
              const items = diskData.uuid.match(regex);

              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
              disk_txt += items ? items[2] : diskData.uuid;
            }
          });
          row.disk_wipe_$$_uuid = disk_txt;
          column.type = 'string';
          break;
        }

        // new from 8293 - 23200405
        case "disk_wipe_$$_bps": {
          let disk_txt = "";
          if (!wipedList)
            break;

          wipedList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.result) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
                //disk_txt += diskData.BPS

                if (diskData.BPS === "")
                  disk_txt += " ";
                else
                  disk_txt += diskData.BPS
            }
          });

          row.disk_wipe_$$_bps = disk_txt;
          column.type = 'number';
          break;
        }

        case "disk_wipe_$$_customer_data": {
          let disk_txt = "";
          if (!wipedList)
            break;

          wipedList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.result && diskData.customer_data) {
              const regex = /(?:Disk)([0-9]+)(?: - )(.+)/i;  // 
              const items = diskData.customer_data.match(regex);

              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
              disk_txt += items ? items[2] : diskData.customer_data;
            }
          });
          row.disk_wipe_$$_customer_data = disk_txt;
          column.type = 'string';
          break;
        }

        case "disk_wipe_$$_reallocated_sectors": {
          let disk_txt = "";
          if (!wipedList)
            break;

          wipedList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.result) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
                //disk_txt += diskData.reallocated_sectors

                if (diskData.reallocated_sectors === "")
                  disk_txt += " ";
                else
              disk_txt += diskData.reallocated_sectors
            }
          });

          row.disk_wipe_$$_reallocated_sectors = disk_txt;
          column.type = 'number';
          break;
        }

        case "disk_wipe_$$_power_on_hours": {
          let disk_txt = "";
          if (!wipedList)
            break;

          wipedList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.result) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
                //disk_txt += diskData.power_on_hours

                if (diskData.power_on_hours === "")
                  disk_txt += " ";
                else
              disk_txt += diskData.power_on_hours
            }
          });

          row.disk_wipe_$$_power_on_hours = disk_txt;
          column.type = 'number';
          break;
        }

        case "disk_wipe_$$_reported_uncorrectable_errors": {
          let disk_txt = "";
          if (!wipedList)
            break;

          wipedList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.result) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
                //disk_txt += diskData.reported_uncorrectable_errors

                if (diskData.reported_uncorrectable_errors === "")
                  disk_txt += " ";
                else
              disk_txt += diskData.reported_uncorrectable_errors
            }
          });

          row.disk_wipe_$$_reported_uncorrectable_errors = disk_txt;
          column.type = 'number';
          break;
        }

        case "disk_wipe_$$_command_timeout": {
          let disk_txt = "";
          if (!wipedList)
            break;

          wipedList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.result) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
                //disk_txt += diskData.command_timeout

                if (diskData.command_timeout === "")
                  disk_txt += " ";
                else
              disk_txt += diskData.command_timeout
            }
          });

          row.disk_wipe_$$_command_timeout = disk_txt;
          column.type = 'number';
          break;
        }

        case "disk_wipe_$$_current_pending_sector_count": {
          let disk_txt = "";
          if (!wipedList)
            break;

          wipedList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.result) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
                //disk_txt += diskData.current_pending_sector_count

                if (diskData.current_pending_sector_count === "")
                  disk_txt += " ";
                else
              disk_txt += diskData.current_pending_sector_count
            }
          });

          row.disk_wipe_$$_current_pending_sector_count = disk_txt;
          column.type = 'number';
          break;
        }

        case "disk_wipe_$$_offline_uncorrectable": {
          let disk_txt = "";
          if (!wipedList)
            break;

          wipedList.forEach(disk => {
            const diskData = fixAndParse(disk);

            if (diskData.result) {
              count++;
              if (disk_txt !== "")
                disk_txt = disk_txt + line_separator;
                //disk_txt += diskData.Offline_Uncorrectable

                if (diskData.Offline_Uncorrectable === "")
                  disk_txt += " ";
                else
                  disk_txt += diskData.Offline_Uncorrectable
            }
          });

          row.disk_wipe_$$_offline_uncorrectable = disk_txt;
          column.type = 'number';
          break;
        }

          case "disk_wipe_$$_disk_health_percentage": {
            let disk_txt = "";
            if (!wipedList)
              break;

            wipedList.forEach(disk => {
              const diskData = fixAndParse(disk);

              if (diskData.result) {
                count++;
                if (disk_txt !== "")
                  disk_txt = disk_txt + line_separator;
                //disk_txt += diskData.disk_health_percentage;

                if (diskData.disk_health_percentage === "")
                  disk_txt += " ";
                else
                  disk_txt += diskData.disk_health_percentage
              }
            });
            row.disk_wipe_$$_disk_health_percentage = disk_txt;
            column.type = 'string';
            break;
          }

          case "disk_wipe_$$_rpm": {
            let disk_txt = "";
            if (!wipedList)
              break;

            wipedList.forEach(disk => {
              const diskData = fixAndParse(disk);

              if (diskData.result) {
                count++;
                if (disk_txt !== "")
                  disk_txt = disk_txt + line_separator;
                //disk_txt += diskData.disk_rpm

                if (diskData.disk_rpm === "")
                  disk_txt += " ";
                else
                disk_txt += diskData.disk_rpm
              }
            });

            row.disk_wipe_$$_rpm = disk_txt;
            column.type = 'number';
            break;
          }

          case "disk_wipe_$$_bus": {
            let disk_txt = "";
            if (!wipedList)
              break;

            wipedList.forEach(disk => {
              const diskData = fixAndParse(disk);

              if (diskData.result) {
                count++;
                if (disk_txt !== "")
                  disk_txt = disk_txt + line_separator;
                //disk_txt += diskData.disk_rpm

                if (diskData.disk_bus === "")
                  disk_txt += " ";
                else
                  disk_txt += diskData.disk_bus
              }
            });

            row.disk_wipe_$$_bus = disk_txt;
            column.type = 'string';
            break;
          }

          case "disk_wipe_$$_path": {
            let disk_txt = "";
            if (!wipedList)
              break;

            wipedList.forEach(disk => {
              const diskData = fixAndParse(disk);

              if (diskData.result) {
                count++;
                if (disk_txt !== "")
                  disk_txt = disk_txt + line_separator;
                //disk_txt += diskData.disk_rpm

                if (diskData.disk_path === "")
                  disk_txt += " ";
                else
                  disk_txt += diskData.disk_path
              }
            });

            row.disk_wipe_$$_path = disk_txt;
            column.type = 'string';
            break;
          }


          case "disk_wipe_$$_ppid": {
            let disk_txt = "";
            if (!wipedList)
              break;

            wipedList.forEach(disk => {
              const diskData = fixAndParse(disk);

              if (diskData.result) {
                count++;
                if (disk_txt !== "")
                  disk_txt = disk_txt + line_separator;
                //disk_txt += diskData.disk_rpm

                if (diskData.disk_ppid === "")
                  disk_txt += " ";
                else
                  disk_txt += diskData.disk_ppid
              }
            });
            row.disk_wipe_$$_ppid = disk_txt;
            column.type = 'string';
            break;
          }



          case "disk_wipe_$$_computed_health": {
            let disk_txt = "";
            if (!extraDiskHealthList)
              break;

            if (!wipedList)
              break;

            wipedList.forEach(disk => {
              const diskData = fixAndParse(disk);
              extraDiskHealthList.forEach(extraDiskHealth => {
                const extraDiskHealthData = fixAndParse(extraDiskHealth);

                const regex = /(?<=ext_disk_health\[)[^\]]*(?=\])/i;
                const items = extraDiskHealthData.xtra_desc && extraDiskHealthData.xtra_desc.match(regex);

                if (items && items[0] && items[0] == diskData.serial) {
                  count++;
                  if (disk_txt !== "")
                    disk_txt = disk_txt + line_separator;
                  disk_txt += extraDiskHealthData.xtra_value
                }
              });
            });

            row.disk_wipe_$$_computed_health = disk_txt;
            column.type = 'number';
            break;
          }


          case "disk_wipe_$$_computed_perf": {
            let disk_txt = "";
            if (!extraDiskPerfList)
              break;

            if (!wipedList)
              break;

            wipedList.forEach(disk => {
              const diskData = fixAndParse(disk);

              extraDiskPerfList.forEach(extraDiskPerf => {
                const extraDiskPerfData = fixAndParse(extraDiskPerf);

                const regex = /(?<=ext_disk_perf\[)[^\]]*(?=\])/i;
                const items = extraDiskPerfData.xtra_desc && extraDiskPerfData.xtra_desc.match(regex);

                if (items && items[0] && items[0] == diskData.serial) {
                  count++;
                  if (disk_txt !== "")
                    disk_txt = disk_txt + line_separator;
                  disk_txt += extraDiskPerfData.xtra_value
                }
              });
            });

            row.disk_wipe_$$_computed_perf = disk_txt;
            column.type = 'number';
            break;
          }

          case "disk_wipe_$$_order": {
            let disk_txt = "";
            if (!wipedList)
              break;

            wipedList.forEach(disk => {
              const diskData = fixAndParse(disk);

              if (diskData.result) {
                count++;
                if (disk_txt !== "")
                  disk_txt = disk_txt + line_separator;

                const regex = /^([A-Za-z0-9]+)(?:_)([A-Za-z0-9]+)$/im;  //


                const orderLot = diskData.disk_orderLot && diskData.disk_orderLot.match(regex);

                // if (diskData.disk_orderLot) {
                //   console.log("6162 - diskData.disk_orderLot=", diskData.disk_orderLot);
                //   console.log("6163 - orderLot=", orderLot);
                // }

                if (orderLot && orderLot[1])
                  disk_txt += orderLot[1]
                else
                  disk_txt += " ";
              }
            });

            row.disk_wipe_$$_order = disk_txt;
            column.type = 'string';
            break;
          }

          case "disk_wipe_$$_lot": {
            let disk_txt = "";
            if (!wipedList)
              break;

            wipedList.forEach(disk => {
              const diskData = fixAndParse(disk);

              if (diskData.result) {
                count++;
                if (disk_txt !== "")
                  disk_txt = disk_txt + line_separator;

                const regex = /^([A-Za-z]+)_([A-Za-z]+)$/im;  // 
                const orderLot = diskData.disk_orderLot && diskData.disk_orderLot.match(regex);

                if (orderLot && orderLot[2])
                  disk_txt += orderLot[2]
                else
                  disk_txt += " ";
              }
            });

            row.disk_wipe_$$_lot = disk_txt;
            column.type = 'string';
            break;
          }
        //------------------------------------------------------------


        // diagnostic
        case "diag_general_$$_global_result": {
          row.diag_general_$$_global_result = deployment.module_1136_result;
            column.type = 'singleSelect';
            column.valueOptions = [
              'PASSED',
              'FAILED',
              'WARNING',
              'CANCEL',
              'ABORTED',
              'SKIPPED',
              'INTERRUPTED',
              'WARNING - REMOVED',
              'ONGOING'
            ]

          break;
        }

        case "diag_general_$$_nb_tests_run": {
          let tests_calc = 0;
          if (!testsList)
            break;
          testsList.forEach(test => {
            tests_calc++;
          });

          row.diag_general_$$_nb_tests_run = tests_calc;
          column.type = 'number';
          break;
        }

        case "diag_general_$$_nb_tests_passed": {
          let tests_calc = 0;
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);
            if (testData.test_result === "0")
              tests_calc++;
          });

          row.diag_general_$$_nb_tests_passed = tests_calc;
          column.type = 'number';
          break;
        }

        case "diag_general_$$_nb_tests_failed": {
          let tests_calc = 0;
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);
            if (testData.test_result === "1")
              tests_calc++;
          });

          row.diag_general_$$_nb_tests_failed = tests_calc;
          column.type = 'number';
          break;
        }

        case "diag_general_$$_nb_tests_skipped": {
          let tests_calc = 0;
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);
            if (testData.test_result === "2")
              tests_calc++;
          });

          row.diag_general_$$_nb_tests_skipped = tests_calc;
          column.type = 'number';
          break;
        }

        case "diag_general_$$_list_tests_failed": {
          let tests_txt = "";
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);

            // console.log("4166 - testData=", testData);

            if (testData.test_result === "1") {
              const found = diag_code_ids.find(element =>
                element.id === testData.test_id);

              if (found) {
                const catName = t(`reporting.columns.${found.category}.sub_title`);
                let testName = t(`reporting.columns.${found.category}.${found.test}`);

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    testName = testName + " (" + skipReasonText + ")";
                  }
                }

                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += catName.toUpperCase() + ' - ' + testName;
              }
                // else
                //   console.log("2674 - testData=", testData);
            }
          });

          row.diag_general_$$_list_tests_failed = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_general_$$_list_tests_skipped": {
          let tests_txt = "";
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);
            if (testData.test_result === "2") {

              const found = diag_code_ids.find(element =>
                element.id === testData.test_id);

              if (found) {
                const catName = t(`reporting.columns.${found.category}.sub_title`);
                let testName = t(`reporting.columns.${found.category}.${found.test}`);

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    testName = testName + " (" + skipReasonText + ")";
                  }
                }

                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += catName.toUpperCase() + ' - ' + testName;
              }
                // else
                //   console.log("4633 - testData=", testData);

        //       const found = diag_code_ids.find(element =>
        //         element.id === testData.test_id);

        //       if (found) {
        //         const catName = t(`reporting.columns.${found.category}.sub_title`);
        //         const testName = t(`reporting.columns.${found.category}.${found.test}`);

        //         const skipReason = t(`skip_reason.${testData.test_skipped_reason}`);

        //         count++;
        //         if (tests_txt !== "")
        //           tests_txt = tests_txt + line_separator;
        //         tests_txt += catName.toUpperCase() + ' - ' + testName + ' (' + skipReason + ')';
        //       }
        //       else
        //         console.log("2705 - testData=", testData);
            }
          });

          row.diag_general_$$_list_tests_skipped = tests_txt;
          column.type = 'string';
          break;
        }
        //------------------------------------------------------------


        // diagnostics CPU
        case "diag_cpu_$$_full_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "500") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_cpu_$$_full_test = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_cpu_$$_full_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "500") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_cpu_$$_full_test = tests_txt;
          column.type = 'string';
          break;
        }



        case "diag_cpu_$$_general_purpose_instructions": {
          let tests_txt = "";
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "501") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_cpu_$$_general_purpose_instructions = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_cpu_$$_general_purpose_instructions": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "501") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_cpu_$$_general_purpose_instructions = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_cpu_$$_floating_point_unit_instructions": {
          let tests_txt = "";
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "502") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_cpu_$$_floating_point_unit_instructions = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_cpu_$$_floating_point_unit_instructions": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "502") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_cpu_$$_floating_point_unit_instructions = tests_txt;
          column.type = 'string';
          break;
        }
        

        case "diag_cpu_$$_prime_number_test": {
          let tests_txt = "";
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "503") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_cpu_$$_prime_number_test = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_cpu_$$_prime_number_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "503") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_cpu_$$_prime_number_test = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_cpu_$$_maximum_heat": {
          let tests_txt = "";
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "504") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_cpu_$$_maximum_heat = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_cpu_$$_maximum_heat": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "504") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_cpu_$$_maximum_heat = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_cpu_$$_mmx": {
          let tests_txt = "";
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "505") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_cpu_$$_mmx = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_cpu_$$_mmx": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "505") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_cpu_$$_mmx = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_cpu_$$_sse": {
          let tests_txt = "";
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "506") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_cpu_$$_sse = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_cpu_$$_sse": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "506") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_cpu_$$_sse = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_cpu_$$_sse2": {
          let tests_txt = "";
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "507") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_cpu_$$_sse2 = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_cpu_$$_sse2": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "507") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_cpu_$$_sse2 = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_cpu_$$_sse3": {
          let tests_txt = ""
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "508") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_cpu_$$_sse3 = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_cpu_$$_sse3": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "508") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_cpu_$$_sse3 = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_cpu_$$_aes": {
          let tests_txt = "";
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "509") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_cpu_$$_aes = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_cpu_$$_aes": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "509") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_cpu_$$_aes = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_cpu_$$_sse41": {
          let tests_txt = "";
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "510") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_cpu_$$_sse41 = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_cpu_$$_sse41": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "510") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_cpu_$$_sse41 = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_cpu_$$_sse42": {
          let tests_txt = "";
          if (!testsList)
            break;
          testsList.forEach(test => {
            test = test.replaceAll(String.fromCharCode(3), '*3*');

            const testData = fixAndParse(test);

            if (testData.test_id === "511") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_cpu_$$_sse42 = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_cpu_$$_sse42": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "511") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_cpu_$$_sse42 = tests_txt;
          column.type = 'string';
          break;
        }

        
        case "diag_cpu_$$_sse4a": {
          let tests_txt = "";
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "512") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_cpu_$$_sse4a = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_cpu_$$_sse4a": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "512") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_cpu_$$_sse4a = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_cpu_$$_avx": {
          let tests_txt = "";
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "513") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_cpu_$$_avx = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_cpu_$$_avx": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "513") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_cpu_$$_avx = tests_txt;
          column.type = 'string';
          break;
        }


          case "diag_cpu_$$_fma3": {
            let tests_txt = "";
            if (!testsList)
              break;
            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "514") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_cpu_$$_fma3 = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_cpu_$$_fma3": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "514") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_cpu_$$_fma3 = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_cpu_$$_apple_cpu_test": {
            let tests_txt = "";
            if (!testsList)
              break;
            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "519") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_cpu_$$_apple_cpu_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_cpu_$$_apple_cpu_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "519") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_cpu_$$_apple_cpu_test = tests_txt;
            column.type = 'string';
            break;
          }

        //------------------------------------------------------------

        // diagnostics Memory
        case "diag_memory_$$_ram": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "540") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_memory_$$_ram = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_memory_$$_ram": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "540") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_memory_$$_ram = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_memory_$$_ram_multi_process_torture": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "541") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }

              // console.log("2959 - ....", tests_txt);
            }
          });
          row.diag_memory_$$_ram_multi_process_torture = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_memory_$$_ram_multi_process_torture": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "541") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_memory_$$_ram_multi_process_torture = tests_txt;
          column.type = 'string';
          break;
        }


          case "diag_memory_$$_apple_memory_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "549") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }

                // console.log("2959 - ....", tests_txt);
              }
            });
            row.diag_memory_$$_apple_memory_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_memory_$$_apple_memory_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "549") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_memory_$$_apple_memory_test = tests_txt;
            column.type = 'string';
            break;
          }
        //------------------------------------------------------------

        // diagnostics Storage
        case "diag_storage_$$_hdd_short_smart_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "10") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_storage_$$_hdd_short_smart_test = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_storage_$$_hdd_short_smart_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "10") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_storage_$$_hdd_short_smart_test = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_storage_$$_hdd_long_smart_test": {
          let tests_txt = "";
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "11") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_storage_$$_hdd_long_smart_test = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_storage_$$_hdd_long_smart_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "11") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_storage_$$_hdd_long_smart_test = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_storage_$$_hdd_linear_read_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "12") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_storage_$$_hdd_linear_read_test = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_storage_$$_hdd_linear_read_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "12") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_storage_$$_hdd_linear_read_test = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_storage_$$_hdd_random_read_test": {
          let tests_txt = "";
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "13") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_storage_$$_hdd_random_read_test = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_storage_$$_hdd_random_read_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "13") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_storage_$$_hdd_random_read_test = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_storage_$$_smart_attributes": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "14") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_storage_$$_smart_attributes = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_storage_$$_smart_attributes": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "14") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_storage_$$_smart_attributes = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_storage_$$_hdd_smart_status": {
          let tests_txt = "";
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "15") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_storage_$$_hdd_smart_status = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_storage_$$_hdd_smart_status": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "15") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_storage_$$_hdd_smart_status = tests_txt;
          column.type = 'string';
          break;
        }


          case "diag_storage_$$_apple_storage_test": {
            let tests_txt = "";
            if (!testsList)
              break;
            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "19") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_storage_$$_apple_storage_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_storage_$$_apple_storage_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "19") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_storage_$$_apple_storage_test = tests_txt;
            column.type = 'string';
            break;
          }


        case "diag_storage_$$_optical_drive_read_test": {
          let tests_txt = "";
          if (!testsList)
            break;
          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "40") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_storage_$$_optical_drive_read_test = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_storage_$$_optical_drive_read_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "40") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_storage_$$_optical_drive_read_test = tests_txt;
          column.type = 'string';
          break;
        }
        //------------------------------------------------------------

        // diagnostics Mainboard
        case "diag_mainboard_$$_usb_ports": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "120") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_mainboard_$$_usb_ports = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_mainboard_$$_usb_ports": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "120") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_mainboard_$$_usb_ports = tests_txt;
          column.type = 'string';
          break;
        }

          case "diag_mainboard_$$_apple_usb_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "128") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_mainboard_$$_apple_usb_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_mainboard_$$_apple_usb_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "128") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_mainboard_$$_apple_usb_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_mainboard_$$_apple_thunderbolt_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "129") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_mainboard_$$_apple_thunderbolt_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_mainboard_$$_apple_thunderbolt_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "129") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_mainboard_$$_apple_thunderbolt_test = tests_txt;
            column.type = 'string';
            break;
          }
        //------------------------------------------------------------

        // diagnostics Video adapter
        // case "diag_video_adapter_$$_gpu_test": {
        //   let tests_txt = "";
        //   if (!testsList)
        //     break;

        //   testsList.forEach(test => {
        //     const testData = fixAndParse(test);

        //     if (testData.test_id === "520") {        // => NOT USED
        //       count++;
        //       if (tests_txt !== "")
        //         tests_txt = tests_txt + line_separator;
        //       tests_txt += testData.test_result
        //     }
        //   });
        //   row.diag_video_adapter_$$_gpu_test = tests_txt;
        //   column.type = 'string';
        //   break;
        // }

        case "diag_video_adapter_$$_2d_local_video_memory": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "521") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_video_adapter_$$_2d_local_video_memory = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_video_adapter_$$_2d_local_video_memory": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "521") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_video_adapter_$$_2d_local_video_memory = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_video_adapter_$$_2d_all_available_memory": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "522") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_video_adapter_$$_2d_all_available_memory = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_video_adapter_$$_2d_all_available_memory": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "522") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_video_adapter_$$_2d_all_available_memory = tests_txt;
          column.type = 'string';
          break;
        }
        

        case "diag_video_adapter_$$_2d_lines_and_bitmaps": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "523") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_video_adapter_$$_2d_lines_and_bitmaps = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_video_adapter_$$_2d_lines_and_bitmaps": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "523") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_video_adapter_$$_2d_lines_and_bitmaps = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_video_adapter_$$_2d_emc_scrolling_characters": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "524") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_video_adapter_$$_2d_emc_scrolling_characters = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_video_adapter_$$_2d_emc_scrolling_characters": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "524") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_video_adapter_$$_2d_emc_scrolling_characters = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_video_adapter_$$_2d_emc_reference_test_pattern": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "525") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_video_adapter_$$_2d_emc_reference_test_pattern = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_video_adapter_$$_2d_emc_reference_test_pattern": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "525") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_video_adapter_$$_2d_emc_reference_test_pattern = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_video_adapter_$$_3d": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "526") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_video_adapter_$$_3d = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_video_adapter_$$_3d": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "526") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_video_adapter_$$_3d = tests_txt;
          column.type = 'string';
          break;
        }



          case "diag_video_adapter_$$_advanced_GPU_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "527") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_video_adapter_$$_advanced_GPU_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_video_adapter_$$_advanced_GPU_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "527") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_video_adapter_$$_advanced_GPU_test = tests_txt;
            column.type = 'string';
            break;
          }


          case "diag_video_adapter_$$_gpgpu": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "528") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_video_adapter_$$_gpgpu = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_video_adapter_$$_gpgpu": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "528") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_video_adapter_$$_gpgpu = tests_txt;
            column.type = 'string';
            break;
          }


          case "diag_video_adapter_$$_apple_gpu_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "539") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_video_adapter_$$_apple_gpu_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_video_adapter_$$_apple_gpu_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "539") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_video_adapter_$$_apple_gpu_test = tests_txt;
            column.type = 'string';
            break;
          }
        //------------------------------------------------------------

        // diagnostics network
        case "diag_network_$$_wired_lan": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "50") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_network_$$_wired_lan = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_network_$$_wired_lan": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "50") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_network_$$_wired_lan = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_network_$$_wifi_wan": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "51") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_network_$$_wifi_wan = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_network_$$_wifi_wan": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "51") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_network_$$_wifi_wan = tests_txt;
          column.type = 'string';
          break;
        }

          case "diag_network_$$_apple_wired": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "57") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_network_$$_apple_wired = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_network_$$_apple_wired": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "57") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_network_$$_apple_wired = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_network_$$_apple_wifi": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "58") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_network_$$_apple_wifi = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_network_$$_apple_wifi": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "58") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_network_$$_apple_wifi = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_network_$$_apple_bluetooth": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "59") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_network_$$_apple_bluetooth = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_network_$$_apple_bluetooth": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "59") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_network_$$_apple_bluetooth = tests_txt;
            column.type = 'string';
            break;
          }
        //------------------------------------------------------------

        // diagnostics Audio
        case "diag_audio_$$_internal_speaker": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "20") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_audio_$$_internal_speaker = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_audio_$$_internal_speaker": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "20") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_audio_$$_internal_speaker = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_audio_$$_internal_microphone": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "21") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_audio_$$_internal_microphone = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_audio_$$_internal_microphone": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "21") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_audio_$$_internal_microphone = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_audio_$$_output_jack": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "22") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_audio_$$_output_jack = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_audio_$$_output_jack": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "22") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_audio_$$_output_jack = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_audio_$$_input_jack": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "23") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_audio_$$_input_jack = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_audio_$$_input_jack": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "23") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_audio_$$_input_jack = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_audio_$$_combo_jack": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "24") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_audio_$$_combo_jack = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_audio_$$_combo_jack": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "24") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_audio_$$_combo_jack = tests_txt;
          column.type = 'string';
          break;
        }



          case "diag_audio_$$_apple_audio_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "29") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_audio_$$_apple_audio_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_audio_$$_apple_audio_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "29") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_audio_$$_apple_audio_test = tests_txt;
            column.type = 'string';
            break;
          }
        //------------------------------------------------------------

        // diagnostics Screen
        case "diag_screen_$$_display_ports": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "80") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_screen_$$_display_ports = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_screen_$$_display_ports": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "80") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_screen_$$_display_ports = tests_txt;
          column.type = 'string';
          break;
        }


          case "diag_screen_$$_apple_hdmi_controller_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "89") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_screen_$$_apple_hdmi_controller_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_screen_$$_apple_hdmi_controller_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "89") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_screen_$$_apple_hdmi_controller_test = tests_txt;
            column.type = 'string';
            break;
          }




        case "diag_screen_$$_dead_pixel_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "100") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_screen_$$_dead_pixel_test = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_screen_$$_dead_pixel_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "100") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_screen_$$_dead_pixel_test = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_screen_$$_screen_calibration_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "101") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_screen_$$_screen_calibration_test = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_screen_$$_screen_calibration_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "101") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_screen_$$_screen_calibration_test = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_screen_$$_touchscreen": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "132") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_screen_$$_touchscreen = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_screen_$$_touchscreen": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "132") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_screen_$$_touchscreen = tests_txt;
          column.type = 'string';
          break;
        }
        //------------------------------------------------------------

        // diagnostics User inputs
        case "diag_user_inputs_$$_keyboard": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "30") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_user_inputs_$$_keyboard = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_user_inputs_$$_keyboard": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "30") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_user_inputs_$$_keyboard = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_user_inputs_$$_keyboard_status_led": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "31") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_user_inputs_$$_keyboard_status_led = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_user_inputs_$$_keyboard_status_led": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "31") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_user_inputs_$$_keyboard_status_led = tests_txt;
          column.type = 'string';
          break;
        }

          //--
          case "diag_user_inputs_$$_apple_keyboard_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "37") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_user_inputs_$$_apple_keyboard_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_user_inputs_$$_apple_keyboard_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "37") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_user_inputs_$$_apple_keyboard_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_user_inputs_$$_apple_touch_id_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "38") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_user_inputs_$$_apple_touch_id_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_user_inputs_$$_apple_touch_id_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "38") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_user_inputs_$$_apple_touch_id_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_user_inputs_$$_apple_touch_bar_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "39") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_user_inputs_$$_apple_touch_bar_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_user_inputs_$$_apple_touch_bar_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "39") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_user_inputs_$$_apple_touch_bar_test = tests_txt;
            column.type = 'string';
            break;
          }

          //--

        case "diag_user_inputs_$$_mouse_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "130") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_user_inputs_$$_mouse_test = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_user_inputs_$$_mouse_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "130") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_user_inputs_$$_mouse_test = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_user_inputs_$$_touchpad": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "131") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_user_inputs_$$_touchpad = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_user_inputs_$$_touchpad": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "131") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_user_inputs_$$_touchpad = tests_txt;
          column.type = 'string';
          break;
        }


          case "diag_user_inputs_$$_apple_trackpad_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "132") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_user_inputs_$$_apple_trackpad_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_user_inputs_$$_apple_trackpad_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "132") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_user_inputs_$$_apple_trackpad_test = tests_txt;
            column.type = 'string';
            break;
          }


        case "diag_user_inputs_$$_trackpoint": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "133") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_user_inputs_$$_trackpoint = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_user_inputs_$$_trackpoint": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "133") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_user_inputs_$$_trackpoint = tests_txt;
          column.type = 'string';
          break;
        }
        //------------------------------------------------------------

        // diagnostics Battery
        case "diag_battery_$$_battery_wear_level": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "1") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_battery_$$_battery_wear_level = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_battery_$$_battery_wear_level": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "1") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_battery_$$_battery_wear_level = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_battery_$$_battery_charging_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "2") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_battery_$$_battery_charging_test = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_battery_$$_battery_charging_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "2") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_battery_$$_battery_charging_test = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_battery_$$_battery_drain_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "3") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_battery_$$_battery_drain_test = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_battery_$$_battery_drain_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "3") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_battery_$$_battery_drain_test = tests_txt;
          column.type = 'string';
          break;
        }

          case "diag_battery_$$_apple_battery_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "9") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_battery_$$_apple_battery_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_battery_$$_apple_battery_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "9") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_battery_$$_apple_battery_test = tests_txt;
            column.type = 'string';
            break;
          }
        //------------------------------------------------------------

        // diagnostics Sensors
        case "diag_sensors_$$_accelerometer": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "60") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_sensors_$$_accelerometer = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_sensors_$$_accelerometer": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "60") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_sensors_$$_accelerometer = tests_txt;
          column.type = 'string';
          break;
        }


        case "diag_sensors_$$_lid_sensor": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "90") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_sensors_$$_lid_sensor = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_sensors_$$_lid_sensor": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "90") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_sensors_$$_lid_sensor = tests_txt;
          column.type = 'string';
          break;
        }

          case "diag_sensors_$$_apple_lid_sensor": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "97") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_sensors_$$_apple_lid_sensor = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_sensors_$$_apple_lid_sensor": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "97") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_sensors_$$_apple_lid_sensor = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_sensors_$$_apple_ambient_light_sensor": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "98") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_sensors_$$_apple_ambient_light_sensor = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_sensors_$$_apple_ambient_light_sensor": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "98") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_sensors_$$_apple_ambient_light_sensor = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_sensors_$$_apple_accelerometer_gyroscope_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "99") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_sensors_$$_apple_accelerometer_gyroscope_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_sensors_$$_apple_accelerometer_gyroscope_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "99") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_sensors_$$_apple_accelerometer_gyroscope_test = tests_txt;
            column.type = 'string';
            break;
          }
        //------------------------------------------------------------

        // diagnostics Other
        case "diag_other_$$_card_reader": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "70") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_other_$$_card_reader = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_other_$$_card_reader": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "70") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_other_$$_card_reader = tests_txt;
          column.type = 'string';
          break;
        }

          case "diag_other_$$_apple_card_reader": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "79") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_other_$$_apple_card_reader = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_other_$$_apple_card_reader": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "79") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_other_$$_apple_card_reader = tests_txt;
            column.type = 'string';
            break;
          }


        case "diag_other_$$_suspend_mode_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "110") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_other_$$_suspend_mode_test = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_other_$$_suspend_mode_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "110") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_other_$$_suspend_mode_test = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_other_$$_webcam": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "140") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_other_$$_webcam = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_other_$$_webcam": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "140") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_other_$$_webcam = tests_txt;
          column.type = 'string';
          break;
        }

          case "diag_other_$$_apple_webcam": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "149") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_other_$$_apple_webcam = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_other_$$_apple_webcam": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "149") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_other_$$_apple_webcam = tests_txt;
            column.type = 'string';
            break;
          }

          //--          
          case "diag_other_$$_apple_case_handle_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "491") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_other_$$_apple_case_handle_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_other_$$_apple_case_handle_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "491") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_other_$$_apple_case_handle_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_other_$$_apple_serial_number_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "492") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_other_$$_apple_serial_number_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_other_$$_apple_serial_number_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "492") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_other_$$_apple_serial_number_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_other_$$_apple_smc_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "493") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_other_$$_apple_smc_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_other_$$_apple_smc_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "493") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_other_$$_apple_smc_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_other_$$_apple_firmware_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "494") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_other_$$_apple_firmware_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_other_$$_apple_firmware_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "494") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_other_$$_apple_firmware_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_other_$$_apple_fan_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "495") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_other_$$_apple_fan_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_other_$$_apple_fan_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "495") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_other_$$_apple_fan_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_other_$$_apple_power_management_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "496") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_other_$$_apple_power_management_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_other_$$_apple_power_management_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "496") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_other_$$_apple_power_management_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_other_$$_apple_power_adapter_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "498") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_other_$$_apple_power_adapter_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_other_$$_apple_power_adapter_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "498") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_other_$$_apple_power_adapter_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_other_$$_apple_io_card": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "498") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_other_$$_apple_io_card = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_other_$$_apple_io_card": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "498") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_other_$$_apple_io_card = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_other_$$_apple_antenna_connector_board_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "499") {
                count++;
                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_result;

                const skipReason = testData.test_skipped_reason;
                if (skipReason !== '0') {
                  const skipReasonText = t(`skip_reason.${skipReason}`);

                  if (skipReasonText !== `skip_reason.${skipReason}`) {
                    tests_txt = tests_txt + "_$$_" + skipReasonText;
                  }
                }
              }
            });
            row.diag_other_$$_apple_antenna_connector_board_test = tests_txt;
            column.type = 'string';
            break;
          }

          case "diag_comment_$$_diag_other_$$_apple_antenna_connector_board_test": {
            let tests_txt = "";
            if (!testsList)
              break;

            testsList.forEach(test => {
              const testData = fixAndParse(test);

              if (testData.test_id === "499") {
                count++;

                if (tests_txt !== "")
                  tests_txt = tests_txt + line_separator;
                tests_txt += testData.test_comment;
              }
            });
            row.diag_comment_$$_diag_other_$$_apple_antenna_connector_board_test = tests_txt;
            column.type = 'string';
            break;
          }

          //--


        case "diag_other_$$_quick_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "580") {
              count++;
              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_result;

              const skipReason = testData.test_skipped_reason;
              if (skipReason !== '0') {
                const skipReasonText = t(`skip_reason.${skipReason}`);

                if (skipReasonText !== `skip_reason.${skipReason}`) {
                  tests_txt = tests_txt + "_$$_" + skipReasonText;
                }
              }
            }
          });
          row.diag_other_$$_quick_test = tests_txt;
          column.type = 'string';
          break;
        }

        case "diag_comment_$$_diag_other_$$_quick_test": {
          let tests_txt = "";
          if (!testsList)
            break;

          testsList.forEach(test => {
            const testData = fixAndParse(test);

            if (testData.test_id === "500") {
              count++;

              if (tests_txt !== "")
                tests_txt = tests_txt + line_separator;
              tests_txt += testData.test_comment;
            }
          });
          row.diag_comment_$$_diag_other_$$_quick_test = tests_txt;
          column.type = 'string';
          break;
        }
        //------------------------------------------------------------


        // deployments
        case "deployments_$$_image_deployed": {
          row.deployments_$$_image_deployed = deployment.image_selected;
          column.type = 'string';
          break;
        }

        case "deployments_$$_image_deployed_os": {
          if (deployment.os_version) {
              row.deployments_$$_image_deployed_os = deployment.os_version;
            column.type = 'string';
          }
          break;
        }

        case "deployments_$$_result": {
          row.deployments_$$_result = deployment.module_1115_result;
            column.type = 'singleSelect';
            column.valueOptions = [
              'PASSED',
              'FAILED',
              'WARNING',
              'CANCEL',
              'ABORTED',
              'SKIPPED',
              'INTERRUPTED',
              'WARNING - REMOVED',
              'ONGOING'
            ]
          break;
        }

        case "deployments_$$_duration": {
          if (deployment.module_1115_end_date && deployment.module_1115_start_date) {
            row.deployments_$$_duration = new Date(deployment.module_1115_end_date) - new Date(deployment.module_1115_start_date);
            column.type = 'string';
          }
          break;
        }


        // imaging
        case "imaging_$$_imaging_result": {
          // row.imaging_$$_imaging_result = (deployment.module_1123_closing_code !== null ? (deployment.module_1123_closing_code === 0 ? "OK" : "FAIL") : "");
            // row.imaging_$$_imaging_result = deployment.module_1123_closing_code;
            row.imaging_$$_imaging_result = deployment.module_1123_module_result;
            column.type = 'singleSelect';
            column.valueOptions = [
              'PASSED',
              'FAILED',
              'WARNING',
              'CANCEL',
              'ABORTED',
              'SKIPPED',
              'INTERRUPTED',
              'WARNING - REMOVED',
              'ONGOING'
            ]
          break;
        }

        case "imaging_$$_added_imageName": {
          row.imaging_$$_added_imageName = deployment.added_imagename;
          column.type = 'string';
          break;
        }

        case "imaging_$$_added_osversion": {
          row.imaging_$$_added_osversion = deployment.added_osversion;
          column.type = 'string';
          break;
        }

        case "imaging_$$_added_osarchitecture": {
          row.imaging_$$_added_osarchitecture = deployment.added_osarchitecture;
          column.type = 'string';
          break;
        }

        case "imaging_$$_added_usedSpace": {
          let usedSpace = deployment.added_usedspace;   // to get value in bytes

          if (usedSpace === null)
            break;

          let decimals = 2;
          if (usedSpace === 0)
            row.imaging_$$_added_usedSpace = '0'; // B';
          else {
            // const k = 1024;
            // const dm = decimals < 0 ? 0 : decimals;
            // const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            // const i = Math.floor(Math.log(usedSpace) / Math.log(k));
            // row.imaging_$$_added_usedSpace = parseFloat((usedSpace / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            row.imaging_$$_added_usedSpace = usedSpace;
          }
          column.type = 'number';
          break;
        }


        // sbar
        case "sbar_$$_activation_code": {
          row.sbar_$$_activation_code = deployment.sbar_activation_code;
          column.type = 'string';
          break;
        }

        case "sbar_$$_activation_type": {
          // row.sbar_$$_activation_type = (deployment.sbar_activation_type) && (deployment.sbar_activation_type).toUpperCase();
            row.sbar_$$_activation_type = deployment.sbar_activation_type ? deployment.sbar_activation_type : "";
          column.type = 'string';
          break;
        }

        case "sbar_$$_activation_result": {
            row.sbar_$$_activation_result = deployment.sbar_activation_result ? deployment.sbar_activation_result : "";
            column.type = 'singleSelect';
            column.valueOptions = [
              'FAILED (Re-activation missing)',
              'FAILED',
              'FAILED (Re-activation unknown)',
              'PASSED (Already activated)',
              'PASSED',
              'PASSED (Re-activated)'
            ]
          break;
        }

        case "sbar_$$_image_type": {
            row.sbar_$$_image_type = deployment.sbar_activation_image ? deployment.sbar_activation_image : "";
          column.type = 'string';
          break;
        }


        // manual inputs => USELESS = WILL BE HIDDEN BECAUSE GENERATE NEW COLUMNS...
        // case "manual_input_$$_welcome_screen": {
        //   let inputs_txt = "";
        //   if (!sdsQuestions101List)
        //     break;

        //   sdsQuestions101List.forEach(input => {
        //     const inputsData = fixAndParse(input);

        //     if (inputsData.xtra_desc) {
        //       count++;

        //       if (inputs_txt !== "")
        //         inputs_txt = inputs_txt + line_separator;
        //       inputs_txt += inputsData.xtra_desc + '=' + inputsData.xtra_value;
        //     }
        //   });

        //   row.manual_input_$$_welcome_screen = inputs_txt;
        //   column.type = 'string';
        //   break;
        // }

        // case "manual_input_$$_questions_form": {
        //   let inputs_txt = "";
        //   if (!sdsQuestions145List)
        //     break;

        //   sdsQuestions145List.forEach(input => {
        //     const inputsData = fixAndParse(input);

        //     if (inputsData.xtra_desc) {
        //       count++;

        //       if (inputs_txt !== "")
        //         inputs_txt = inputs_txt + line_separator;
        //       inputs_txt += inputsData.xtra_desc + '=' + inputsData.xtra_value;
        //     }
        //   });

        //   row.manual_input_$$_questions_form = inputs_txt;
        //   column.type = 'string';
        //   break;
        // }


        // Trade-in
        case "trade_in_$$_code": {
          // row.trade_in_$$_code = (deployment.tradeIn_code) && (deployment.tradeIn_code).toUpperCase();
            row.trade_in_$$_code = deployment.tradeIn_code ? deployment.tradeIn_code : "";
          column.type = 'string';
          break;
        }



        // MCE
        case "general_mobiles_$$_date": {
          // const options = {
          //   year: 'numeric',
          //   month: '2-digit',
          //   day: '2-digit',
          //   hour: 'numeric',
          //   minute: '2-digit'
          // };
          // row.general_mobiles_$$_date = new Date(getTimeAsZDateTime(deployment.mceDate)).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
          row.general_mobiles_$$_date = deployment.mceDate;
            column.type = 'dateTime';
          break;
        }

        case "general_mobiles_$$_id": {
          row.general_mobiles_$$_id = deployment.mceDeploymentID;
          column.type = 'number';
          break;
        }

        case "general_mobiles_$$_overall_result": {
            let now = new Date();
            let mceDate = new Date(deployment.mceDate);
            let diff = Math.round(now.getTime() - mceDate.getTime());

            let versionDate = new Date("2025-03-06T00:00:00.000Z");
            let diff2 = Math.round(versionDate.getTime() - mceDate.getTime());

            if (deployment.isComplete == 1 || deployment.isComplete === null) { //|| diff2 > 0) 

              row.general_mobiles_$$_overall_result = "OK";

              if (deployment.mceWipeResult === "2")
                row.general_mobiles_$$_overall_result = "FAIL";
              else {
                const K = Object.keys(deployment);
                K.forEach((key, index) => {
                  if (key.substring(0, 8) === "[<TEST>]") {
                    // console.log("8742 - key=", key, deployment[key]);
                    if (deployment[key] && deployment[key].test_result === 2)
                      row.general_mobiles_$$_overall_result = "FAIL";
                  }
                });
              }
              // row.general_mobiles_$$_overall_result = deployment["[<XTRA>]Overall Result"];
            }
            else {
              if (diff > 86400000)
                row.general_mobiles_$$_overall_result = "INTERRUPTED";
              else
                row.general_mobiles_$$_overall_result = "ONGOING";
            }
            column.type = 'singleSelect';
            column.valueOptions = [
              'PASSED',
              'FAILED',
              'WARNING',
              'CANCEL',
              'ABORTED',
              'SKIPPED',
              'INTERRUPTED',
              'WARNING - REMOVED',
              'ONGOING'
            ]
          break;
        }

        case "general_mobiles_$$_error_codes": {
          row.general_mobiles_$$_error_codes = deployment["[<XTRA>]Error Codes"];
          column.type = 'string';
          break;
        }

        case "general_mobiles_$$_grade": {
            if (deployment.grade)
              row.general_mobiles_$$_grade = deployment.grade;
            else
          row.general_mobiles_$$_grade = deployment["[<XTRA>]Grade"];

          column.type = 'string';
          break;
        }

        case "hardware_general_mobiles_$$_manufacturer": {
          row.hardware_general_mobiles_$$_manufacturer = deployment.mceMake;
          column.type = 'string';
          break;
        }

        case "hardware_general_mobiles_$$_product": {
          row.hardware_general_mobiles_$$_product = deployment.mceModel;
          column.type = 'string';
          break;
        }

        case "hardware_general_mobiles_$$_display_name": {
          row.hardware_general_mobiles_$$_display_name = deployment.mceDisplayName;
          column.type = 'string';
          break;
        }

        case "hardware_general_mobiles_$$_model_name": {
          row.hardware_general_mobiles_$$_model_name = deployment.mceIOSModelName;
          column.type = 'string';
          break;
        }

          case "hardware_general_mobiles_$$_model_code": {
            row.hardware_general_mobiles_$$_model_code = deployment.modelCode;
            column.type = 'string';
            break;
          }

          case "hardware_general_mobiles_$$_model_id": {
            row.hardware_general_mobiles_$$_model_id = deployment.hardwareId;
            column.type = 'string';
            break;
          }

          case "hardware_general_mobiles_$$_board": {
            // console.log("8186 - deployment=", deployment);
            row.hardware_general_mobiles_$$_board = deployment.hwModel;
            column.type = 'string';
            break;
          }

        case "hardware_general_mobiles_$$_iemi": {
          row.hardware_general_mobiles_$$_iemi = deployment.mceIMEI;
          column.type = 'string';
          break;
        }

        case "hardware_general_mobiles_$$_meid": {
          row.hardware_general_mobiles_$$_meid = deployment.mceMEID;
          column.type = 'string';
          break;
        }

        case "hardware_general_mobiles_$$_iccid": {
          row.hardware_general_mobiles_$$_iccid = deployment.mceICCID;
          column.type = 'string';
          break;
        }

        case "hardware_general_mobiles_$$_serial_number": {
          row.hardware_general_mobiles_$$_serial_number = deployment.mceSerialNumber;
          column.type = 'string';
          break;
        }

        case "hardware_general_mobiles_$$_region": {
          row.hardware_general_mobiles_$$_region = deployment.mceRegionInfo;
          column.type = 'string';
          break;
        }

          case "hardware_general_mobiles_$$_region_code": {
            row.hardware_general_mobiles_$$_region_code = deployment.regionCode;
            column.type = 'string';
            break;
          }

          case "hardware_general_mobiles_$$_region_info": {
            row.hardware_general_mobiles_$$_region_info = deployment.regionInfo;
            column.type = 'string';
            break;
          }

        case "hardware_general_mobiles_$$_capacity": {
          row.hardware_general_mobiles_$$_capacity = deployment.mceCapacity;

            if (typeof deployment.mceCapacity === 'number')
              row.hardware_general_mobiles_$$_capacity += 'GB';
          column.type = 'string';
          break;
        }

        case "hardware_general_mobiles_$$_front_color": {
          row.hardware_general_mobiles_$$_front_color = deployment.mceFrontColor;
          column.type = 'string';
          break;
        }

        case "hardware_general_mobiles_$$_back_color": {
          row.hardware_general_mobiles_$$_back_color = deployment.mceBackColor;
          column.type = 'string';
          break;
        }

        case "hardware_general_mobiles_$$_sd_card_present": {
          row.hardware_general_mobiles_$$_sd_card_present = deployment.mceSDCardPresent;
          column.type = 'string';
          break;
        }

        case "hardware_general_mobiles_$$_sim_card_present": {
          row.hardware_general_mobiles_$$_sim_card_present = deployment.mceSIMCardPresent;
          column.type = 'string';
          break;
        }

          case "hardware_general_mobiles_$$_dual_sim": {
            row.hardware_general_mobiles_$$_dual_sim = deployment.isDualSim;
            column.type = 'string';
            break;
          }

        case "hardware_general_mobiles_$$_port_number": {
          row.hardware_general_mobiles_$$_port_number = deployment.mcePortNumber;
          column.type = 'string';
          break;
        }

        case "hardware_battery_mobiles_$$_max_capacity": {
            if (deployment.batteryFullChargeCapacity)
              row.hardware_battery_mobiles_$$_max_capacity = deployment.batteryFullChargeCapacity;
            else
          row.hardware_battery_mobiles_$$_max_capacity = deployment['[<XTRA>]Battery Max Capacity'];
          column.type = 'string';
          break;
        }

        case "hardware_battery_mobiles_$$_design_capacity": {
            if (deployment.batteryDesignCapacity)
              row.hardware_battery_mobiles_$$_design_capacity = deployment.batteryDesignCapacity;
            else
          row.hardware_battery_mobiles_$$_design_capacity = deployment['[<XTRA>]Battery Design Capacity'];
          column.type = 'string';
          break;
        }

        case "hardware_battery_mobiles_$$_cycle_count": {
            if (deployment.batteryCycleCount)
              row.hardware_battery_mobiles_$$_cycle_count = deployment.batteryCycleCount;
            else
          row.hardware_battery_mobiles_$$_cycle_count = deployment['[<XTRA>]Battery Cycle Count'];
          column.type = 'string';
          break;
        }

        case "hardware_battery_mobiles_$$_soh": {
            if (deployment.batteryHealthPercentage)
              row.hardware_battery_mobiles_$$_soh = deployment.batteryHealthPercentage;
            else
          row.hardware_battery_mobiles_$$_soh = deployment['[<XTRA>]Battery SOH'];
          column.type = 'string';
          break;
        }

          case "hardware_battery_mobiles_$$_serial_number": {
            row.hardware_battery_mobiles_$$_serial_number = deployment.batterySerial;
            column.type = 'string';
            break;
          }

          case "hardware_battery_mobiles_$$_manufacturing_date": {
            row.hardware_battery_mobiles_$$_manufacturing_date = deployment.batteryManufacturingDate;
            column.type = 'string';
            break;
          }

          case "hardware_battery_mobiles_$$_grade": {
            row.hardware_battery_mobiles_$$_grade = deployment.batteryGrade;
            column.type = 'string';
            break;
          }


        // case "tests_mobiles_$$_tests_mobiles": {
        //   let inputs_txt = "";
        //   if (!sdsTestsMobilesList)
        //     break;

        //   sdsTestsMobilesList.forEach(input => {
        //     const inputsData = fixAndParse(input);

        //     if (inputsData.xtra_desc) {
        //       count++;

        //       if (inputs_txt !== "")
        //         inputs_txt = inputs_txt + line_separator;
        //       inputs_txt += inputsData.xtra_desc + '=' + inputsData.xtra_value;
        //     }
        //   });

        //   row.tests_mobiles_$$_tests_mobiles = inputs_txt;
        //   column.type = 'string';
        //   break;
        // }

        /*
            Magnetometer Test
            Accelerometer Test
            Physical Buttons Test
            Zoom Gesture Test
            Touchscreen Test
            Touch Accuracy Test
            Swipe Gesture Test
            Multi-Touch Test
            Dead Pixels Test
            Microphone 2 Test
            Microphone 1 Test
            Earpiece Test
            WiFi Networks Detection Test
            Cameras Functionality Test
            Battery Health Test
            Microphones Test
          */


          case "locks_mobiles_$$_rooted_jailbroken": { //32790
          row.locks_mobiles_$$_rooted_jailbroken = deployment.mceRootedJailbroken;
          column.type = 'string';
          break;
        }

        case "locks_mobiles_$$_blacklisted": {
          row.locks_mobiles_$$_blacklisted = deployment.mceBlackListed;
          column.type = 'string';
          break;
        }

        case "locks_mobiles_$$_samsung_reactivation_lock": {
          row.locks_mobiles_$$_samsung_reactivation_lock = deployment.mceSamsungReactivationLock;
          column.type = 'string';
          break;
        }

        case "locks_mobiles_$$_google_fpr_lock": {
          row.locks_mobiles_$$_google_fpr_lock = deployment.mceGoogleFPRLock;
          column.type = 'string';
          break;
        }

        case "locks_mobiles_$$_find_my_iphone": {
          row.locks_mobiles_$$_find_my_iphone = deployment.mceFindMyiPhone;
          column.type = 'string';
          break;
        }

        case "locks_mobiles_$$_sim_lock": {
            // console.log("8229 - deployment.mceSIMLock=", deployment.mceSIMLock);
            if (deployment.mceSIMLock)
              row.locks_mobiles_$$_sim_lock = deployment.mceSIMLock;
            else
          row.locks_mobiles_$$_sim_lock = deployment['[<XTRA>]SIM Lock'];
          column.type = 'string';
          break;
        }

        case "locks_mobiles_$$_google_enterprise_configured": {
          row.locks_mobiles_$$_google_enterprise_configured = deployment['[<XTRA>]Google Enterprise Configured'];
          column.type = 'string';
          break;
        }

        case "locks_mobiles_$$_ios_mdm_configured": {
            if (deployment.mceIOSMDMConfigured)
              row.locks_mobiles_$$_ios_mdm_configured = deployment.mceIOSMDMConfigured;
            else
          row.locks_mobiles_$$_ios_mdm_configured = deployment['[<XTRA>]iOS MDM Configured'];
          column.type = 'string';
          break;
        }

          case "locks_mobiles_$$_samsung_knox_configured": { //32792
          row.locks_mobiles_$$_samsung_knox_configured = deployment['[<XTRA>]Samsung Knox Configured'];
          column.type = 'string';
          break;
        }

          case "locks_mobiles_$$_xiaomi_account": { // 32779
            row.locks_mobiles_$$_xiaomi_account = deployment['[<XTRA>]Xiaomi account'];
            column.type = 'string';
            break;
          }

          case "locks_mobiles_$$_google_account": { // 32791
            row.locks_mobiles_$$_google_account = deployment['[<XTRA>]Google account'];
            column.type = 'string';
            break;
          }

          case "locks_mobiles_$$_huawei_account": {
            row.locks_mobiles_$$_huawei_account = deployment['[<XTRA>]Huawei account'];
            column.type = 'string';
            break;
          }

          case "locks_mobiles_$$_device_genuine": { // 32782 => NOT genuine
            row.locks_mobiles_$$_device_genuine = deployment['[<XTRA>]Device genuine'];
            column.type = 'string';
            break;
          }

          case "locks_mobiles_$$_battery_genuine": { // 32784 => NOT genuine
            row.locks_mobiles_$$_battery_genuine = deployment['[<XTRA>]Battery genuine'];
            column.type = 'string';
            break;
          }

          case "locks_mobiles_$$_zero_touch_enrollment": {
            row.locks_mobiles_$$_zero_touch_enrollment = deployment['[<XTRA>]Zero Touch enrollment'];
            column.type = 'string';
            break;
          }

        /*
            Is the entire device free of any cracks/breaks/dents or missing parts?
            Is the entire phone severely damaged/bent/corroded or poses a safety hazard?
            Does the LCD have cracks/bleeding/lines/major screen burn or major bruising?
        */


        case "operations_mobiles_$$_flash": {
          row.operations_mobiles_$$_flash = deployment['[<XTRA>]Flash'];
          column.type = 'string';
          break;
        }

        case "operations_mobiles_$$_wipe": {
            if (deployment.mceWipeResult)
              row.operations_mobiles_$$_wipe = deployment.mceWipeResult;
            else
          row.operations_mobiles_$$_wipe = deployment['[<XTRA>]Wipe'];
            column.type = 'singleSelect';
            column.valueOptions = [
              'UNKNOWN',
              'SUCCESS',
              'FAILURE',
              'SUCCESS (but nothing was done)',
              'SKIPPED',
              'CANCELLED'
            ]
          break;
        }

        case "other_mobiles_$$_carrier": {
          row.other_mobiles_$$_carrier = deployment.mceCarrier;
          column.type = 'string';
          break;
        }

        case "other_mobiles_$$_carrier_bundle": {
          row.other_mobiles_$$_carrier_bundle = deployment.mceCarrierBundle;
          column.type = 'string';
          break;
        }

        case "other_mobiles_$$_esim_wipe": {
          row.other_mobiles_$$_esim_wipe = deployment['[<XTRA>]Esim Wipe'];
          column.type = 'string';
          break;
        }

        case "other_mobiles_$$_esim_active": {
          row.other_mobiles_$$_esim_active = deployment['[<XTRA>]Esim Active'];
          column.type = 'string';
          break;
        }

        case "other_mobiles_$$_esim_carrier": {
          row.other_mobiles_$$_esim_carrier = deployment['[<XTRA>]Esim Carrier'];
          column.type = 'string';
          break;
        }

        case "other_mobiles_$$_activate": {
          row.other_mobiles_$$_activate = deployment['[<XTRA>]Activate'];
          column.type = 'string';
          break;
        }

        case "other_mobiles_$$_iq_reseller_number": {
          row.other_mobiles_$$_iq_reseller_number = deployment['[<XTRA>]IQ_Reseller Number'];
          column.type = 'string';
          break;
        }

        case "other_mobiles_$$_fed_check": {
          row.other_mobiles_$$_fed_check = deployment['[<XTRA>]FED Check'];
          column.type = 'string';
          break;
        }

        case "other_mobiles_$$_warranty_end_date_activate": {
          row.other_mobiles_$$_warranty_end_date_activate = deployment['[<XTRA>]Warranty End Date'];
          column.type = 'string';
          break;
        }

        case "other_mobiles_$$_under_warranty": {
          row.other_mobiles_$$_under_warranty = deployment['[<XTRA>]Under Warranty'];
          column.type = 'string';
          break;
        }



        // DISKS
        case "disks_wipe_$$_id": {
          row.disks_wipe_$$_id = deployment.deployment_id;
          column.type = 'string';
          break;
        }

        case "disks_wipe_$$_date": {
          // const options = {
          //   year: 'numeric',
          //   month: '2-digit',
          //   day: '2-digit',
          //   hour: 'numeric',
          //   minute: '2-digit'
          // };
          // row.disks_wipe_$$_date = new Date(getTimeAsZDateTime(deployment.date)).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
          row.disks_wipe_$$_date = deployment.date;
            column.type = 'dateTime';
          break;
        }

        case "disks_wipe_$$_result": {
          row.disks_wipe_$$_result = deployment.result;
            column.type = 'singleSelect';
            column.valueOptions = [
              'PASSED',
              'FAILED',
              'WARNING',
              'CANCEL',
              'ABORTED',
              'SKIPPED',
              'INTERRUPTED',
              'WARNING - REMOVED',
              'ONGOING'
            ]
          break;
        }

        case "disks_wipe_$$_algorithm": {
          row.disks_wipe_$$_algorithm = deployment.algorithm;
          column.type = 'string';
          break;
        }

        case "disks_wipe_$$_eraser_rounds": {
          row.disks_wipe_$$_eraser_rounds = deployment.eraser_rounds;
          column.type = 'string';
          break;
        }

        case "disks_wipe_$$_time": {
          row.disks_wipe_$$_time = deployment.time;
          column.type = 'string';
          break;
        }

        case "disks_wipe_$$_manufacturer": {
            row.disks_wipe_$$_manufacturer = deployment.manufacturer && deployment.manufacturer.replace(/"/g, '&quot;').replace(/\n/g, ' ').replace(/\r/g, ' ').replace(/\t/g, '   ');
          column.type = 'string';
          break;
        }

        case "disks_wipe_$$_model": {
            row.disks_wipe_$$_model = deployment.model && deployment.model.replace(/"/g, '&quot;').replace(/\n/g, ' ').replace(/\r/g, ' ').replace(/\t/g, '   ');
          column.type = 'string';
          break;
        }

        case "disks_wipe_$$_advertized_capacity": {
          row.disks_wipe_$$_advertized_capacity = deployment.size_commercial;
          column.type = 'string';
          break;
        }

        case "disks_wipe_$$_serial": {
            row.disks_wipe_$$_serial = deployment.serial && deployment.serial.replace(/"/g, '&quot;').replace(/\n/g, ' ').replace(/\r/g, ' ').replace(/\t/g, '   ');
          column.type = 'string';
          break;
        }

        case "disks_wipe_$$_health": {
          row.disks_wipe_$$_health = deployment.health;
            column.type = 'singleSelect';
            column.valueOptions = [
              'UNKNOWN',
              'GOOD',
              'BAD',
              'WARNING'
            ]
          break;
        }

        case "disks_wipe_$$_uuid": {
          row.disks_wipe_$$_uuid = deployment.uuid;
          column.type = 'string';
          break;
        }

          case "disks_wipe_$$_ppid": {
            row.disks_wipe_$$_ppid = deployment.disk_ppid;
            column.type = 'string';
            break;
          }

        case "disks_wipe_$$_bps": {
          row.disks_wipe_$$_bps = deployment.bps;
          column.type = 'string';
          break;
        }

        case "disks_wipe_$$_customer_data": {
            row.disks_wipe_$$_customer_data = deployment.customer_data && deployment.customer_data.replace(/"/g, '&quot;').replace(/\n/g, ' ').replace(/\r/g, ' ').replace(/\t/g, '   ');
          column.type = 'string';
          break;
        }
        case "disks_wipe_$$_reallocated_sectors": {
          row.disks_wipe_$$_reallocated_sectors = deployment.reallocated_sectors;
          column.type = 'string';
          break;
        }
        case "disks_wipe_$$_power_on_hours": {
          row.disks_wipe_$$_power_on_hours = deployment.power_on_hours;
          column.type = 'string';
          break;
        }
        case "disks_wipe_$$_reported_uncorrectable_errors": {
          row.disks_wipe_$$_reported_uncorrectable_errors = deployment.reported_uncorrectable_errors;
          column.type = 'string';
          break;
        }
        case "disks_wipe_$$_command_timeout": {
          row.disks_wipe_$$_command_timeout = deployment.command_timeout;
          column.type = 'string';
          break;
        }
        case "disks_wipe_$$_current_pending_sector_count": {
          row.disks_wipe_$$_current_pending_sector_count = deployment.current_pending_sector_count;
          column.type = 'string';
          break;
        }
        case "disks_wipe_$$_offline_uncorrectable": {
          row.disks_wipe_$$_offline_uncorrectable = deployment.offline_uncorrectable;
          column.type = 'string';
          break;
        }
          case "disks_wipe_$$_disk_health_percentage": {
            row.disks_wipe_$$_disk_health_percentage = deployment.diskHealthPercentage;
            column.type = 'string';
            break;
          }
          case "disks_wipe_$$_rpm": {
            row.disks_wipe_$$_rpm = deployment.disk_rpm;
            column.type = 'number';
            break;
          }

          case "disks_wipe_$$_bus": {
            row.disks_wipe_$$_bus = deployment.disk_bus;
            column.type = 'string';
            break;
          }

          case "disks_wipe_$$_path": {
            row.disks_wipe_$$_path = deployment.disk_path;
            column.type = 'string';
            break;
          }

          case "disks_wipe_$$_computed_health": {
            row.disks_wipe_$$_computed_health = deployment.extraDiskHealth;
            column.type = 'string';
            break;
          }

          case "disks_wipe_$$_computed_perf": {
            row.disks_wipe_$$_computed_perf = deployment.extraDiskPerf;
            column.type = 'string';
            break;
          }

          // hexadecimal_viewer
          case "hexadecimal_viewer_$$_result": {
            row.hexadecimal_viewer_$$_result = deployment.module_1141_closing_code;
            column.type = 'singleSelect';
            column.valueOptions = [
              'UNKNOWN',
              'PASSED',
              'CANCELLED',
              'FAILED'
            ]
            break;
          }

          case "hexadecimal_viewer_$$_disk_validated": {
            let diskValidated_txt = "";
            if (!diskValidatedList)
              break;

            diskValidatedList.forEach(diskValidated => {
              const diskValidatedData = fixAndParse(diskValidated);

              if (diskValidatedData.checked) {
                count++;

                if (diskValidated_txt !== "")
                  diskValidated_txt = diskValidated_txt + line_separator;
                diskValidated_txt += diskValidatedData.checked + ' - ' + diskValidatedData.validated;
              }
            });
            row.hexadecimal_viewer_$$_disk_validated = diskValidated_txt;
            column.type = 'string';
            break;
          }


          case "disks_wipe_$$_order": {
            if (deployment.disk_orderLot) {
              const regex = /^([A-Za-z]+)_([A-Za-z]+)$/im;  // 
              const orderLot = deployment.disk_orderLot.match(regex);

              if (orderLot && orderLot[1])
                row.disks_wipe_$$_order = orderLot[1];
              else
                row.disks_wipe_$$_order = "";


              column.type = 'string';
              break;
            }
          }

          case "disks_wipe_$$_lot": {
            if (deployment.disk_orderLot) {
              const regex = /^([A-Za-z]+)_([A-Za-z]+)$/im;  // 
              const orderLot = deployment.disk_orderLot.match(regex);

              if (orderLot && orderLot[2])
                row.disks_wipe_$$_lot = orderLot[2];
              else
                row.disks_wipe_$$_lot = "";

              column.type = 'string';
              break;
            }
          }

          //------------------------------------------------------------

          case "locks_$$_lock_bios_admin_password": {
            row.locks_$$_lock_bios_admin_password = deployment.lock_bios_admin_password;
            column.type = 'string';
            break;
          }

          case "locks_$$_lock_bios_computrace_status": {
            row.locks_$$_lock_bios_computrace_status = deployment.lock_bios_computrace_status;
            column.type = 'string';
            break;
          }

          //------------------------------------------------------------

          case "bootimage_$$_current_name": {
            let bootimage_txt = "";

            if (!sdsBootImgList)
              break;

            sdsBootImgList.forEach(bootimage => {
              const bootimageData = fixAndParse(bootimage);

              if (bootimageData.module_result === "BOOT_IMG_CURRENT_NAME") {
                count++;
                if (bootimage_txt !== "")
                  bootimage_txt = bootimage_txt + line_separator;

                bootimage_txt += bootimageData.module_result_data;
              }
            });

            row.bootimage_$$_current_name = bootimage_txt;
            column.type = 'string';
            break;
          }

          case "bootimage_$$_original_name": {
            let bootimage_txt = "";

            if (!sdsBootImgList)
              break;

            sdsBootImgList.forEach(bootimage => {
              const bootimageData = fixAndParse(bootimage);

              if (bootimageData.module_result === "BOOT_IMG_ORIGINAL_NAME") {
                count++;
                if (bootimage_txt !== "")
                  bootimage_txt = bootimage_txt + line_separator;

                bootimage_txt += bootimageData.module_result_data;
              }
            });

            row.bootimage_$$_original_name = bootimage_txt;
            column.type = 'string';
            break;
          }

          case "bootimage_$$_date": {
            let bootimage_txt = "";

            if (!sdsBootImgList)
              break;

            sdsBootImgList.forEach(bootimage => {
              const bootimageData = fixAndParse(bootimage);

              if (bootimageData.module_result === "BOOT_IMG_DATE") {
                count++;
                if (bootimage_txt !== "")
                  bootimage_txt = bootimage_txt + line_separator;

                bootimage_txt += bootimageData.module_result_data;
              }
            });

            row.bootimage_$$_date = bootimage_txt;
            column.type = 'string';
            break;
          }

          case "bootimage_$$_winpe_ver": {
            let bootimage_txt = "";

            if (!sdsBootImgList)
              break;

            sdsBootImgList.forEach(bootimage => {
              const bootimageData = fixAndParse(bootimage);

              if (bootimageData.module_result === "BOOT_IMG_WINPE_VER") {
                count++;
                if (bootimage_txt !== "")
                  bootimage_txt = bootimage_txt + line_separator;

                bootimage_txt += bootimageData.module_result_data;
              }
            });

            row.bootimage_$$_winpe_ver = bootimage_txt;
            column.type = 'string';
            break;
          }

          case "bootimage_$$_launcher_ver": {
            let bootimage_txt = "";

            if (!sdsBootImgList)
              break;

            sdsBootImgList.forEach(bootimage => {
              const bootimageData = fixAndParse(bootimage);

              if (bootimageData.module_result === "BOOT_IMG_LAUNCHER_VER") {
                count++;
                if (bootimage_txt !== "")
                  bootimage_txt = bootimage_txt + line_separator;

                bootimage_txt += bootimageData.module_result_data;
              }
            });

            row.bootimage_$$_launcher_ver = bootimage_txt;
            column.type = 'string';
            break;
          }

          case "bootimage_$$_boot_type": {
            let bootimage_txt = "";

            if (!sdsBootImgList)
              break;

            sdsBootImgList.forEach(bootimage => {
              const bootimageData = fixAndParse(bootimage);

              if (bootimageData.module_result === "BOOT_IMG_BOOT_TYPE") {
                count++;
                if (bootimage_txt !== "")
                  bootimage_txt = bootimage_txt + line_separator;

                bootimage_txt += bootimageData.module_result_data;
              }
            });

            row.bootimage_$$_boot_type = bootimage_txt;
            column.type = 'string';
            break;
          }

          case "bootimage_$$_secure_boot": {
            let bootimage_txt = "";

            if (!sdsBootImgList)
              break;

            sdsBootImgList.forEach(bootimage => {
              const bootimageData = fixAndParse(bootimage);

              if (bootimageData.module_result === "BOOT_IMG_SECURE_BOOT") {
                count++;
                if (bootimage_txt !== "")
                  bootimage_txt = bootimage_txt + line_separator;

                bootimage_txt += bootimageData.module_result_data;
              }
            });

            row.bootimage_$$_secure_boot = bootimage_txt;
            column.type = 'string';
            break;
          }

          case "bootimage_$$_t2_security": {
            let bootimage_txt = "";

            if (!sdsBootImgList)
              break;

            sdsBootImgList.forEach(bootimage => {
              const bootimageData = fixAndParse(bootimage);

              if (bootimageData.module_result === "BOOT_IMG_T2_SECURITY") {
                count++;
                if (bootimage_txt !== "")
                  bootimage_txt = bootimage_txt + line_separator;

                bootimage_txt += bootimageData.module_result_data;
              }
            });

            row.bootimage_$$_t2_security = bootimage_txt;
            column.type = 'string';
            break;
          }
          //------------------------------------------------------------


        default:
          const [title, subtitle, extra] = column.field.split('_$$_');
          // console.log("-----------------------------------------");
          // console.log("title=", title);
          // console.log("subtitle=", subtitle);
          // console.log("extra=", extra);

          if (title === "welcome_screen") {

            if (subtitle === "other_manual_inputs") {
              let inputs_txt = "";
              if (!sdsQuestions101List)
                break;

              sdsQuestions101List.forEach(input => {
                const inputsData = fixAndParse(input);
                  if (inputsData.module_id) {
                // console.log("6260 - inputsData=", inputsData);
                    if (extra === undefined && inputsData && inputsData.xtra_id === "null" && inputsData.xtra_desc) {
                  count++;

                  if (inputs_txt !== "")
                    inputs_txt = inputs_txt + line_separator;
                      inputs_txt += (inputsData.xtra_desc + ' : ' + inputsData.xtra_value);
                }
                  }
              });
              row[column.field] = inputs_txt;
              column.type = 'string';

            }
            else if (subtitle === "input_value") {
              let inputs_txt = "";
              if (!sdsQuestions101List)
                break;

              sdsQuestions101List.forEach(input => {
                const inputsData = fixAndParse(input);
                  if (inputsData.module_id) {
                    if (extra && inputsData && inputsData.xtra_id !== "null" && ('input#' + inputsData.xtra_id /*+ ' : ' + inputsData.xtra_desc*/) === extra) {
                  count++;

                  if (inputs_txt !== "")
                    inputs_txt = inputs_txt + line_separator;
                  inputs_txt += inputsData.xtra_value;
                }
                    }
              });
              row[column.field] = inputs_txt;
              column.type = 'string';
            }
              // else {
              //   console.log("4904 - default=", column.field);
              // }
          }
          else if (title === "tests_mobiles") {

              // console.log("8836 - sdsTestsMobilesList=", sdsTestsMobilesList);
            let inputs_txt = "";
            if (!sdsTestsMobilesList)
              break;

            sdsTestsMobilesList.forEach(input => {
              const inputsData = fixAndParse(input);
              if (inputsData && inputsData.xtra_desc && inputsData.xtra_desc === extra) {
                count++;

                if (inputs_txt !== "")
                  inputs_txt = inputs_txt + line_separator;
                inputs_txt += inputsData.xtra_value;

                  // console.log("8850 - inputsData=", inputsData);

                  const skipReason = inputsData.skipped_reason;
                  if (skipReason && skipReason !== '0') {
                    let skipReasonsText = "";
                    const skipReasons = skipReason.split(',');
                    skipReasons.forEach(s => {
                      if (skipReasonsText !== "")
                        skipReasonsText = skipReasonsText + ", ";
                      skipReasonsText = skipReasonsText + t('piceasoft_test_issue.' + parseInt(s));
                    });

                    if (skipReasonsText !== "") {
                      //inputs_txt += '('+skipReasonsText+'.)';
                    }
                  }
              }
            });

              // console.log("8876 - ", column.field, "=", inputs_txt);
            row[column.field] = inputs_txt;
            column.type = 'string';

          }
          else if (title === "manual_inputs_mobiles") {

            let inputs_txt = "";
            if (!sdsManualInputsMobilesList)
              break;

            sdsManualInputsMobilesList.forEach(input => {
              const inputsData = fixAndParse(input);
              if (inputsData && inputsData.xtra_desc && inputsData.xtra_desc === extra) {
                count++;

                if (inputs_txt !== "")
                  inputs_txt = inputs_txt + line_separator;
                inputs_txt += inputsData.xtra_value;
              }
            });
            row[column.field] = inputs_txt;
            column.type = 'string';
          }
            else if (title === "other_mobiles" && subtitle === "others_input_value") {

            let inputs_txt = "";
            if (!sdsOthersMobilesList)
              break;

            sdsOthersMobilesList.forEach(input => {
              const inputsData = fixAndParse(input);
                if (inputsData && inputsData.xtra_desc && inputsData.xtra_desc.toUpperCase() === extra.toUpperCase()) {

                  // console.log("10773 - input=", input, extra);
                count++;

                if (inputs_txt !== "")
                  inputs_txt = inputs_txt + line_separator;
                inputs_txt += inputsData.xtra_value;
              }
            });
            row[column.field] = inputs_txt;
            column.type = 'string';
          }
          else if (title === "script") {
            let inputs_txt = "";
            if (!sdsScriptsList)
              break;

              sdsScriptsList.forEach(input => {
              const inputsData = fixAndParse(input);
                if (inputsData.module_id) {
              if (inputsData && inputsData.module_result && ('script#' + inputsData.module_result) === extra) {
                count++;

                if (inputs_txt !== "")
                  inputs_txt = inputs_txt + line_separator;
                inputs_txt += inputsData.module_result_data;
              }
                }
            });
            row[column.field] = inputs_txt;
            column.type = 'string';
          }
          else if (title === "questions_form") {

            if (subtitle === "other_questions") {

              let inputs_txt = "";
              if (!sdsQuestions145List)
                break;

              sdsQuestions145List.forEach(input => {
                const inputsData = fixAndParse(input);
                  if (inputsData.module_id) {
                    if (inputsData && inputsData.xtra_id === "null" && inputsData.xtra_desc) {
                  count++;

                  if (inputs_txt !== "")
                    inputs_txt = inputs_txt + line_separator;
                      inputs_txt += (inputsData.xtra_desc + " : " + inputsData.xtra_value);
                }
                  }
              });
              row[column.field] = inputs_txt;
              column.type = 'string';
            }
            else if (subtitle === "question_value") {
              let inputs_txt = "";
                if (!sdsQuestions145List) {
                  row[column.field] = inputs_txt;
                  column.type = 'string';
                break;
                }

              sdsQuestions145List.forEach(input => {
                const inputsData = fixAndParse(input);
                  if (inputsData.module_id) {
                    if (extra && inputsData && inputsData.xtra_id !== "null" && ('question#' + inputsData.xtra_id /*+ ' : ' + inputsData.xtra_desc*/) === extra) {
                  count++;

                  if (inputs_txt !== "")
                    inputs_txt = inputs_txt + line_separator;
                  inputs_txt += inputsData.xtra_value;
                }
                  }
              });
              row[column.field] = inputs_txt;
              column.type = 'string';
            }
          else {
            // console.log("4908 - default=", column.field);
          }
          }

            else if (title === "disks_wipe" && subtitle === "smart_attributes") {

              // console.log("--------------------------------");
              let inputs_txt = "";
              if (!deployment.smartAttibutesData) {
                row[column.field] = inputs_txt;
                column.type = 'number';
                break;
              }

              // console.log("9610 - subtitle=", subtitle);
              // console.log("9611 - extra=", extra);

              deployment.smartAttibutesData.forEach(inputsData => {

                // console.log("9631 - inputsData=", inputsData);
                let smartAttributeValue = -1;
                let values = {};

                if (extra.length > 4 && extra.substring(0, 4) === "raw_") {
                  smartAttributeValue = extra.substring(4);
                  values = inputsData.rawValue;
                } else if (extra.length > 4 && extra.substring(0, 11) === "normalized_") {
                  smartAttributeValue = extra.substring(11);
                  values = inputsData.normalizedValue;
                }


                if (
                  inputsData && inputsData.smartAttribute &&
                  inputsData.smartAttribute == smartAttributeValue
                ) {

                  for (const value of values) {
                    count++;
                    if (inputs_txt !== "")
                      inputs_txt = inputs_txt + line_separator;
                    inputs_txt += /*"#" + value.id + ' : ' + */ value.value;
                  }
                }
              });

              // console.log("961 - ", column.field, "=", inputs_txt);
              row[column.field] = inputs_txt;
              column.type = 'number';

            }

            else if (title === "disk_wipe" && subtitle === "smart_attributes") {
              if (!sdsDiskWipeSmartAttributesList) {
                row[column.field] = "";
                column.type = 'number';
                break;
              }

              const arrayDisk = [];
              sdsDiskWipeSmartAttributesList.forEach(line => {
                let inputsData = {};
                try {
                  inputsData = JSON.parse(line);
                }
                catch (e) {
                  inputsData = {};
                }
                // console.log("9758 - inputsData=", inputsData);
                const alreadyIn = arrayDisk.find((element) => {
                  return element == inputsData.disk;
                });
                if (!alreadyIn)
                  arrayDisk.push(inputsData.disk);
              });

              let inputs_txt = "";
              arrayDisk.forEach(diskNumber => {

                let diskPresent = false;

                sdsDiskWipeSmartAttributesList.forEach(line => {
                  let inputsData = {};
                  try {
                    inputsData = JSON.parse(line);
                  }
                  catch (e) {
                    inputsData = {};
                  }
                  let smartAttributeValue = -1;
                  let values = {};

                  if (extra.length > 4 && extra.substring(0, 4) === "raw_") {
                    smartAttributeValue = extra.substring(4);
                    values = inputsData.rawValue;
                  } else if (extra.length > 4 && extra.substring(0, 11) === "normalized_") {
                    smartAttributeValue = extra.substring(11);
                    values = inputsData.normalizedValue;
                  }

                  if (
                    inputsData && inputsData.smartAttribute &&
                    inputsData.smartAttribute == smartAttributeValue &&
                    inputsData.disk == diskNumber
                  ) {
                    count++;
                    if (inputs_txt !== "")
                      inputs_txt = inputs_txt + line_separator;
                    inputs_txt += /*"Disk#" + inputsData.disk + ' : ' +*/ values;

                    diskPresent = true;
                  }
                });
                if (!diskPresent) {
                  if (inputs_txt !== "")
                    inputs_txt = inputs_txt + line_separator;
                  inputs_txt += " ";
                }
              });

              /*
              sdsDiskWipeSmartAttributesList.forEach(line => {
                let inputsData = {};
                try {
                  inputsData = JSON.parse(line);
                }
                catch (e) {
                  inputsData = {};
                }
                console.log("9777 - inputsData=", inputsData);

                let smartAttributeValue = -1;
                let values = {};

                if (extra.length > 4 && extra.substring(0, 4) === "raw_") {
                  smartAttributeValue = extra.substring(4);
                  values = inputsData.rawValue;
                } else if (extra.length > 4 && extra.substring(0, 11) === "normalized_") {
                  smartAttributeValue = extra.substring(11);
                  values = inputsData.normalizedValue;
                }

                arrayDisk.forEach(diskNumber => {
                  if (
                    inputsData && inputsData.smartAttribute &&
                    inputsData.smartAttribute == smartAttributeValue &&
                    inputsData.disk == diskNumber
                  ) {
                    count++;
                    if (inputs_txt !== "")
                      inputs_txt = inputs_txt + line_separator;
                    inputs_txt += "Disk#" + inputsData.disk + ' : ' + values;
                  }
                  else {
                    if (inputs_txt !== "")
                      inputs_txt = inputs_txt + line_separator;
                    inputs_txt += " ";
                  }
                });
                */


              // if (
              //   inputsData && inputsData.smartAttribute &&
              //   inputsData.smartAttribute == smartAttributeValue
              // ) {

              //   console.log("9627 - smartAttributeValue=", smartAttributeValue);
              //   console.log("9628 - values=", values);

              //   count++;
              //   if (inputs_txt !== "")
              //     inputs_txt = inputs_txt + line_separator;
              //   inputs_txt += /*"Disk#" + inputsData.disk + ' : ' +*/ values;

              // }


              // console.log("9794 - ", column.field, "=", inputs_txt);
              row[column.field] = inputs_txt;
              column.type = 'number';
            }

          break;
      }

      if (count > mapRowSize.get(row.id) || !mapRowSize.get(row.id))
        mapRowSize.set(row.id, count);
    }
    if (reportingColumnsCopy.length > 0)
        localFilteredRows.push(row);
  }



    // GET MAX ROW LINES
    let localMaxRowLines = 2;
  var fixedRowCount = Math.ceil(Array.from(mapRowSize.values()).reduce(function (n, value) {
    let toAdd = (value) / 2;

      if (localMaxRowLines < value) {
        localMaxRowLines = value;
      }

    if (toAdd <= 1)
      toAdd = 1;

    return n + toAdd
  }, 0));
    // console.log("8365 - fixedRowCount=", fixedRowCount);


    // // GET MAX ROW LINES
    // var fixedRowCount2 = Math.ceil(Array.from(mapRowSize.values()).reduce(function (n, value) {
    //   // let toAdd = Math.max(1, Math.round( (18*value - 47)/52 + 1 ));

    //   let calc1 = 2.52341 * value + 0.277592;     
    //   let toAdd =  Math.round(Math.max(1, calc1 / 6));

    //   console.log("8372 - value=", value, calc1, toAdd, n);
    //   return n + toAdd
    // }, 0));
    // console.log("8365 - fixedRowCount2=", fixedRowCount2);

    // let localSimRowLines = 1;// Math.max(fixedRowCount2, localFilteredRows.length);
    // console.log("8374 - localSimRowLines=", localSimRowLines, localFilteredRows.length);


    if (fixedRowCount === localFilteredRows.length)
      fixedRowCount++;


    // BUILD COLUMNS LIST --------------
    var localHeaderLinesRatio = 1;
    let localColumns = [];
    let localActiveSortModel = [];
  let indexCol = 0;

  for (const column of reportingColumnsCopy) {

      // console.log("8421 - column=", column);
    if (column.headerName === "" || column.customHeaderName === false) {
        const [title, subtitle, extra, desc] = column.field.split('_$$_');

        // console.log("11213 - -----------------------------------");

        // console.log("11215 - title=", title);
        // console.log("11216 - subtitle=", subtitle);
        // console.log("11217 - extra=", extra);
        // console.log("11218 - desc=", desc);

      // console.log("6352 - column=", column);

      const isWelcomeScreenManualInput = column.field.length > 39 && (column.field.substring(0, 39) === "welcome_screen_$$_input_value_$$_input#");
      const isSdsQuestion = column.field.length > 45 && (column.field.substring(0, 45) === "questions_form_$$_question_value_$$_question#");
      // const isSdsQuestion = column.field.length > 43 && (column.field.substring(0, 43) === "manual_input_$$_questions_form_$$_question#");
      const isScript = column.field.length > 33 && (column.field.substring(0, 33) === "script_$$_script_value_$$_script#");
      const isComments = column.field.length > 16 && (column.field.substring(0, 16) === "diag_comment_$$_");
        const isMobileOthersData = column.field.length > 17 && (column.field.substring(0, 17) === "other_mobiles_$$_");

        const isSmartAttributes = column.field.length > 34 && (column.field.substring(0, 34) === "disks_wipe_$$_smart_attributes_$$_");
        const isSmartAttributes2 = column.field.length > 34 && (column.field.substring(0, 33) === "disk_wipe_$$_smart_attributes_$$_");

      column.customHeaderName = false;
        column.disableReorder = true;

      // console.log("6359 - isWelcomeScreenManualInput=", isWelcomeScreenManualInput);
      // console.log("6360 - isSdsQuestion=", isSdsQuestion);
      // console.log("6361 - isScript=", isScript);
        // console.log("6361 - isMobileOthersData=", isMobileOthersData);

      if (isWelcomeScreenManualInput) {
        const strTmp = `${t(column.parentTitle)} \u2013 ${t(`reporting.columns.${title}.sub_title`)}`
        column.headerName = strTmp;
      }
      else if (isSdsQuestion) {
        // column.headerName = `${t(`reporting.columns.${title}.sub_title`)}`;
        const strTmp = `${t(column.parentTitle)} \u2013 ${t(`reporting.columns.${title}.sub_title`)}`
        column.headerName = strTmp;
      }
      else if (isScript) {
        column.headerName = `${t(`reporting.columns.${title}.sub_title`)}`;
      }
        else if (isMobileOthersData) {
          if (!extra) {
            column.headerName = `${t(`reporting.columns.${title}.sub_title`)} \u2013 ${t(`reporting.columns.${title}.${subtitle}`)}`
          }
          else {
            column.headerName = `${t(`reporting.columns.${title}.sub_title`)}`;
          }
        }
      else if (column.parentTitle) {
        column.headerName = `${t(column.parentTitle)} \u2013 ${t(`reporting.columns.${title}.sub_title`)} \u2013 ${t(`reporting.columns.${title}.${subtitle}`)}`
      }
      else if (isComments) {
        // console.log("6348 - title=", title);
        // console.log("6348 - subtitle=", subtitle);
        // console.log("6348 - extra=", extra);
        column.headerName = `${t(`reporting.columns.settings.diagnostics`)} \u2013 ${t(`reporting.columns.${subtitle}.sub_title`)}`;
      }
        else if (isSmartAttributes || isSmartAttributes2) {
          column.headerName = `${t(`reporting.columns.${title}.sub_title`)} \u2013 ${t(`reporting.columns.${title}.smart_attribute`)}`
        }
      else {
        column.headerName = `${t(`reporting.columns.${title}.sub_title`)} \u2013 ${t(`reporting.columns.${title}.${subtitle}`)}`
      }
      // console.log("6379 - column.headerName=", column.headerName);


      if (extra) {
        if (isWelcomeScreenManualInput) {
          const found = welcomeScreenManualInputs && welcomeScreenManualInputs.find((element) => {
              const strTest = element.xtra_id + '_$$_' + element.xtra_desc;
            return strTest === column.field.substring(39);     // String VS numeric...
          });

          if (found) {
              column.headerName = column.headerName + ` \u2013 ` + t(`reporting.columns.manual_input.input`) + ` #` + found.xtra_id + ' : ' + found.xtra_desc;
          }
          else {
            column.headerName = column.headerName + ` \u2013 ` + t(`reporting.columns.manual_input.input`) + ` #` + column.field.substring(39);
          }
        }
        else if (isSdsQuestion) {
          const found = sdsQuestions && sdsQuestions.find((element) => {

              const strTest = element.xtra_id + '_$$_' + element.xtra_desc;
            return strTest === column.field.substring(45);     // String VS numeric...
          });
          if (found) {
              column.headerName = column.headerName + ` \u2013 ` + t(`reporting.columns.manual_input.sds_questions`) + ` #` + found.xtra_id + ' : ' + found.xtra_desc;
          }
          else {
            column.headerName = column.headerName + ` \u2013 ` + t(`reporting.columns.manual_input.sds_questions`) + ` #` + column.field.substring(45);
          }
        }
        else if (isScript) {
          const found = scriptHeaders && scriptHeaders.find((element) => {
            return element === column.field.substring(33);     // String VS numeric...
          });

          if (found) {
            column.headerName = column.headerName + ` \u2013 ` + found;
          }
          else {
            column.headerName = column.headerName + ` \u2013 ` + column.field.substring(33);
          }
        }
          else if (isMobileOthersData) {
            //\u2013 (${t(`reporting.columns.other_mobiles_others.sub_title`)})
            column.headerName = column.headerName + ` \u2013 (${t(`reporting.columns.other_mobiles_others.sub_title`)}) \u2013 ` + extra;
          }
        else if (isComments) {
          column.headerName = column.headerName + ` \u2013 ${t(`reporting.columns.${subtitle}.${extra}`)} ${t(`reporting.columns.diag_common.comments`)}`;
        }
          else if (isSmartAttributes) {

            if (extra.length > 4 && extra.substring(0, 4) === "raw_") {
              column.headerName = column.headerName + ` #` + extra.substring(4) + ` \u2013 ` + t(`reporting.columns.smart_attributes.raw_value`);
            } else if (extra.length > 4 && extra.substring(0, 11) === "normalized_") {
              column.headerName = column.headerName + ` #` + extra.substring(11) + ` \u2013 ` + t(`reporting.columns.smart_attributes.normalized_value`);
            }
            else
              column.headerName = column.headerName + ` \u2013 ` + extra;

            // const found = scriptHeaders && scriptHeaders.find((element) => {
            //   return element === column.field.substring(33);     // String VS numeric...
            // });

            // if (found) {
            //   column.headerName = column.headerName + ` \u2013 ` + found;
            // }
            // else {
            //   column.headerName = column.headerName + ` \u2013 ` + column.field.substring(33);
            // }
          }
          else if (isSmartAttributes2) {

            if (extra.length > 4 && extra.substring(0, 4) === "raw_") {
              column.headerName = column.headerName + ` #` + extra.substring(4) + ` \u2013 ` + t(`reporting.columns.smart_attributes.raw_value`);
            } else if (extra.length > 4 && extra.substring(0, 11) === "normalized_") {
              column.headerName = column.headerName + ` #` + extra.substring(11) + ` \u2013 ` + t(`reporting.columns.smart_attributes.normalized_value`);
            }
            else
              column.headerName = column.headerName + ` \u2013 ` + extra;
          }
        else {
          column.headerName = column.headerName + ` \u2013 ` + extra;
        }
          //column.resizable = false
      }
    }

    const headerNameSplitted = column.headerName.split(' \u2013 ');
    const ratio = headerNameSplitted.length / 2;
      if (ratio > localHeaderLinesRatio)
        localHeaderLinesRatio = ratio;

    const newColum = {
      ...column,
      key: indexCol++,
      headerAlign: 'left',
        align: column.align ? column.align : 'left',
        disableReorder: true,

        // valueGetter: (params) => {

        //   // console.log("8190 - params=", params);
        //   // console.log("8191 - getInterpretedData=", getInterpretedData(params));

        //   if (params.value) {
        //     let lines = String(params.value).split(line_separator);
        //     console.log("8195 - lines=", lines);

        //     for (const line of lines) {

        //       console.log("8195 - line=", line);              

        //       const newParams = {
        //         formattedValue: lines,
        //         field: params.field
        //       }
        //       console.log("8202 - newParams=", newParams);
        //       console.log("8203 - newParams=", getInterpretedData(newParams));
        //     }
        //   }
        //   return params.value;
        // },

      renderHeader: (params) => {
        //const headerNameSplitted = params.colDef.headerName.split(' \u2013 ');
          // console.log("10559 - params=", params.colDef)
        return (<div>
            {headerNameSplitted.map((headerLine, index) => {
              // console.log("10562 - headerLine=", headerLine, index, params.colDef.deduplicated);
            return (
              <div >
                  <span display={'inline'} noWrap={true}>
                <Typography
                  variant={'body2'}
                  style={{
                    color: colors.softthinks,
                    fontWeight: "700",
                    textAlign: "Left"
                  }}
                >
                      {/* {index == 0 && params && params.colDef && params.colDef.deduplicated == true ? (
                        <span
                          className="material-icons"
                          style={{ fontSize: "medium" }}
                          title={t('reporting.deduplicated')}
                        >
                          {"filter"}
                          &nbsp;
                        </span>
                      ) : (
                        <span>
                        </span>
                      )} */}
                  {headerLine}
                </Typography>
                  </span>
              </div>
            )
          })}
        </div>
        );
      },

      renderCell: (params) => {
        let lines = String(params.formattedValue).split(line_separator);
          const title = t('reporting.line') + params.id + ' ( ' + lines + ' )';

        if ("disk_$$_bus" === params.field) {
          return (<div>
            {lines.map(line => {
              return (
                <div>
                    <span display={'inline'} noWrap={true}>
                  <Typography title={title} variant={'body2'}>{getDiskBus(line)}</Typography>
                    </span>
                </div>
              )
            })}
          </div>
          );
        }

        if ("disk_$$_health" === params.field || "disk_wipe_$$_health" === params.field || "disks_wipe_$$_health" === params.field) {
          return (<div>
            {lines.map(line => {
              const data = getDiskHealth(line);
              return (
                <div>
                    <span display={'inline'} noWrap={true}>
                  <Typography title={title} variant={'body2'} style={{ color: ((data.color !== "") ? data.color : "black") }} >
                    {data.text}
                  </Typography>
                    </span>
                </div>
              )
            })}
          </div>
          );
        }

        if ("battery_$$_power_state" === params.field) {
          return (<div>
            {lines.map(line => {
              const data = getBatteryPowerState(line);
              return (
                <div>
                    <span display={'inline'} noWrap={true}>
                  <Typography title={title} variant={'body2'} style={{ color: ((data.color !== "") ? data.color : "black") }} >
                    {data.text}
                  </Typography>
                    </span>
                </div>
              )
            })}
          </div>
          );
        }

        if ("disk_$$_hpa" === params.field || "disk_$$_dco" === params.field) {
          return (<div >
            {lines.map(line => {
              const data = getDiskHpaAndDco(line);
              return (
                <div>
                    <span display={'inline'} noWrap={true}>
                  <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} >
                        <span className="material-icons-round" style={{ fontSize: "medium" }}>
                      {data.ico}
                    </span>
                    &nbsp;
                    {data.text}
                  </Typography>
                    </span>
                </div>
              )
            })}
          </div>
          );
        }

        if ("deployments_$$_duration" === params.field) {
          return (<div>
            {lines.map(line => {
              let timeString = "";

              if (line !== 'undefined') {
                const duration = parseInt(line);

                // const milliseconds = parseInt((duration % 1000) / 100);
                let seconds = Math.floor((duration / 1000) % 60);
                let minutes = Math.floor((duration / (1000 * 60)) % 60);
                let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

                // hours = (hours < 10) ? "0" + hours : hours;
                // minutes = (minutes < 10) ? "0" + minutes : minutes;
                // seconds = (seconds < 10) ? "0" + seconds : seconds;

                minutes = (hours > 0 && minutes < 10) ? "0" + minutes : minutes;
                seconds = (minutes > 0 && seconds < 10) ? "0" + seconds : seconds;

                timeString = (hours > 0 ? hours + "h " : "") + ((hours > 0 || minutes > 0) ? minutes + "min " : "") + seconds + "sec";
              }

              return (
                <div>
                    <span display={'inline'} noWrap={true}>
                  <Typography title={title} variant={'body2'}>{timeString}</Typography>
                    </span>
                </div>
              )
            })}
          </div>
          );
        }


        if (
            "disk_$$_rpm" === params.field ||
            "disks_wipe_$$_rpm" === params.field ||
            "disk_wipe_$$_rpm" === params.field
        ) {

          return (<div>
            {lines.map(line => {
              const data = getRPMStyle(line);
              return (
                <div>
                    <span display={'inline'} noWrap={true}>
                  <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} >
                    {data.text}
                  </Typography>
                    </span>
                </div>
              )
            })}
          </div>
          );
        }

        if (
          "other_$$_bluetooth" === params.field ||
          "other_$$_biometrics" === params.field ||
            "other_$$_cardreader" === params.field ||
            "hardware_general_mobiles_$$_sd_card_present" === params.field ||
            "hardware_general_mobiles_$$_sim_card_present" === params.field ||
            "hardware_general_mobiles_$$_dual_sim" === params.field
        ) {

          // console.log("lines=", lines) ;
          return (<div>
            {lines.map(line => {
              const data = getBooleanStyle(line);
              return (
                <div>
                    <span display={'inline'} noWrap={true}>
                  <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} >
                        <span className="material-icons-round" style={{ fontSize: "medium" }}>
                      {data.ico}
                    </span>
                    &nbsp;
                    {data.text}
                  </Typography>
                    </span>
                </div>
              )
            })}
          </div>
          );
        }


        if (
          "screen_$$_touch_screen" === params.field
        ) {
          return (<div>
            {lines.map(line => {
              const screen_txt = (line === "1" ? "true" : "false");
              const data = getBooleanStyle(screen_txt);
              return (
                <div>
                    <span display={'inline'} noWrap={true}>
                  <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} >
                        <span className="material-icons-round" style={{ fontSize: "medium" }}>
                      {data.ico}
                    </span>
                    &nbsp;
                    {data.text}
                  </Typography>
                    </span>
                </div>
              )
            })}
          </div>
          );
        }


          if (
            "disk_wipe_$$_result" === params.field
          ) {
            return (<div>
              {lines.map(line => {
                const data = getSmartThresholdExceededResultStyle(line);
                return (
                  <span>
                    <span display={'inline'} noWrap={true}>
                      <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} display={'inline'} noWrap={true} >
                        <span className="material-icons-round" style={{ fontSize: "medium" }}>
                          {data.ico}
                        </span>
                        &nbsp;
                        {data.text}
                      </Typography>
                    </span>
                  </span>
                )
              })}
            </div>
            );
          }



          if (
            "device_wipe_$$_result" === params.field
          ) {

            return (<div>
              {lines.map(line => {
                const [result, extra] = line.split('_$$_');                
                const data = getResultStyle(result);
                // console.log("9840 - result=", result);
                // console.log("9841 - data=", data);
                return (
                  <div>
                    <span display={'inline'} noWrap={true}>
                      <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} display={'inline'} noWrap={true}>
                        <span className="material-icons-round" style={{ fontSize: "medium" }}>
                          {data.ico}
                        </span>
                        &nbsp;
                        {data.text}
                        &nbsp;
                        <span style={{ color: "red" }}>
                          {extra !== undefined ? "(" + extra + ")" : ""}
                        </span>
                      </Typography>
                    </span>
                  </div>
                )
              })}
            </div>
            );
          }


        if (
            "general_$$_global_result" === params.field ||
            "diag_general_$$_global_result" === params.field ||
          "deployments_$$_result" === params.field || "imaging_$$_imaging_result" === params.field ||
          "disks_wipe_$$_result" === params.field
        ) {

            // console.log("9072 - lines=", params.field, lines) ;
          return (<div>
            {lines.map(line => {
              const data = getResultStyle(line);
              return (
                <div>
                    <span display={'inline'} noWrap={true}>
                  <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} >
                        <span className="material-icons-round" style={{ fontSize: "medium" }}>
                      {data.ico}
                    </span>
                    &nbsp;
                    {data.text}
                  </Typography>
                    </span>
                </div>
              )
            })}
          </div>
          );
        }


        if (
          "sbar_$$_activation_result" === params.field
        ) {

          return (<div>
            {lines.map(line => {
              const data = getSbarActivationResultStyle(line);
              return (
                <div>
                    <span display={'inline'} noWrap={true}>
                  <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} >
                        <span className="material-icons-round" style={{ fontSize: "medium" }}>
                      {data.ico}
                    </span>
                    &nbsp;
                    {data.text}
                  </Typography>
                    </span>
                </div>
              )
            })}
          </div>
          );
        }


        if (
          // CPU
          "diag_cpu_$$_full_test" === params.field ||
          "diag_cpu_$$_general_purpose_instructions" === params.field ||
          "diag_cpu_$$_floating_point_unit_instructions" === params.field ||
          "diag_cpu_$$_prime_number_test" === params.field ||
          "diag_cpu_$$_maximum_heat" === params.field ||
          "diag_cpu_$$_mmx" === params.field ||
          "diag_cpu_$$_sse" === params.field ||
          "diag_cpu_$$_sse2" === params.field ||
          "diag_cpu_$$_sse3" === params.field ||
          "diag_cpu_$$_aes" === params.field ||
          "diag_cpu_$$_sse41" === params.field ||
          "diag_cpu_$$_sse42" === params.field ||
          "diag_cpu_$$_sse4a" === params.field ||
          "diag_cpu_$$_avx" === params.field ||
            "diag_cpu_$$_fma3" === params.field ||
            "diag_cpu_$$_apple_cpu_test" === params.field ||

          // Memory
          "diag_memory_$$_ram_multi_process_torture" === params.field ||
          "diag_memory_$$_ram" === params.field ||
            "diag_memory_$$_apple_memory_test" === params.field ||

          // Storage
          "diag_storage_$$_hdd_short_smart_test" === params.field ||
          "diag_storage_$$_hdd_long_smart_test" === params.field ||
          "diag_storage_$$_hdd_linear_read_test" === params.field ||
          "diag_storage_$$_hdd_random_read_test" === params.field ||
          "diag_storage_$$_smart_attributes" === params.field ||
          "diag_storage_$$_hdd_smart_status" === params.field ||
            "diag_storage_$$_apple_storage_test" === params.field ||
          "diag_storage_$$_optical_drive_read_test" === params.field ||

          // Video adapter
          // "diag_video_adapter_$$_gpu_test" === params.field ||
          "diag_video_adapter_$$_2d_local_video_memory" === params.field ||
          "diag_video_adapter_$$_2d_all_available_memory" === params.field ||
          "diag_video_adapter_$$_2d_lines_and_bitmaps" === params.field ||
          "diag_video_adapter_$$_2d_emc_scrolling_characters" === params.field ||
          "diag_video_adapter_$$_2d_emc_reference_test_pattern" === params.field ||
          "diag_video_adapter_$$_3d" === params.field ||
            "diag_video_adapter_$$_advanced_GPU_test" === params.field ||
            "diag_video_adapter_$$_gpgpu" === params.field ||
            "diag_video_adapter_$$_apple_gpu_test" === params.field ||

          // Network
          "diag_network_$$_wired_lan" === params.field ||
          "diag_network_$$_wifi_wan" === params.field ||
            "diag_network_$$_apple_wired" === params.field ||
            "diag_network_$$_apple_wifi" === params.field ||
            "diag_network_$$_apple_bluetooth" === params.field ||

          // Audio
          "diag_audio_$$_internal_speaker" === params.field ||
          "diag_audio_$$_internal_microphone" === params.field ||
          "diag_audio_$$_output_jack" === params.field ||
          "diag_audio_$$_input_jack" === params.field ||
          "diag_audio_$$_combo_jack" === params.field ||
            "diag_audio_$$_apple_audio_test" === params.field ||

          // Screen
          "diag_screen_$$_display_ports" === params.field ||
            "diag_screen_$$_apple_hdmi_controller_test" === params.field ||
          "diag_screen_$$_dead_pixel_test" === params.field ||
          "diag_screen_$$_screen_calibration_test" === params.field ||
          "diag_screen_$$_touchscreen" === params.field ||

          // User Inputs
          "diag_user_inputs_$$_keyboard" === params.field ||
          "diag_user_inputs_$$_keyboard_status_led" === params.field ||
            "diag_user_inputs_$$_apple_keyboard_test" === params.field ||
            "diag_user_inputs_$$_apple_touch_id_test" === params.field ||
            "diag_user_inputs_$$_apple_touch_bar_test" === params.field ||
          "diag_user_inputs_$$_mouse_test" === params.field ||
          "diag_user_inputs_$$_touchpad" === params.field ||
            "diag_user_inputs_$$_apple_trackpad_test" === params.field ||
          "diag_user_inputs_$$_trackpoint" === params.field ||

          // Battery
          "diag_battery_$$_battery_wear_level" === params.field ||
          "diag_battery_$$_battery_charging_test" === params.field ||
          "diag_battery_$$_battery_drain_test" === params.field ||
            "diag_battery_$$_apple_battery_test" === params.field ||

          // Sensors
          "diag_sensors_$$_accelerometer" === params.field ||
          "diag_sensors_$$_lid_sensor" === params.field ||
            "diag_sensors_$$_apple_lid_sensor" === params.field ||
            "diag_sensors_$$_apple_ambient_ligh_sensor" === params.field ||
            "diag_sensors_$$_apple_accelerometer_gyroscope_test" === params.field ||

          // Other
          "diag_other_$$_card_reader" === params.field ||
            "diag_other_$$_apple_card_reader" === params.field ||
          "diag_other_$$_suspend_mode_test" === params.field ||
          "diag_other_$$_webcam" === params.field ||
            "diag_other_$$_apple_webcam" === params.field ||
            "diag_other_$$_apple_case_handle_test" === params.field ||
            "diag_other_$$_apple_serial_number_test" === params.field ||
            "diag_other_$$_apple_smc_test" === params.field ||
            "diag_other_$$_apple_firmware_test" === params.field ||
            "diag_other_$$_apple_fan_test" === params.field ||
            "diag_other_$$_apple_power_management_test" === params.field ||
            "diag_other_$$_apple_power_adapter_test" === params.field ||
            "diag_other_$$_apple_io_card" === params.field ||
            "diag_other_$$_apple_antenna_connector_board_test" === params.field ||
          "diag_other_$$_quick_test" === params.field
        ) {

          // console.log("lines=", lines) ;
          return (<div>
            {lines.map(line => {
              const [result, extra] = line.split('_$$_');
              const data = getDiagnosticResultStyle(result);

              return (
                  <div>
                    <span display={'inline'} noWrap={true}>
                  <Typography title={title} noWrap={true} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} >
                        <span className="material-icons-round" style={{ fontSize: "medium" }}>
                      {data.ico}
                    </span>
                    &nbsp;
                    {data.text}
                    &nbsp;
                    <span style={{ color: "black" }}>
                      {extra !== undefined ? "(" + extra + ")" : ""}
                    </span>
                  </Typography>
                </span>
                  </div>
              )
            })}
          </div>
          );
        }


          if (
            "operations_mobiles_$$_wipe" === params.field
          ) {
            return (<div>
              {lines.map(line => {
                let newLine = line;
                switch (line) {
                  case '1':
                  case 1:
                    newLine = "Success";
                    break;

                  case '2':
                  case 2:
                    newLine = "Failure";
                    break;

                  case '3':
                  case 3:
                    newLine = "Success but nothing was done";
                    break;

                  case '4':
                  case 4:
                    newLine = "Skipped";
                    break;

                  case '5':
                  case 5:
                    newLine = "Cancelled";
                    break;
                }

                const data = getMCEWipeResultStyle(newLine);
                return (
                  <div>
                    <span display={'inline'} noWrap={true}>
                      <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} >
                        <span className="material-icons-round" style={{ fontSize: "medium" }}>
                          {data.ico}
                        </span>
                        &nbsp;
                        {data.text}
                      </Typography>
                    </span>
                  </div>
                )
              })}
            </div>
            );
          }


        if (
          "tests_mobiles_$$_tests_mobiles_$$_" === params.field.substring(0, 34)
        ) {
          return (<div>
            {lines.map(line => {
              const data = getMCETestsStyle(line);
              return (
                <div>
                    <span display={'inline'} noWrap={true}>
                  <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} >
                        <span className="material-icons-round" style={{ fontSize: "medium" }}>
                      {data.ico}
                    </span>
                    &nbsp;
                    {data.text}
                  </Typography>
                    </span>
                </div>
              )
            })}
          </div>
          );
        }

        if (
          "manual_inputs_mobiles_$$_manual_inputs_mobiles_$$_" === params.field.substring(0, 61)
        ) {
            // console.log("6181 - manual_inputs_mobiles_...");
          return (<div>
            {lines.map(line => {
              const data = getMCETestsStyle(line);
              return (
                <div>
                    <span display={'inline'} noWrap={true}>
                  <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} >
                        <span className="material-icons-round" style={{ fontSize: "medium" }}>
                      {data.ico}
                    </span>
                    &nbsp;
                    {data.text}
                  </Typography>
                    </span>
                </div>
              )
            })}
          </div>
          );
        }

          if (
            "disks_wipe_$$_smart_attributes_$$_" === params.field.substring(0, 34)
          ) {
            // console.log("10381 - lines=", lines);
            return (<div>
              {lines.map(line => {
                return (
                  <div>
                    <span>
                      <Typography title={title} variant={'body2'} display={'inline'} noWrap={true}>{line}</Typography>
                    </span>
                  </div>
                )
              })}
            </div>
            );
          }

          if (
            "other_mobiles_$$_others_input_value_$$_" === params.field.substring(0, 39)
          ) {
          //   console.log("10216 - lines=", lines);
            return (<div>
              {lines.map(line => {
                return (
                  <div>
                    <span>
                      <Typography title={title} variant={'body2'} display={'inline'} noWrap={true}>{line}</Typography>
                    </span>
                  </div>
                )                
              })}
            </div>
            );
          }

        // 20230621
        if (
          "general_$$_date" === params.field ||
          "general_mobiles_$$_date" === params.field ||
          "disks_wipe_$$_date" === params.field
        ) {
          const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: 'numeric',
            minute: '2-digit'
          };

          return (<div>
            {lines.map(line => {
              if (line !== "null") {
                const dataTxt = new Date(getTimeAsZDateTime(line)).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
                return (
                  <div>
                      <span display={'inline'} noWrap={true}>
                    <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: "black" }} >
                      {dataTxt}
                    </Typography>
                      </span>
                  </div>
                )
              }
            })}
          </div>
          );
        }

        if (
          "bios_$$_date" === params.field
        ) {
          const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          };
          // console.log("7294 - bios_$$_date=", lines);

          return (<div>
            {lines.map(line => {
              if (line !== "null") {
                const dataTxt = new Date(line).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
                return (
                  <div>
                      <span display={'inline'} noWrap={true}>
                    <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: "black" }} >
                      {dataTxt}
                    </Typography>
                      </span>
                  </div>
                )
              }
            })}
          </div>
          );
        }

        if (
          "cpu_$$_nominal_frequency" === params.field ||
          "cpu_$$_maximum_frequency" === params.field ||
          "ram_bank_$$_speed" === params.field
        ) {

          return (<div>
            {lines.map(line => {
              if (line !== "undefined") {
                const dataTxt = line + " MHz";
                return (
                  <div>
                      <span display={'inline'} noWrap={true}>
                    <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: "black" }} >
                      {dataTxt}
                    </Typography>
                      </span>
                  </div>
                )
              }
            })}
          </div>
          );
        }

        if (
          "cpu_$$_l1cache" === params.field ||
          "cpu_$$_l2cache" === params.field ||
          "cpu_$$_l3cache" === params.field
        ) {

          return (<div>
            {lines.map(line => {
              if (line !== "undefined") {
                const dataTxt = line + " KB";
                return (
                  <div>
                      <span display={'inline'} noWrap={true}>
                    <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: "black" }} >
                      {dataTxt}
                    </Typography>
                      </span>
                  </div>
                )
              }
            })}
          </div>
          );
        }

        if (
          "disk_$$_total_size" === params.field ||
          "disk_$$_real_capacity" === params.field ||
          "imaging_$$_added_usedSpace" === params.field
        ) {

          // console.log("7370 - SIZE=", lines);
          return (<div>
            {lines.map(line => {
              if (line !== "undefined") {
                let dataTxt = '0 B';

                if (line !== 0) {
                  let decimals = 2;

                  const k = 1024;
                  const dm = decimals < 0 ? 0 : decimals;
                  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
                  const i = Math.floor(Math.log(line) / Math.log(k));
                  dataTxt = parseFloat((line / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
                }

                return (
                  <div>
                      <span display={'inline'} noWrap={true}>
                    <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: "black" }} >
                      {dataTxt}
                    </Typography>
                      </span>
                  </div>
                )
              }
            })}
          </div>
          );
        }

        if (
          "ram_bank_$$_total_amount" === params.field ||
          "ram_bank_$$_size" === params.field
        ) {

          // console.log("7370 - SIZE=", lines);
          return (<div>
            {lines.map(line => {
              if (line !== "undefined") {
                let dataTxt = '0 B';

                if (line !== 0) {
                  line = 1048576 * line;   // to get value in bytes          
                  let decimals = 2;

                  const k = 1024;
                  const dm = decimals < 0 ? 0 : decimals;
                  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
                  const i = Math.floor(Math.log(line) / Math.log(k));
                  dataTxt = parseFloat((line / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
                }

                return (
                  <div>
                      <span display={'inline'} noWrap={true}>
                    <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: "black" }} >
                      {dataTxt}
                    </Typography>
                      </span>
                  </div>
                )
              }
            })}
          </div>
          );
        }

        if (
          "ram_bank_$$_rank" === params.field
        ) {

          // console.log("7436 - SIZE=", lines);
          return (<div>
            {lines.map(line => {
              if (line !== "undefined") {

                let dataTxt = "";
                switch (line) {
                  case "1":
                    dataTxt = "Single";
                    break;

                  case "2":
                    dataTxt = "Dual";
                    break;

                  case "4":
                    dataTxt = "Quad";
                    break;

                  default:
                    dataTxt = "Unknown";
                }

                return (
                  <div>
                      <span display={'inline'} noWrap={true}>
                    <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: "black" }} >
                      {dataTxt}
                    </Typography>
                      </span>
                  </div>
                )
              }
            })}
          </div>
          );
        }

        if (
          "battery_$$_designed_capacity" === params.field ||
          "battery_$$_full_charged_capacity" === params.field ||
          "battery_$$_current_capacity" === params.field
        ) {

          return (<div>
            {lines.map(line => {
              if (line !== "undefined") {
                const dataTxt = line + " mWH";
                return (
                  <div>
                      <span display={'inline'} noWrap={true}>
                    <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: "black" }} >
                      {dataTxt}
                    </Typography>
                      </span>
                  </div>
                )
              }
            })}
          </div>
          );
        }

        if (
          "battery_$$_rate" === params.field
        ) {

          return (<div>
            {lines.map(line => {
                if (line !== "undefined" && line !== "" ) {
                const dataTxt = line + " mW";
                return (
                  <div>
                      <span display={'inline'} noWrap={true}>
                    <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: "black" }} >
                      {dataTxt}
                    </Typography>
                      </span>
                  </div>
                )
              }
            })}
          </div>
          );
        }

        if (
          "battery_$$_voltage" === params.field
        ) {

          return (<div>
            {lines.map(line => {
              if (line !== "undefined") {
                const dataTxt = (line / 1000) + " V";
                return (
                  <div>
                      <span display={'inline'} noWrap={true}>
                    <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: "black" }} >
                      {dataTxt}
                    </Typography>
                      </span>
                  </div>
                )
              }
            })}
          </div>
          );
        }

        if (
            "battery_$$_wear_level" === params.field ||
            "battery_$$_health_level" === params.field ||
            // "disk_$$_computed_health" === params.field ||
            // "disk_$$_computed_perf" === params.field ||
            "disk_wipe_$$_computed_health" === params.field ||
            "disk_wipe_$$_computed_perf" === params.field ||
            "disks_wipe_$$_computed_health" === params.field ||
            "disks_wipe_$$_computed_perf" === params.field
        ) {

          return (<div>
            {lines.map(line => {
                if (line !== "" && line !== undefined && line !== "undefined") {
                let dataTxt = "";
                  if (parseInt(line, 10) > 100 || parseInt(line, 10) < 0)
                  dataTxt = "-- %";
                else
                  dataTxt = line + " %";
                return (
                  <div>
                      <span display={'inline'} noWrap={true}>
                    <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: "black" }} >
                      {dataTxt}
                    </Typography>
                      </span>
                  </div>
                )
              }
            })}
          </div>
          );
        }

        if (
            "disk_wipe_$$_disk_health_percentage" === params.field
          ) {

            return (<div>
              {lines.map(line => {
                // if (line == "")
                //   line = " ";
                if (line !== "undefined" && line !== "") {

                  let dataTxt = "";
                  if (parseInt(line, 10) > 100 || parseInt(line, 10) < 0)
                    dataTxt = "-- %";
                  else {
                    if (line === " " || line === " ")
                      dataTxt = " ";
                    else
                      dataTxt = line + " %";
                  }

                  let newColor = "black";
                  if (parseInt(line, 10) >= 90 && parseInt(line, 10) <= 100) {
                    newColor = "green"
                  } else if (parseInt(line, 10) >= 0 && parseInt(line, 10) < 90) {
                    newColor = "red"
                  }
                  return (
                    <div>
                      <span display={'inline'} noWrap={true}>
                        <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: newColor }} >
                          {dataTxt}
                        </Typography>
                      </span>
                    </div>
                  )
                }
              })}
            </div>
            );
          }

          if (
            "disks_wipe_$$_disk_health_percentage" === params.field
          ) {

            return (<div>
              {lines.map(line => {
                if (line !== "undefined" && line !== "") {

                  let dataTxt = "";
                  if (parseInt(line, 10) > 100 || parseInt(line, 10) < 0)
                    dataTxt = "-- %";
                  else {
                    if (line === " " || line === " ")
                      dataTxt = " ";
                    else
                      dataTxt = line + " %";
                  }

                  let newColor = "black";
                  if (parseInt(line, 10) >= 90 && parseInt(line, 10) <= 100) {
                    newColor = "green"
                  } else if (parseInt(line, 10) >= 0 && parseInt(line, 10) < 90) {
                    newColor = "red"
                  }
                  return (
                    <div>
                      <span display={'inline'} noWrap={true}>
                        <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: newColor }} >
                          {dataTxt}
                        </Typography>
                      </span>
                    </div>
                  )
                }
              })}
            </div>
            );
          }

          if (
          "sbar_$$_activation_type" === params.field ||
          "trade_in_$$_code" === params.field
        ) {

          return (<div>
            {lines.map(line => {
              if (line !== "undefined") {
                const dataTxt = line.toUpperCase();
                return (
                  <div>
                      <span display={'inline'} noWrap={true}>
                    <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: "black" }} >
                      {dataTxt}
                    </Typography>
                      </span>
                  </div>
                )
              }
            })}
          </div>
          );
        }

        if (
          "deployments_$$_image_deployed_os" === params.field
        ) {

          return (<div>
            {lines.map(line => {
              if (line !== "undefined") {

                const regex = /(?:WINVISTA_)([0-9]+)(_?)(.*)/i;  // 
                const items = line.match(regex);

                let os_version = "Windows";
                let architecture = "32";
                let dataTxt = "";

                if (items) {
                  switch (items[1]) {
                    case '7':
                      os_version = "Windows 7 ";
                      break;

                    case '8':
                      os_version = "Windows 8 ";
                      break;

                    case '10':
                      os_version = "Windows 10 ";
                      break;

                    case '11':
                      os_version = "Windows 11 ";
                      break;

                    default:
                      os_version = "Windows ";
                  }

                  switch (items[3]) {
                    default:
                    case '32':
                      architecture = "32 bits";
                      break;

                    case '64':
                      architecture = "64 bits";
                      break;

                    case 'ARM64':
                      architecture = "ARM 64 bits";
                      break;
                  }
                  dataTxt = os_version + architecture;
                }
                else
                  dataTxt = line;

                // const dataTxt = line.toUpperCase();
                return (
                  <div>
                      <span display={'inline'} noWrap={true}>
                    <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: "black" }} >
                      {dataTxt}
                    </Typography>
                      </span>
                  </div>
                )
              }
            })}
          </div>
          );
        }


          if ("hexadecimal_viewer_$$_result" === params.field) {
            return (<div >
              {lines.map(line => {
                const data = getHexadecimalViewerStyle(line);
                return (
                  <div>
                    <span display={'inline'} noWrap={true}>
                      <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} display={'inline'} noWrap={true}>
                        <span className="material-icons-round" style={{ fontSize: "medium" }}>
                          {data.ico}
                        </span>
                        &nbsp;
                        {data.text}
                      </Typography>
                    </span>
                  </div>
                )
              })}
            </div>
            );
          }

          if ("hexadecimal_viewer_$$_disk_validated" === params.field) {

            return (<div >
              {lines.map(line => {
                const data = getDiskValidatedStyle(line);

                if (data.checked !== " ")
                  return (
                    <div>
                      <span display={'inline'} noWrap={true}>
                        <Typography title={title} variant={'body2'} style={{ color: "black" }} display={'inline'} noWrap={true}>
                          {data.checked}
                        </Typography>
                        &nbsp;:&nbsp;
                        <Typography title={title} variant={'body2'} style={{ color: ((data.color !== "") ? data.color : "black") }} display={'inline'} noWrap={true}>
                          {data.validated}
                        </Typography>
                      </span>
                    </div>
                  )
              })}
            </div>
            );
          }


          if (
            "disk_$$_ppid" === params.field ||
            "disk_wipe_$$_ppid" === params.field ||
            "disks_wipe_$$_ppid" === params.field
          ) {
            return (
              <div>
              {lines.map(line => {
                const data = getPPIDStyle(line);
                return (
                  <div>
                    <span display={'inline'} noWrap={true}>
                      <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} display={'inline'} noWrap={true}>
                        {data.text}
                      </Typography>
                    </span>
                  </div>
                )
              })}
            </div>
            );
          }


          if (
            "video_card_$$_allocated_memory_size" === params.field
          ) {
            return (
              <div>
                {lines.map(line => {
                  if (line && line !== "undefined" && line !== "0" && line !== "" && line !== "null")
                    line += " MB"
					  return (
						<div>
						  <span>
							<Typography title={title} variant={'body2'} display={'inline'} noWrap={true}>{line}</Typography>
						  </span>
						</div>
					  )
                })}
              </div>
            );
          }

          if (
            "video_card_$$_memory_bus" === params.field
          ) {
            return (
              <div>
                {lines.map(line => {
                  if (line && line !== "undefined" && line !== "0" && line !== "" && line !== "null")
                    line += " bits"
					  return (
						<div>
						  <span>
							<Typography title={title} variant={'body2'} display={'inline'} noWrap={true}>{line}</Typography>
						  </span>
						</div>
					  )
                })}
              </div>
            );
          }



          if ("locks_$$_lock_bios_admin_password" === params.field) {
            return (<div >
              {lines.map(line => {
                const data = getBIOSAdminPasswordLockStyle(line);
                return (
                  <div>
                    <span display={'inline'} noWrap={true}>
                      <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} display={'inline'} noWrap={true}>
                        {data.text}
                      </Typography>
                    </span>
                  </div>
                )
              })}
            </div>
            );
          }

          if ("locks_$$_lock_bios_computrace_status" === params.field) {
            return (<div >
              {lines.map(line => {
                const data = getBIOSComputraceStatusStyle(line);
                return (
                  <div>
                    <span display={'inline'} noWrap={true}>
                      <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} display={'inline'} noWrap={true}>
                        {data.text}
                      </Typography>
                    </span>
                  </div>
                )
              })}
            </div>
            );
          }

          if (
            "locks_mobiles_$$_rooted_jailbroken" === params.field ||
            "locks_mobiles_$$_blacklisted" === params.field ||
            "locks_mobiles_$$_samsung_reactivation_lock" === params.field ||
            "locks_mobiles_$$_ios_mdm_configured" === params.field ||
            // "locks_mobiles_$$_xiaomi_account" === params.field ||
            // "locks_mobiles_$$_google_account" === params.field ||
            // "locks_mobiles_$$_huawei_account" === params.field ||            
            "locks_mobiles_$$_zero_touch_enrollment" === params.field
          ) {
            return (<div >
              {lines.map(line => {
                let newLine = line;
                switch (line) {
                  case '1':
                  case '32767':
                    newLine = "No";
                    break;

                  case '32778':
                  case '32775':
                    newLine = "Yes";
                    break;

                  case '32773':
                  case '32774':
                  case '32780':
                    newLine = "Enabled";
                    break;

                  case '32777':
                    newLine = "Warning";
                    break;

                  case '32785':
                    newLine = "Failed";
                    break;

                  case 0:
                  case '0':
                  case 'null':
                  case null:
                    newLine = "Unknown";
                    break;
                }

                const data = getRedYesStyle(newLine);
                return (
                  <div>
                    <span display={'inline'} noWrap={true}>
                      <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} display={'inline'} noWrap={true}>
                        <span className="material-icons-round" style={{ fontSize: "medium" }}>
                          {data.ico}
                        </span>
                        &nbsp;
                        {data.text}
                      </Typography>
                    </span>
                  </div>
                )
              })}
            </div>
            );
          }

          if (
            "locks_mobiles_$$_google_fpr_lock" === params.field ||
            "locks_mobiles_$$_find_my_iphone" === params.field
          ) {
            return (<div >
              {lines.map(line => {
                let newLine = line;
                switch (line) {
                  case '1':
                    newLine = "Disabled";
                    break;

                  case '32773':
                  case '32774':
                    newLine = "Enabled";
                    break;

                  case 'null':
                  case null:
                    newLine = "Unknown";
                    break;
                }

                const data = getRedYesStyle(newLine);
                return (
                  <div>
                    <span display={'inline'} noWrap={true}>
                      <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} display={'inline'} noWrap={true}>
                        <span className="material-icons-round" style={{ fontSize: "medium" }}>
                          {data.ico}
                        </span>
                        &nbsp;
                        {data.text}
                      </Typography>
                    </span>
                  </div>
                )
              })}
            </div>
            );
          }

          if (
            "locks_mobiles_$$_sim_lock" === params.field
          ) {
            // console.log("lines=", lines);
            return (<div >
              {lines.map(line => {
                let newLine = line;
                switch (line) {
                  case '1':
                    newLine = "N/A";
                    break;

                  case '2':
                  case '3':
                  case '4':
                    newLine = "Enabled";
                    break;

                  case '5':
                    newLine = "Disabled";
                    break;

                  case '6':
                    newLine = "SIM not ready";
                    break;

                  case '7':
                    newLine = "SIM disabled";
                    break;

                  case '8':
                    newLine = "SIM Error";
                    break;

                  case '9':
                    newLine = "SIM Restricted";
                    break;

                  case '0':
                  case 'null':
                  case null:
                    newLine = "Unknown";
                    break;
                }

                const data = getSimLockStyle(newLine);
                return (
                  <div>
                    <span display={'inline'} noWrap={true}>
                      <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} display={'inline'} noWrap={true}>
                        <span className="material-icons-round" style={{ fontSize: "medium" }}>
                          {data.ico}
                        </span>
                        &nbsp;
                        {data.text}
                      </Typography>
                    </span>
                  </div>
                )
              })}
            </div>
            );
          }

          if (
            "locks_mobiles_$$_device_genuine" === params.field ||
            "locks_mobiles_$$_battery_genuine" === params.field
          ) {
            return (<div >
              {lines.map(line => {
                let newLine = line;
                switch (line) {
                  case '1':
                    newLine = "Yes";
                    break;

                  case '32782':
                  case '32784':
                    newLine = "No";
                    break;

                  case 'null':
                  case null:
                    newLine = "Unknown";
                    break;
                }

                const data = getGreenYesStyle(newLine);
                return (
                  <div>
                    <span display={'inline'} noWrap={true}>
                      <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} display={'inline'} noWrap={true}>
                        <span className="material-icons-round" style={{ fontSize: "medium" }}>
                          {data.ico}
                        </span>
                        &nbsp;
                        {data.text}
                      </Typography>
                    </span>
                  </div>
                )
              })}
            </div>
            );
          }

          if (
            "general_mobiles_$$_grade" === params.field 
          ) {
            return (<div >
              {lines.map(line => {
                let newLine = line;
                switch (line) {
                  case '0':
                    newLine = "Lowest";
                    break;

                  case '1':
                    newLine = "C -";
                    break;

                  case '2':
                    newLine = "C +";
                    break;

                  case '3':
                    newLine = "B -";
                    break;

                  case '4':
                    newLine = "B +";
                    break;

                  case '5':
                    newLine = "A -";
                    break;

                  case '6':
                    newLine = "A +";
                    break;

                  case 'null':
                  case null:
                    newLine = "Undefined";
                    break;
                }

                return (
                  <div>
                    <span>
                      <Typography title={title} variant={'body2'} display={'inline'} noWrap={true}>{newLine}</Typography>
                    </span>
                  </div>
                )
              })}
            </div>
            );
          }

          if (
            "hardware_battery_mobiles_$$_grade" === params.field
          ) {
            return (<div >
              {lines.map(line => {
                let newLine = line;
                switch (line) {
                  case '1':
                    newLine = "D -";
                    break;

                  case '2':
                    newLine = "D";
                    break;

                  case '3':
                    newLine = "D +";
                    break;

                  case '4':
                    newLine = "C -";
                    break;

                  case '5':
                    newLine = "C";
                    break;

                  case '6':
                    newLine = "C +";
                    break;

                  case '7':
                    newLine = "B -";
                    break;

                  case '8':
                    newLine = "B";
                    break;

                  case '9':
                    newLine = "B +";
                    break;

                  case '10':
                    newLine = "A -";
                    break;

                  case '11':
                    newLine = "A";
                    break;

                  case '12':
                    newLine = "A +";
                    break;

                  case '0':
                  case 'null':
                  case null:
                    newLine = "Undefined";
                    break;
                }

                return (
                  <div>
                    <span>
                      <Typography title={title} variant={'body2'} display={'inline'} noWrap={true}>{newLine}</Typography>
                    </span>
                  </div>
                )
              })}
            </div>
            );
          }


          if (
            "general_mobiles_$$_overall_result" === params.field
          ) {
            return (
              lines.map(line => {

                const data = getResultStyle(line);
                return (
                  <div>
                    <span display={'inline'} noWrap={true}>
                      <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} display={'inline'} noWrap={true}>
                        <span className="material-icons-round" style={{ fontSize: "medium" }}>
                          {data.ico}
                        </span>
                        &nbsp;
                        {data.text}
                      </Typography>
                    </span>
                  </div>
                )
              })
            )
          }


          if (
            "bootimage_$$_secure_boot" === params.field ||
            "bootimage_$$_t2_security" === params.field
          ) {
            return (
              lines.map(line => {
                const [result, extra] = line.split('_$$_');
                const data = getBootImageSecureResultStyle(result);

                return (
                  <div>
                    <span display={'inline'} noWrap={true}>
                      <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: ((data.color !== "") ? data.color : "black") }} display={'inline'} noWrap={true}>
                        <span className="material-icons-round" style={{ fontSize: "medium" }}>
                          {data.ico}
                        </span>
                        &nbsp;
                        {data.text}
                      </Typography>
                    </span>
                  </div>
                )
              })
            )
          }

          if (
            "network_card_$$_protocol_version" === params.field
          ) {
            let linesType;
            const types = params.row && params.row["network_card_$$_protocol_version_type"];
            if (types)
              linesType = String(types).split(line_separator);

            return (
              <div>
                {lines.map((line, index) => {
                  const [result, extra] = line.split('_$$_');
                  let versionTxt = "";
                  if (result && linesType) {
                    if (linesType[index] === "Wireless")
                      versionTxt = getWifiVersionText(result);
                    else if (linesType[index] === "Bluetooth") {
                      versionTxt = 'Bluetooth ' + result;
                    }
                    else {
                      versionTxt = ' ';
                    }
                  }

                  return (
                    <div>
                      <div>
                        <span display={'inline'} noWrap={true}>
                          <Typography title={title} variant={'body2'} style={{ alignItems: "center", display: "flex", color: "black" }} display={'inline'} noWrap={true}>
                            {versionTxt}
                          </Typography>
                        </span>
                      </div>
                    </div>
                  )
                })}
              </div>
            );
          }

        return (<div>
          {lines.map((line, index) => {

            //console.log("> 5504 - line=", index, line, params.id); // Only shown columns
            if (
              line !== "undefined" &&
              line !== "null"
            ) {
              // if (index < 7) {
              if (line === "")
                line = " ";     // invisible space...

              // if (index === 6)
              //   line = "      (...)  ";

              return (
                <div>
                    <span>
                  <Typography title={title} variant={'body2'} display={'inline'} noWrap={true}>{line}</Typography>
                    </span>
                </div>
              )
              // }
            }
            else
              return (
                <div></div>
              )
          })
          }
        </div>
        );
      }
    }

      // console.log("9555 - newColum=", newColum);
      localColumns.push(newColum);
    }

    // console.log("9023 - localColumns=", localColumns);
    // console.log("9022 - localFilteredRows=", localFilteredRows);
    // console.log("9017 - fixedRowCount=", fixedRowCount);
    // console.log("9018 - localMaxRowLines=", localMaxRowLines);



    // SET STATES...
    setFilteredRows(localFilteredRows);
    setMaxRowLines(localMaxRowLines);
    setHeaderLinesRatio(localHeaderLinesRatio);

    // console.log("9029 - sortModel=", sortModel);

    setActiveSortModel([]);
    if (sortModel) {
      let newActiveSortModel = [];
      for (const element of sortModel) {
        const found = localColumns.find(o => {
          return element.field === o.field
        })
        if (found) {
          newActiveSortModel.push(element);
        }
  }
      // console.log("9043 - localColumns=", localColumns);
      setColumns(localColumns);

      // console.log("9042 - newActiveSortModel=", newActiveSortModel);
      setActiveSortModel(newActiveSortModel);
    }
    else
      setColumns(localColumns);

    // console.log("9078 - processColumns DONE");
  }

  //------------------------------

  const rescheduleGetMultiReportArchiveGeneratedStatusCheck = (archiveCode, count) => {

    if (count < 10000) {
      setTimeout(() => {
        getMultiReportArchiveGeneratedStatusCheck(archiveCode, count);
      }, 2500);
    }
    else 
      Swal.close();
  };

  const getMultiReportArchiveGeneratedStatusCheck = async (archiveCode, count) => {
    // console.log("12050 - getMultiReportArchiveGeneratedStatusCheck=", archiveCode, count);
    try {
    const res = await getMultiReportArchiveGeneratedStatus(archiveCode);

    console.log("12053 - res=", res);
      if (res) {
    if (res.success) {
      if (res.status === 1) {   // In progress
        console.log("12056 - res=", res);
        console.log("1259 - selectionModel...", selectionModel.length);

        Swal.update({
              html: t('admin.reports.in_progress') + " (" + res.count + "/" + (selectionModel.length) + ")."
            });

            rescheduleGetMultiReportArchiveGeneratedStatusCheck(archiveCode, count + 1);
          }
          else if (res.status === 2) {   // Archiving
            console.log("12068 - res=", res);
            
            Swal.update({
              html: t('admin.reports.archive_in_progress') + "... "
        });

        rescheduleGetMultiReportArchiveGeneratedStatusCheck(archiveCode, count + 1);
      }
      else {
            if (res.status === 3) {   // Success
              console.log("12069 - res=", res);
          Swal.close();
          //download file...
          toast(decodeHTMLEntities(t('admin.reports.success')), { type: 'success' });
          await processDownloads(res)
        }
        else {                    // Failure    
          Swal.close();
          toast(decodeHTMLEntities(t('admin.reports.errors.' + res)), { type: 'error' });
        }
      }
    }
        else {                    // Failure    
          // Swal.close();
          // toast(decodeHTMLEntities(t('admin.reports.errors.' + res)), { type: 'error' });
          console.log("12095 - ERROR... retry...");
          rescheduleGetMultiReportArchiveGeneratedStatusCheck(archiveCode, count + 1);
        }
  }
      else {
        console.log("12100 - ERROR... retry...");
        //Swal.close();
        rescheduleGetMultiReportArchiveGeneratedStatusCheck(archiveCode, count + 1);
      }
    }
    catch (error) {
      console.log("12106 - error=", error);
      Swal.close();
    }
  }

  const callReportGenerator = async (devicesType) => {

    // console.log("1259 - callReportGenerator...", selectionModel);
    // TEST OF REPORT GENERATOR

    if (deployments.length !== 0 && selectedReport !== undefined) {
      toast(decodeHTMLEntities(t('admin.reports.in_progress')), { type: 'success' });

      const mapDeploymentList = new Map();
      const mapDiskSerialList = new Map();

      let tmpReportMaxCount = 0;
      let tmpReportCurrentCount = 0;

      // - TEST 005 --------------------------------------------
      for (const checked of selectionModel) {
        const element = deployments[checked - 1];

        // console.log("13096 - element=", element);

        const tmpDeploymentIdsList = mapDeploymentList.get(element.location_id);
        if (tmpDeploymentIdsList) {
          if (devicesType === 2) {
            if (!tmpDeploymentIdsList.includes(element.serial + " / " + element.deployment_id))
              tmpDeploymentIdsList.push(element.serial + " / " + element.deployment_id);
          }
          else
          tmpDeploymentIdsList.push(element.deployment_id ? element.deployment_id : element.mceDeploymentID);
        }
        else {
          let newDeploymentIdsList = [];
          if (devicesType === 2) {
            if (!newDeploymentIdsList.includes(element.serial + " / " + element.deployment_id))
              newDeploymentIdsList.push(element.serial + " / " + element.deployment_id);
          }
          else
          newDeploymentIdsList.push(element.deployment_id ? element.deployment_id : element.mceDeploymentID);

          mapDeploymentList.set(element.location_id, newDeploymentIdsList);
        }

        tmpReportMaxCount++;
        // console.log("1269 - element...", element);
      }

      // console.log("1290 - mapDeploymentList...", mapDeploymentList);
      const tmpArray = Array.from(mapDeploymentList.keys());
      const arrayRes = [];

      // console.log("11122 - selectedReport=", selectedReport);
      // console.log("11128 - mapDeploymentList=", mapDeploymentList);
      // console.log("11122 - tmpReportMaxCount=", tmpReportMaxCount);

      setReportCurrentCount(tmpReportCurrentCount);
      setReportMaxCount(tmpReportMaxCount);

      if (settings.reportsInArchive === true) {

        const allDeploymentList = JSON.stringify(Array.from(mapDeploymentList));
        const res = await getMultiReportArchiveGenerated(allDeploymentList, selectedReport, devicesType);

        if (!res.success) {
          toast(decodeHTMLEntities(t('admin.reports.errors.' + res)), { type: 'error' });
        }
        else {
          // console.log('12087 - res', res);

          Swal.fire({
            allowOutsideClick: false,
            title: t('global.dialog_title'),
            html: t('admin.reports.generating'),
            showCancelButton: false,
            showConfirmButton: false,
            customClass: {
              confirmButton: 'confirm-button-class',
              title: 'title-class',
              icon: 'icon-class'
            }
          });

          setTimeout(() => {
            getMultiReportArchiveGeneratedStatusCheck(res.archiveCode, 1);
          }, 2000);
        }
        setReportMaxCount(0);
      }
      else {
        const arrayDiskSerial = Array.from(mapDiskSerialList.values());

      for (const key of tmpArray) {
        const values = mapDeploymentList.get(key);

        let index = 0;
        const arrayArrayTmp = [];

        while (index < values.length) {
          let i = 0;
          const arrayTmp = [];

          while (i < 7) {
            if (index < values.length) {
              const element = values[index];
              arrayTmp.push(element);
              index++;
            }
            i++;
          }
          if (arrayTmp.length)
            arrayArrayTmp.push(arrayTmp);
        }

        const maxPromises = 7;
        let arrayPromises = [];
        let indexArrayArrayTmp = 0;

        // PARSE arrayArrayTmp
        while (indexArrayArrayTmp < arrayArrayTmp.length) {

          const arrayTmp = arrayArrayTmp[indexArrayArrayTmp];

          let arrayPromisesTmp = [];
          for (let indexArrayPromises = 0; indexArrayPromises < arrayPromises.length; indexArrayPromises++) {
            const statusPending = await isPromisePending(arrayPromises[indexArrayPromises]);
            if (statusPending)
              arrayPromisesTmp.push(arrayPromises[indexArrayPromises]);
          }
          arrayPromises = arrayPromisesTmp;

          if (arrayPromises.length + 1 > maxPromises) {
            await pauseMe(1000);
          }
          else {
            const promiseTmp = new Promise(async (resolve, reject) /*(arrayTmp, key, selectedReport, devicesType)*/ => {

              const res = await getMultiReportGenerated(arrayTmp, key, selectedReport, devicesType);

              if (!res.success) {
                toast(decodeHTMLEntities(t('admin.reports.errors.' + res)), { type: 'error' });
              }
              else {
                // console.log('11317 - tmpReportCurrentCount', tmpReportCurrentCount);
                await processDownloads(res)
                tmpReportCurrentCount = tmpReportCurrentCount + arrayTmp.length;
                setReportCurrentCount(tmpReportCurrentCount);
              }
              resolve();
            });
            arrayPromises.push(promiseTmp);
            indexArrayArrayTmp++;
          }
        }       
      }
      }
      setReportMaxCount(0);
    }
  };


  const getSdsMobilesList = (deployment) => {
    // console.log("553 - enter getSdsTestsMobilesList=", deployment);

    const sdsTestsMobilesList = [];
    const sdsManualInputsMobilesList = [];
    const sdsOthersMobilesList = [];

    for (const [key, value] of Object.entries(deployment)) {
      if (key.substring(0, 8) === "[<XTRA>]") {

        const realKey = key.substring(8);

        // ' Test'
        const testStr = realKey.substring(realKey.length - 5);
        if (testStr === ' Test') {

          let newKey = realKey.substring(0, realKey.indexOf(' Test'));
          newKey = newKey.charAt(0).toUpperCase() + newKey.slice(1);
          sdsTestsMobilesList.push(JSON.stringify({ xtra_desc: newKey, xtra_value: value }, 3, null));
        }
        else {
          const questionStr = realKey.substring(realKey.length - 1);
          if (questionStr === '?') {
            let newKey = realKey.charAt(0).toUpperCase() + realKey.slice(1);
            sdsManualInputsMobilesList.push(JSON.stringify({ xtra_desc: newKey, xtra_value: value }, 3, null));
          }
          // else if (
          //   realKey === "Auditor_Name" ||
          //   realKey === "Asset_Tag" ||
          //   realKey === "NT_Tag" ||
          //   realKey === "PO_#"
          // ) {
          //   let newKey = realKey.charAt(0).toUpperCase() + realKey.slice(1);
          //   sdsManualInputsMobilesList.push(JSON.stringify({ xtra_desc: newKey, xtra_value: value }, 3, null));

          //   console.log("9396 - newKey=", newKey);
          // }
          else {
            // console.log("622 - realKey=", realKey);

            // OTHER EXTRA VALUES...
            if (
              realKey !== "Overall Result" &&
              realKey !== "Error Codes" &&
              realKey !== "Grade" &&
              realKey !== "Battery Max Capacity" &&
              realKey !== "Battery Design Capacity" &&
              realKey !== "Battery Cycle Count" &&
              realKey !== "Battery SOH" &&
              realKey !== "SIM Lock" &&
              realKey !== "Google Enterprise Configured" &&
              realKey !== "iOS MDM Configured" &&
              realKey !== "Samsung Knox Configured" &&
              realKey !== "Flash" &&
              realKey !== "Wipe" &&
              realKey !== "Esim Wipe" &&
              realKey !== "Esim Active" &&
              realKey !== "Esim Carrier" &&
              realKey !== "Activate" &&
              // realKey !== "IQ_Reseller Number" &&
              realKey !== "FED Check" &&
              realKey !== "Warranty End Date" &&
              realKey !== "Under Warranty"
            ) {
              let newKey = realKey.charAt(0).toUpperCase() + realKey.slice(1);
              sdsOthersMobilesList.push(JSON.stringify({ xtra_desc: newKey, xtra_value: value }, 3, null));

            }
          }
        }
      }
      else if (key.substring(0, 8) === "[<TEST>]") {

        const realKey = key.substring(8);

        // console.log("10006 - key=", key);
        // console.log("10006 - realKey=", realKey);
        // console.log("10006 - value=", value);

        const picesaoftTestDesc = t(`piceasoft_test_case.${realKey}`);
        const picesaoftTestValue = t(`piceasoft_test_case_status.${value.test_result}`);

        sdsTestsMobilesList.push(JSON.stringify({ xtra_desc: picesaoftTestDesc, xtra_value: value.test_result, original_value: value.test_result, skipped_reason: value.test_skipped_reason, timestamp: value.test_timestamp }, 3, null));
        // sdsTestsMobilesList.push(JSON.stringify({ xtra_desc: realKey, xtra_value: value.test_result }, 3, null));

      }
    }

    // console.log("566 - ret=", sdsTestsMobilesList, sdsManualInputsMobilesList, sdsOthersMobilesList);
    return {
      tests: sdsTestsMobilesList,
      manualInputs: sdsManualInputsMobilesList,
      others: sdsOthersMobilesList
    }
  };



  const loadDeploymentsHeaders = async () => {
    const repWelcomeScreenManualInputsPromise = getWelcomeScreenManualInputs({ locations: getSelectedLocations(pickers.locations.show, selected.locations) });
    const repSDSQPromise = getSDSQuestions({ locations: getSelectedLocations(pickers.locations.show, selected.locations) });
    const repScriptHPromise = getScriptHeaders({ locations: getSelectedLocations(pickers.locations.show, selected.locations) });

    const repExtDiskHealthAndPerfPromise = getExtDiskHealthAndPerf({ locations: getSelectedLocations(pickers.locations.show, selected.locations) });

    const repMobileOthersDataPromise = getMobileOthersData({ locations: getSelectedLocations(pickers.locations.show, selected.locations) });

    const repWelcomeScreenManualInputs = await repWelcomeScreenManualInputsPromise;
    // console.log("11510 - repWelcomeScreenManualInputs=", repWelcomeScreenManualInputs);
    setWelcomeScreenManualInputs(repWelcomeScreenManualInputs.result);

    const repSDSQ = await repSDSQPromise;
    setSdsQuestions(repSDSQ.result);

    const repScriptH = await repScriptHPromise;
    setScriptHeaders(repScriptH.result);

    const repMobileOthersData = await repMobileOthersDataPromise;
    setMobileOthersData(repMobileOthersData.result);

    let sdsExtraDiskHealthFlagTmp = false;
    let sdsExtraDiskPerfFlagTmp = false;

    const repExtDiskHealthAndPerf = await repExtDiskHealthAndPerfPromise;
    if (repExtDiskHealthAndPerf && repExtDiskHealthAndPerf.result) {
      if (repExtDiskHealthAndPerf.result.health && repExtDiskHealthAndPerf.result.health.length) {
        // console.log("12726 - repExtDiskHealthAndPerf.result.heath=", repExtDiskHealthAndPerf.result.health);
        sdsExtraDiskHealthFlagTmp = true;
      }
      if (repExtDiskHealthAndPerf.result.perf && repExtDiskHealthAndPerf.result.perf.length) {
        // console.log("12729 - repExtDiskHealthAndPerf.result.perf=", repExtDiskHealthAndPerf.result.perf);
        sdsExtraDiskPerfFlagTmp = true;
      }
    }
    setSdsExtraDiskHealthFlag(sdsExtraDiskHealthFlagTmp);
    setSdsExtraDiskPerfFlag(sdsExtraDiskPerfFlagTmp);


    // setScriptHeaders(repScriptH.result);
    // console.log("12726 - repExtDiskHealthAndPerf=", repExtDiskHealthAndPerf);


    let newReportingColumns;

    if (settings.mode === undefined || settings.mode !== "modules") {
      const columnsFromDatabase = await getColumns(
        scenario && scenario.id, scenario && scenario.devicesType
      );
      // console.log("12713 - columnsFromDatabase=", columnsFromDatabase);


      if (columnsFromDatabase && columnsFromDatabase.reportingColumns && columnsFromDatabase.reportingColumns[0]) {
        setWithExtraColumns(JSON.parse(columnsFromDatabase.reportingColumns[0].ReportingColumns));

        // 20230823 SortModel
        const tmpSortModel = await getSortModel(
          scenario && scenario.id, scenario && scenario.devicesType
        );
        setActiveSortModel([]);
        if (tmpSortModel && tmpSortModel.sortModel && tmpSortModel.sortModel[0]) {
          setSortModel(JSON.parse(tmpSortModel.sortModel[0].SortModel));
        }

        newReportingColumns = JSON.parse(columnsFromDatabase.reportingColumns[0].ReportingColumns).filter(o => o.extraColumn !== true);

        let allAvailableColId = getAllAvailableColumns(scenario, repWelcomeScreenManualInputs.result, repSDSQ.result, repScriptH.result, repMobileOthersData.result, sdsExtraDiskHealthFlag, sdsExtraDiskPerfFlag);
         
        if (allAvailableColId.length !== 0) {
          let change = false;
          for (var indexReportingColumns = 0; indexReportingColumns < newReportingColumns.length; indexReportingColumns++) {
            const column = newReportingColumns[indexReportingColumns];

            const found = (allAvailableColId.indexOf(column.field) > -1);
            if (!found) {
              newReportingColumns.splice(newReportingColumns.indexOf(newReportingColumns[indexReportingColumns]), 1);
              --indexReportingColumns;
              change = true;
            }
          }
        }
        dispatch({ reportingColumns: newReportingColumns });
        eventDispatch({ reportingColumnsStatus: "loaded" });
      }
    }
    else if (settings.mode === "modules") {
      const columnsFromDatabase = await getColumnsForModule(
        module
      );
      // console.log("12505 - columnsFromDatabase=", columnsFromDatabase);


      if (columnsFromDatabase && columnsFromDatabase.reportingColumns && columnsFromDatabase.reportingColumns[0]) {
        setWithExtraColumns(JSON.parse(columnsFromDatabase.reportingColumns[0].ReportingColumns));

        const tmpSortModel = await getSortModelForModule(
          module
        );
        setActiveSortModel([]);
        if (tmpSortModel && tmpSortModel.sortModel && tmpSortModel.sortModel[0]) {
          setSortModel(JSON.parse(tmpSortModel.sortModel[0].SortModel));
        }

        newReportingColumns = JSON.parse(columnsFromDatabase.reportingColumns[0].ReportingColumns).filter(o => o.extraColumn !== true);

        let allAvailableColId = getAllAvailableColumns(scenario, repWelcomeScreenManualInputs.result, repSDSQ.result, repScriptH.result, repMobileOthersData.result, sdsExtraDiskHealthFlag, sdsExtraDiskPerfFlag);

        if (allAvailableColId.length !== 0) {
          let change = false;
          for (var indexReportingColumns = 0; indexReportingColumns < newReportingColumns.length; indexReportingColumns++) {
            const column = newReportingColumns[indexReportingColumns];

            const found = (allAvailableColId.indexOf(column.field) > -1);
            console.log("12560 - column=", column.field, found);
            if (!found) {
              newReportingColumns.splice(newReportingColumns.indexOf(newReportingColumns[indexReportingColumns]), 1);
              --indexReportingColumns;
              change = true;
            }
          }
        }

        dispatch({ reportingColumns: newReportingColumns });
        eventDispatch({ reportingColumnsStatus: "loaded" });
      }
    }
    // console.log("13231 - loadDeploymentsHeaders - END");
  };


  const loadDeploymentsData = async (cancelValue, startDate, endDate) => {
    // console.log("13237 - loadDeploymentsData - BEGIN");

    let newRows = [];
    let res;

    //for (const location of getSelectedLocations(pickers.locations.show, selected.locations)) {
    //await Promise.all(
    // getSelectedLocations(pickers.locations.show, selected.locations).map(async location => {
    //   const locationsTmp = [];
    //   locationsTmp.push(location);

    let offset = 0;
    let size = 1000;       //  0 => NOT using "OFFSET m ROWS FETCH NEXT n ROWS ONLY;" type query
    let processColumnsDone = false;

    const mode = settings.mode || "all_scenario";
    do {

      // CANCEL REQUEST...
      if (cancelation.current !== cancelValue) {
        setCancelled(true);
        setDeployments([]);

        const savSelectedReport = selectedReport;
        // console.log("11195 - savSelectedReport=", savSelectedReport);

        setSelectedReport(null);
        const rep = await getReports();

        if (rep && rep.reports) {
          for (const report of rep.reports) {
            if (report.id === savSelectedReport && report.type === scenario.devicesType) {
              setSelectedReport(savSelectedReport);
            }
          }
        }

        setReports(rep.reports);
        // console.log("11201 - rep.reports=", rep.reports);

        // console.log("11203 - set loading false");
        appDispatch({ loading: false });
        return;
      }
      else {
        setCancelled(false);
        appDispatch({ loading: true });
      }

      // console.log("12434 - getDeployments...");
      res = await getDeployments({
        mode,
        scenario, module, startDate, endDate,
        groups: getSelectedGroups(pickers.groups, selected.groups),
        locations: getSelectedLocations(pickers.locations.show, selected.locations), //locationsTmp, //
        offset, size
      });
      offset += size;

      if (size !== 2000) // 5000
        size = 2000;

      if (!res || !res.success) {
        // setLoading(false); // Stop loading bar if an error occurs
        // console.log("9546 - set loading false");

        appDispatch({ loading: false });
        return toast(decodeHTMLEntities(t('reporting.errors.' + res)), { type: 'error' });
      }

      if (cancelation.current !== cancelValue) {
        setCancelled(true);
        setDeployments([]);

        const savSelectedReport = selectedReport;
        // console.log("11266 - savSelectedReport=", savSelectedReport);

        setSelectedReport(null);
        const rep = await getReports();

        if (rep && rep.reports) {
          for (const report of rep.reports) {
            if (report.id === savSelectedReport && report.type === scenario.devicesType) {
              setSelectedReport(savSelectedReport);
            }
          }
        }

        // setReports(rep.reports);
        // console.log("11272 - rep.reports=", rep.reports);

        setReports(rep.reports);
        // console.log("9565 - set loading false");
        appDispatch({ loading: false });
        return;
      }

      // console.log("11673 - res.deployments=", res.deployments);
      newRows = newRows.concat(res.deployments);
      // console.log("9559 - concat DONE...");

      const newNewRows = newRows.sort(function (a, b) {

      // setDeployments(newNewRows.sort(function (a, b) {
        if (a.group && b.group && a.group.toLowerCase() < b.group.toLowerCase()) {
          return -1;
        }
        if (a.group && b.group && b.group.toLowerCase() < a.group.toLowerCase()) {
          return 1;
        }

        if (a.location && b.location && a.location.toLowerCase() < b.location.toLowerCase()) {
          return -1;
        }
        if (a.location && b.location && b.location.toLowerCase() < a.location.toLowerCase()) {
          return 1;
        }

        if (a.date && b.date) {
          if (a.date < b.date) {
            return -1;
          }
          if (b.date < a.date) {
            return 1;
          }
        }

        if (a.mceDate && b.mceDate) {
          if (a.mceDate < b.mceDate) {
            return -1;
          }
          if (b.mceDate < a.mceDate) {
            return 1;
          }
        }

        if (a.deployment_id && b.deployment_id) {
          if (a.deployment_id < b.deployment_id) {
            return -1;
          }
          return 1;
        }

        if (a.mceDeploymentID && b.mceDeploymentID) {
          if (a.mceDeploymentID < b.mceDeploymentID) {
            return -1;
          }
          return 1;
        }
      });
      // console.log("9610 - sort DONE");

      // console.log("11754 - newNewRows=", newNewRows);
      setDeployments(newNewRows);
      // console.log("9560 - setDeployments DONE");

      // console.log("9621 - processColumnsDone=", processColumnsDone, offset, withExtraColumns);
      if (processColumnsDone === false && withExtraColumns.length > 0) {
        processColumnsDone = true;
        processColumns(newNewRows);
      }
    }
    while (res.success && res.moreData);

    // eventDispatch({ deploymentsStatus: "loaded" });
    // console.log("13402 - loadDeploymentsData - END");
  };


  const loadDeploymentsReports = async () => {
    // console.log("1870 - loadDeploymentsReports - BEGIN");
    const savSelectedReport = selectedReport;
    // console.log("11357 - savSelectedReport=", savSelectedReport);

    setSelectedReport(null);
    const rep = await getReports();

    if (rep && rep.reports) {
      for (const report of rep.reports) {
        if (report.id === savSelectedReport && report.type === scenario.devicesType) {
          setSelectedReport(savSelectedReport);
        }
      }
    }

    setReports(rep.reports);
    // console.log("11363 - rep.reports=", rep.reports);
    // console.log("1873 - loadDeploymentsReports - END");
  };


  const handleLoadReports = useCallback(async (cancelValue) => {
    // console.log("1857 - handleLoadReports...", scenario, loading, module, settings.mode);

    const promiseLoadDeploymentsReports = loadDeploymentsReports();
    await promiseLoadDeploymentsReports;

    eventDispatch({ reportsStatus: "loaded" });

    return 1;
  }, [period, pickers, selected, scenario, module, settings.mode, dispatch, loading, setDeployments, appDispatch, t]);



  const handleLoadDeployments = useCallback(async (cancelValue) => {
    // console.log("675 - handleLoadDeployments...", scenario, loading, module, settings.mode);

    setCancelled(false);
    appDispatch({ loading: true });

    setActiveSortModel([]);
    setFilteredRows([]);
    setDeployments([]);

    const promiseLoadDeploymentsHeaders = loadDeploymentsHeaders();

    let start = getPreciseTime(period, 'start');
    let end = getPreciseTime(period, 'end');

    if (isNaN(start)) {
      start = 0;
    }
    if (isNaN(end)) {
      end = 0;
    }

    const startDate = new Date(new Date(+start).getTime() + Math.abs(new Date(+start).getTimezoneOffset() * 60000)).toJSON().slice(0, 10);
    const endDate = new Date(new Date(+end).getTime() + Math.abs(new Date(+end).getTimezoneOffset() * 60000)).toJSON().slice(0, 10);

    await promiseLoadDeploymentsHeaders;

    const promiseLoadDeploymentsData = loadDeploymentsData(cancelValue, startDate, endDate);
    await promiseLoadDeploymentsData;

    eventDispatch({ deploymentsStatus: "loaded" });
    appDispatch({ loading: false });

    return 1;
  }, [period, pickers, selected, scenario, module, settings.mode, dispatch, loading, setDeployments, appDispatch, t]);




  useEffect(() => {// deployments
    // console.log("9736 - useEffect... deployments=", deployments.length, reloadFromStore);

    let duplicateNetworkCardTmp = true;
    for (const element of deployments) {
      if (element.deploy_jukebox_version) {
        if (compareVersionStrings(element.deploy_jukebox_version, "2.0.5.66") < 0) {
          duplicateNetworkCardTmp = false;
          break;
        }
      } {
        duplicateNetworkCardTmp = false;
        break;
      }
    }
    setDuplicateNetworkCard(duplicateNetworkCardTmp);


    if (!reloadFromStore && !_.isEqual(storedDeployments, deployments)) {

      // console.log("11550 - useEffect... deployments=", deployments.length, reloadFromStore);

      appDispatch({
        storedDeployments: deployments,
        storedWelcomeScreenManualInputs: welcomeScreenManualInputs,
        storedSdsQuestions: sdsQuestions,
        storedScriptHeaders: scriptHeaders,
        storedMobileOthersData: mobileOthersData,
        storedSdsExtraDiskHealthFlag: sdsExtraDiskHealthFlag,
        storedSdsExtraDiskPerfFlag: sdsExtraDiskPerfFlag
      });
    }
  }, [deployments]);


  useEffect(() => {// scenariosStatus
    if (scenariosStatus === "loading") {
      setActiveSortModel([]);
      setDeployments([]);
    }
  }, [scenariosStatus]);


  useEffect(() => {// reports
    if (!_.isEqual(storedReports, reports)) {
      appDispatch({ storedReports: reports });
    }
  }, [reports]);


  useEffect(() => {// reportsStatus
    if (reportsStatus === "force") {
      eventDispatch({ reportsStatus: "loading" });
      handleLoadReports();
    }
    else if (reportsStatus === "loaded") {
      eventDispatch({ reportsStatus: "idle" });
    }
  }, [reportsStatus]);



  useEffect(() => {// deploymentsStatus
    if (settings.mode === 'modules')
      document.title = t('reporting.page') + (module ? '\u2000\u2013\u2000' + t('scenarios.modules.' + module) : '');
    else
      document.title = t('reporting.page') + (scenario ? '\u2000\u2013\u2000' + scenario.label : '');

    if (deploymentsStatus === "pending") {

    } else if (deploymentsStatus === "forceForce") {
      eventDispatch({ deploymentsStatus: "force" });
    } else if (deploymentsStatus === "force") {

      if (settings.mode === 'modules') {

        document.title = t('reporting.page') + (module ? '\u2000\u2013\u2000' + t('scenarios.modules.' + module) : '');

        if (!module) {
          setActiveSortModel([]);
          setDeployments([]);
          prevModule.current = null;
        }
        else {
          cancelation.current = getRandomPassword();

          setActiveSortModel([]);

          handleLoadReports();
          handleLoadDeployments(cancelation.current);

          prevModule.current = module;
          prevPeriod.current = period;
          // setRefresh(false);

          eventDispatch({ deploymentsStatus: "loading" });
        }
      }
      else {
        document.title = t('reporting.page') + (scenario ? '\u2000\u2013\u2000' + scenario.label : '');

        prevModule.current = null;
        if (!scenario) {
          setActiveSortModel([]);
          setDeployments([]);
          prevScenario.current = null;
        }
        else {
          cancelation.current = getRandomPassword();

          setActiveSortModel([]);

          handleLoadReports();
          handleLoadDeployments(cancelation.current);

          prevScenario.current = scenario;
          prevPeriod.current = period;

          eventDispatch({ deploymentsStatus: "loading" });
        }
      }

    } else if (deploymentsStatus === "loading") {
      // setActiveSortModel([]);
      // setDeployments([]);
    } else if (deploymentsStatus === "loaded") {
      processColumns();
      eventDispatch({ deploymentsStatus: "idle" });
    }
  }, [deploymentsStatus]);



  // reportingColumnsStatus
  useEffect(() => {// [reportingColumnsStatus]); 
    // console.log("9820 - useEffect... reportingColumnsStatus=", reportingColumnsStatus);
    if (reportingColumnsStatus === "pending") {

    } else if (reportingColumnsStatus === "force") {

    } else if (reportingColumnsStatus === "loading") {
      setActiveSortModel([]);
    } else if (reportingColumnsStatus === "loaded") {

      processColumns();
      eventDispatch({ reportingColumnsStatus: "idle" });
    }
  }, [reportingColumnsStatus]);



  // settings.mode
  useEffect(() => {// [settings.mode]); 
    // console.log("1921 - useEffect... settings.mode=", settings.mode);

    if (!isEqual(settings.mode, prevMode.current) /*|| !scenario*/) {
      setActiveSortModel([]);
      setDeployments([]);

      prevMode.current = settings.mode;
      if (deploymentsStatus !== "force")
      eventDispatch({ deploymentsStatus: "force" });
      else
        eventDispatch({ deploymentsStatus: "forceForce" });
      return;
    }
  }, [settings.mode]);



  // useEffect(() => {// reportingColumns
  //   // console.log("2049 - useEffect... reportingColumns=", reportingColumns);
  // }, [reportingColumns]);


  // useEffect(() => {// showColumnsMenu
  //   if (showColumnsMenu === false && savedRowIndex > 0) {
  //     setForceRowIndex(true);
  //   }
  // }, [showColumnsMenu]);



  useEffect(() => {// sortModel
    // console.log("9886 - useEffect... sortModel=", sortModel, columns, storedSortModel, reloadFromStore);

    if (!_.isEqual(storedSortModel, sortModel)) {
      appDispatch({ storedSortModel: sortModel });

    if (sortModel) {
        if (reportingColumnsStatus === "idle" && deploymentsStatus === "idle") {
      let newActiveSortModel = [];
      for (const element of sortModel) {
        const found = columns.find(o => {
          return element.field === o.field
        })
        if (found) {
          newActiveSortModel.push(element);
        }
      }
          // console.log("9935 - setActiveSortModel=", newActiveSortModel);
      setActiveSortModel(newActiveSortModel);
        }
    }
    else
      setActiveSortModel([]);
    }

  }, [sortModel]);


  useEffect(() => {// withExtraColumns
    // console.log("9928 - useEffect... withExtraColumns=", withExtraColumns);
    if (!_.isEqual(storedWithExtraColumns, withExtraColumns)) {
      appDispatch({ storedWithExtraColumns: withExtraColumns });
    }
  }, [withExtraColumns]);

  useEffect(() => {// filteredRows
    if (!_.isEqual(storedFilteredRows, filteredRows)) {
      appDispatch({ storedFilteredRows: filteredRows });
    }
  }, [filteredRows]);

  useEffect(() => {// maxRowLines
    if (!_.isEqual(storedMaxRowLines, maxRowLines)) {
      appDispatch({ storedMaxRowLines: maxRowLines });
    }
  }, [maxRowLines]);

  useEffect(() => {// headerLinesRatio
    if (!_.isEqual(storedHeaderLinesRatio, headerLinesRatio)) {
      appDispatch({ storedHeaderLinesRatio: headerLinesRatio });
    }
  }, [headerLinesRatio]);

  useEffect(() => {// headerLinesRatio
    if (!_.isEqual(storedColumns, columns)) {
      appDispatch({ storedColumns: columns });
    }
  }, [columns]);

  useEffect(() => {// savedRowIndex
    if (!_.isEqual(storedRowIndex, savedRowIndex)) {
      // console.log("11787 - storedRowIndex=", savedRowIndex);
      appDispatch({ storedRowIndex: savedRowIndex });
    }
  }, [savedRowIndex]);

  useEffect(() => {// savedPageNumber
    if (!_.isEqual(storedPageNumber, savedPageNumber)) {
      // console.log("11787 - storedPageNumber=", savedPageNumber);
      appDispatch({ storedPageNumber: savedPageNumber });
    }
  }, [savedPageNumber]);

  useEffect(() => {// uniqueCount
    if (!_.isEqual(storedUniqueCount, uniqueCount)) {
      appDispatch({ storedUniqueCount: uniqueCount });
    }
  }, [uniqueCount]);


  useEffect(() => {// scenariosStatus
    // console.log("9638 - useEffect... scenariosStatus=", scenariosStatus);
    if (forceRowIndex) {
      // setForceRowIndex(false);

      try {
        if (apiRef && apiRef.current && apiRef.current.scrollToIndexes && deduplicatedRows) {
          setForceRowIndex(false);

          if (settings.pagination)
            apiRef.current.setPage(savedPageNumber);

          const GridCellIndexCoordinates = {
            rowIndex: savedRowIndex
          };
          // console.log("11803 - scrollToIndexes=", GridCellIndexCoordinates);
          apiRef.current.scrollToIndexes(GridCellIndexCoordinates);
        }
      }
      catch (e) {
        console.log("13039 - e=", e);
      }
    }
  }, [forceRowIndex]);


  useEffect(() => {// reloadFromStore
    // console.log("9888 - useEffect... reloadFromStore=", reloadFromStore, groupsLocationsStatus, scenariosStatus, deploymentsStatus, storedSortModel, storedDeployments);

    if (reloadFromStore && groupsLocationsStatus !== 'pending' && scenariosStatus === 'idle' && deploymentsStatus === 'idle' ) {
      // if (storedSortModel)
      //   setSortModel(storedSortModel);

      // if (storedDeployments) {
      // setDeployments(storedDeployments);
      const timeout = 100;
      appDispatch({ loading: true });

      setTimeout(() => {
        // console.log("9915 - timeout setDeployments...", storedDeployments);

        if (storedDeployments)
        setDeployments(storedDeployments);

        if (storedColumns) {
          // console.log("9945 - reload storedColumns=", storedColumns);
          setColumns(storedColumns);
      }

        if (storedSortModel) {
          // console.log("9950 - reload storedSortModel=", storedSortModel);
        setSortModel(storedSortModel);
        }

        if (storedFilteredRows)
          setFilteredRows(storedFilteredRows);

        if (storedMaxRowLines)
          setMaxRowLines(storedMaxRowLines);

        if (storedHeaderLinesRatio)
          setHeaderLinesRatio(storedHeaderLinesRatio);
        // eventDispatch({ deploymentsStatus: "loaded" });

        if (storedPageNumber) {
          setSavedPageNumber(storedPageNumber);
        }

        if (storedRowIndex) {
          setSavedRowIndex(storedRowIndex);
          setForceRowIndex(true);
        }

        // if (storedDeployments && storedColumns && storedColumns.length > 0) {
        //   console.log("9971 - set loading false");
        appDispatch({ loading: false });
        // }
          
      }, timeout);
      // }

      setReloadFromStore(false);
    }
  }, [reloadFromStore]);


  useEffect(() => {// deployments
    // console.log("9929 - useEffect... activeSortModel=", activeSortModel);
  }, [activeSortModel]);


  useEffect(() => {
    // console.log("13829 - ...", filterModel, deduplicatedColumns, columns, filteredRows, scenario);
  const linkOperator = (filterModel && filterModel.items && (filterModel.items.length > 1) && filterModel.linkOperator) || "and";

  const mapDeduplication = new Map();
  for (let j = 0, lenj = columns.length; j < lenj; j++) {
    const type = columns[j].type;

    const index = deduplicatedColumns.indexOf(columns[j].field);
    if (index > -1) {
      const dataTmp = {
        mapData: new Map()
      };
      mapDeduplication.set(columns[j].field, dataTmp);
    }
  }


  const newFilteredRows = _.filter(filteredRows, row => {
    let keepIt = true;

    // AND
    if (filterModel && filterModel.items && linkOperator === "and") {
      keepIt = true;
      for (const filter of filterModel.items) {
        const values = filter.value && filter.value.split("|");

        switch (filter.operatorValue) {
          case "string_Deduplicate": {
            break;
          }

          case "string_Contains": {
            if (filter.value) {
              if (row[filter.columnField] !== null) {

                const found2 = values.find(value => {
                  const params = {
                    formattedValue: row[filter.columnField],
                    field: filter.columnField
                  }
                  // console.log("12779 - params=", params);
                  // console.log("10661 - getInterpretedData(params)=", getInterpretedData(params));

                  for (const line of getInterpretedData(params)) {

                    if (line && value && line.toString().toUpperCase().includes(value.toString().toUpperCase()))
                      return line;
                  }
                  return undefined;
                });

                // Check RAW 
              const found = values.find(value =>
                  row[filter.columnField] && value && row[filter.columnField].toString().toUpperCase().includes(value.toString().toUpperCase())
              )

                // console.log("10672 - row=", row, found, found2);
                if (found === undefined && found2 === undefined)
                keepIt = false;
            }
              else
                keepIt = false;
            }
            break;
          }

          case "string_DoesNotContain": {
            if (filter.value) {
              if (row[filter.columnField] !== null) {

                const found2 = values.find(value => {
                  const params = {
                    formattedValue: row[filter.columnField],
                    field: filter.columnField
                  }
                  for (const line of getInterpretedData(params)) {
                    if (line && value && line.toString().toUpperCase().includes(value.toString().toUpperCase())) {
                      // console.log("10692 - line=", line);
                      // console.log("10693 - value=", value);
                      return line;
                  }
                  }
                  return undefined;
                });

                // Check RAW 
              const found = values.find(value =>
                  row[filter.columnField] && value && row[filter.columnField].toString().toUpperCase().includes(value.toString().toUpperCase())
              )

                // console.log("10702 - row=", row, found, found2);
                if (found !== undefined || found2 !== undefined)
                keepIt = false;
            }
            }
            break;
          }

          case "string_Equals":
          case "number_Equals":
          case "dateTime_Equals": {
            if (filter.value) {
              if (row[filter.columnField] !== null) {

                const found2 = values.find(value => {
                  const params = {
                    formattedValue: row[filter.columnField],
                    field: filter.columnField
                  }

                  for (const line of getInterpretedData(params)) {

                    if (filter.operatorValue === 'string_Equals') {
                      if (line && value && line.toString().toUpperCase() === (value.toString().toUpperCase()))
                        return line;
                    }
                    else if (filter.operatorValue === 'number_Equals') {
                      if (line && value && Number(line) === Number(value))
                        return line;
                    }
                  }
                  return undefined;
                });

                const found = values.find(value => {
                  if (filter.operatorValue === 'string_Equals')
                    return row[filter.columnField] && value && row[filter.columnField].toString().toUpperCase() === (value.toString().toUpperCase());
                  else if (filter.operatorValue === 'number_Equals') {
                    return row[filter.columnField] && value && Number(row[filter.columnField]) === Number(value);
                  }
                  else if (filter.operatorValue === 'dateTime_Equals') {
                    if (row[filter.columnField] && value) {

                      let dateLine = getDateWithoutTimezone(row[filter.columnField]);
                      let dateValue = getDateWithoutTimezone(value);

                      dateLine.setHours(0, 0, 0, 0)
                      dateValue.setHours(0, 0, 0, 0)

                      if (!isNaN(dateLine.getTime()) && !isNaN(dateValue.getTime()) && dateLine.getTime() == dateValue.getTime()) {
                        return true;
                    }
                  }
                  }
                  return undefined;
                });

                // console.log("10760 - row=", row, found, found2);
                if (found === undefined && found2 === undefined)
                keepIt = false;
            }
              else
                keepIt = false;
            }
            break;
          }

          case "string_DoesNotEqual":
          case "number_DoesNotEqual":
          case "dateTime_DoesNotEqual": {
            if (filter.value) {
              if (row[filter.columnField] !== null) {

                const found2 = values.find(value => {
                  const params = {
                    formattedValue: row[filter.columnField],
                    field: filter.columnField
                  }

                  for (const line of getInterpretedData(params)) {

                    if (filter.operatorValue === 'string_DoesNotEqual') {
                      if (line && value && line.toString().toUpperCase() === (value.toString().toUpperCase()))
                        return line;
                    }
                    else if (filter.operatorValue === 'number_DoesNotEqual') {
                      if (line && value && Number(line) === Number(value))
                        return line;
                    }
                  }
                  return undefined;
                });

                const found = values.find(value => {
                  if (filter.operatorValue === 'string_DoesNotEqual')
                    return row[filter.columnField] && value && row[filter.columnField].toString().toUpperCase() === (value.toString().toUpperCase());
                  else if (filter.operatorValue === 'number_DoesNotEqual') {
                    return row[filter.columnField] && value && Number(row[filter.columnField]) === Number(value);
                  }
                  else if (filter.operatorValue === 'dateTime_DoesNotEqual') {
                    if (row[filter.columnField] && value) {

                      // let dateLine = new Date(row[filter.columnField]);
                      // // let dateValue = new Date(value);
                      // let dateValue = new Date(new Date(value).getTime() + Math.abs(new Date().getTimezoneOffset() * 60000));

                      let dateLine = getDateWithoutTimezone(row[filter.columnField]);
                      let dateValue = getDateWithoutTimezone(value);

                      dateLine.setHours(0, 0, 0, 0)
                      dateValue.setHours(0, 0, 0, 0)

                      if (!isNaN(dateLine.getTime()) && !isNaN(dateValue.getTime()) && dateLine.getTime() == dateValue.getTime())
                        return true;
                    }
                  }
                  return undefined;
                });

                // console.log("10817 - row=", row, found, found2);
                if (found !== undefined || found2 !== undefined)
                  keepIt = false;
              }
            }
            break;
          }

          case "string_StartsWith": {
            if (filter.value) {
              if (row[filter.columnField] !== null) {

                const found2 = values.find(value => {
                  const params = {
                    formattedValue: row[filter.columnField],
                    field: filter.columnField
                  }
                  for (const line of getInterpretedData(params)) {
                    if (line && value && line.toString().toUpperCase().startsWith(value.toUpperCase()))
                      return line;
                  }
                  return undefined;
                });

              const found = values.find(value =>
                  row[filter.columnField] && value && row[filter.columnField].toUpperCase().startsWith(value.toUpperCase())
              )
                if (found === undefined && found2 === undefined)
                keepIt = false;
            }
              else
                keepIt = false;
            }
            break;
          }

          case "string_EndsWith": {
            if (filter.value) {
              if (row[filter.columnField] !== null) {

                const found2 = values.find(value => {
                  const params = {
                    formattedValue: row[filter.columnField],
                    field: filter.columnField
                  }
                  for (const line of getInterpretedData(params)) {
                    if (line && value && line.toString().toUpperCase().endsWith(value.toUpperCase()))
                      return line;
                  }
                  return undefined;
                });

              const found = values.find(value =>
                  row[filter.columnField] && value && row[filter.columnField].toUpperCase().endsWith(value.toUpperCase())
              )

                if (found === undefined && found2 === undefined)
                keepIt = false;
            }
              else
                keepIt = false;
            }
            break;
          }

          case "number_GreaterThanOrEqualTo":
          case "dateTime_OnOrAfter": {
            if (filter.value) {
              if (row[filter.columnField] !== null) {

                const found2 = values.find(value => {
                  const params = {
                    formattedValue: row[filter.columnField],
                    field: filter.columnField
                  }

                  for (const line of getInterpretedData(params)) {

                    if (filter.operatorValue === 'number_GreaterThanOrEqualTo') {
                      if (line && value && (Number(line) >= Number(value)))
                        return line;
                    }
                  }
                  return undefined;
                });

                const found = values.find(value => {
                  if (filter.operatorValue === 'number_GreaterThanOrEqualTo')
                    return row[filter.columnField] && value && Number(row[filter.columnField]) >= Number(value);

                  else if (filter.operatorValue === 'dateTime_OnOrAfter') {

                    if (row[filter.columnField] && value) {

                      // let dateLine = new Date(row[filter.columnField]);
                      // // let dateValue = new Date(value);
                      // let dateValue = new Date(new Date(value).getTime() + Math.abs(new Date().getTimezoneOffset() * 60000));

                      let dateLine = getDateWithoutTimezone(row[filter.columnField]);
                      let dateValue = getDateWithoutTimezone(value);

                      dateLine.setHours(0, 0, 0, 0)
                      dateValue.setHours(0, 0, 0, 0)

                      if (dateLine.getTime() >= dateValue.getTime())
                        return true;
                    }
                  }
                  return false;
                });

                if (found === undefined && found2 === undefined)
                  keepIt = false;
              }
              else
                keepIt = false;
            }
            break;
          }

          case "number_GreaterThan":
          case "dateTime_After": {
            if (filter.value) {
              if (row[filter.columnField] !== null) {

                const found2 = values.find(value => {
                  const params = {
                    formattedValue: row[filter.columnField],
                    field: filter.columnField
                  }

                  for (const line of getInterpretedData(params)) {

                    if (filter.operatorValue === 'number_GreaterThan') {
                      if (line && value && (Number(line) > Number(value)))
                        return line;
                    }
                  }
                  return undefined;
                });

                const found = values.find(value => {
                  if (filter.operatorValue === 'number_GreaterThan')
                    return row[filter.columnField] && value && Number(row[filter.columnField]) > Number(value);

                  else if (filter.operatorValue === 'dateTime_After') {

                    if (row[filter.columnField] && value) {
                      // let dateLine = new Date(row[filter.columnField]);
                      // // let dateValue = new Date(value);
                      // let dateValue = new Date(new Date(value).getTime() + Math.abs(new Date().getTimezoneOffset() * 60000));

                      let dateLine = getDateWithoutTimezone(row[filter.columnField]);
                      let dateValue = getDateWithoutTimezone(value);

                      dateLine.setHours(0, 0, 0, 0)
                      dateValue.setHours(0, 0, 0, 0)

                      if (dateLine.getTime() > dateValue.getTime())
                        return true;
                    }
                  }

                  return false;
                });

                if (found === undefined && found2 === undefined)
                  keepIt = false;
              }
              else
                keepIt = false;
            }
            break;
          }

          case "number_LessThanOrEqualTo":
          case "dateTime_OnOrBefore": {
            if (filter.value) {
              if (row[filter.columnField] !== null) {

                const found2 = values.find(value => {
                  const params = {
                    formattedValue: row[filter.columnField],
                    field: filter.columnField
                  }

                  for (const line of getInterpretedData(params)) {

                    if (filter.operatorValue === 'number_LessThanOrEqualTo') {
                      if (line && value && (Number(line) <= Number(value)))
                        return line;
                    }
                  }
                  return undefined;
                });

                const found = values.find(value => {
                  if (filter.operatorValue === 'number_LessThanOrEqualTo')
                    return row[filter.columnField] && value && Number(row[filter.columnField]) <= Number(value);

                  else if (filter.operatorValue === 'dateTime_OnOrBefore') {

                    if (row[filter.columnField] && value) {

                      // let dateLine = new Date(row[filter.columnField]);
                      // // let dateValue = new Date(value);
                      // let dateValue = new Date(new Date(value).getTime() + Math.abs(new Date().getTimezoneOffset() * 60000));

                      let dateLine = getDateWithoutTimezone(row[filter.columnField]);
                      let dateValue = getDateWithoutTimezone(value);

                      dateLine.setHours(0, 0, 0, 0)
                      dateValue.setHours(0, 0, 0, 0)

                      if (dateLine.getTime() <= dateValue.getTime())
                        return true;
                    }
                  }

                  return false;
                });

                if (found === undefined && found2 === undefined)
                  keepIt = false;
              }
              else
                keepIt = false;
            }
            break;
          }

          case "number_LessThan":
          case "dateTime_Before": {
            if (filter.value) {
              if (row[filter.columnField] !== null) {

                const found2 = values.find(value => {
                  const params = {
                    formattedValue: row[filter.columnField],
                    field: filter.columnField
                  }

                  for (const line of getInterpretedData(params)) {

                    if (filter.operatorValue === 'number_LessThan') {
                      if (line && value && (Number(line) < Number(value)))
                        return line;
                    }
                  }
                  return undefined;
                });

                const found = values.find(value => {
                  if (filter.operatorValue === 'number_LessThan')
                    return row[filter.columnField] && value && Number(row[filter.columnField]) < Number(value);

                  else if (filter.operatorValue === 'dateTime_Before') {

                    if (row[filter.columnField] && value) {

                      // let dateLine = new Date(row[filter.columnField]);
                      // // let dateValue = new Date(value);
                      // let dateValue = new Date(new Date(value).getTime() + Math.abs(new Date().getTimezoneOffset() * 60000));

                      let dateLine = getDateWithoutTimezone(row[filter.columnField]);
                      let dateValue = getDateWithoutTimezone(value);

                      dateLine.setHours(0, 0, 0, 0)
                      dateValue.setHours(0, 0, 0, 0)

                      if (dateLine.getTime() < dateValue.getTime())
                        return true;
                    }
                  }

                  return false;
                });

                if (found === undefined && found2 === undefined)
                  keepIt = false;
              }
              else
                keepIt = false;
            }
            break;
          }

          case "string_IsEmpty":
          case "number_IsEmpty": {
            if (row[filter.columnField] !== '' && row[filter.columnField] !== undefined && row[filter.columnField] !== null)
              keepIt = false;
            break;
          }

          case "string_IsNotEmpty":
          case "number_IsNotEmpty": {
            if (row[filter.columnField] === '' || row[filter.columnField] === undefined || row[filter.columnField] === null)
              keepIt = false;
            break;
          }

          default:
            keepIt = true;
        }
      }
    }


    // OR
    else if (filterModel && linkOperator === "or") {
      keepIt = false;
      for (const filter of filterModel.items) {
        const values = filter.value && filter.value.split("|");

        switch (filter.operatorValue) {
          case "string_Deduplicate": {
            break;
          }

          case "string_Contains": {
            if (filter.value) {
              if (row[filter.columnField] !== null) {

                const found2 = values.find(value => {
                  const params = {
                    formattedValue: row[filter.columnField],
                    field: filter.columnField
                  }
                  for (const line of getInterpretedData(params)) {
                    if (line && value && line.toString().toUpperCase().includes(value.toString().toUpperCase()))
                      return line;
                  }
                  return undefined;
                });

                // Check RAW 
              const found = values.find(value =>
                  row[filter.columnField] && value && row[filter.columnField].toString().toUpperCase().includes(value.toString().toUpperCase())
              )

                if (found !== undefined || found2 !== undefined)
                keepIt = true;
            }
            }
            break;
          }

          case "string_DoesNotContain": {
            if (filter.value) {
              if (row[filter.columnField] !== null) {

                const found2 = values.find(value => {
                  const params = {
                    formattedValue: row[filter.columnField],
                    field: filter.columnField
                  }
                  for (const line of getInterpretedData(params)) {
                    if (line && value && line.toString().toUpperCase().includes(value.toString().toUpperCase()))
                      return line;
                  }
                  return undefined;
                });

                // Check RAW 
                const found = values.find(value =>
                  row[filter.columnField] && value && row[filter.columnField].toString().toUpperCase().includes(value.toString().toUpperCase())
                )

                if (found === undefined && found2 === undefined)
              keepIt = true;
              }
            }
            break;
          }

          case "string_Equals":
          case "number_Equals":
          case "dateTime_Equals": {
            if (filter.value) {
              if (row[filter.columnField] !== null) {

                const found2 = values.find(value => {
                  const params = {
                    formattedValue: row[filter.columnField],
                    field: filter.columnField
                  }
                  for (const line of getInterpretedData(params)) {
                    // if (line && value && line.toString().toUpperCase() === value.toString().toUpperCase())
                    //   return line;
                    if (filter.operatorValue === 'string_Equals') {
                      if (line && value && line.toString().toUpperCase() === (value.toString().toUpperCase()))
                        return line;
                    }
                    else if (filter.operatorValue === 'number_Equals') {
                      if (line && value && (Number(line) === Number(value)))
                        return line;
                    }
                  }
                  return undefined;
                });

                // Check RAW 
                // const found = values.find(value =>
                //   row[filter.columnField] && value && row[filter.columnField].toString().toUpperCase() === value.toString().toUpperCase()
                // )
                const found = values.find(value => {
                  if (filter.operatorValue === 'string_Equals')
                    return row[filter.columnField] && value && row[filter.columnField].toString().toUpperCase() === (value.toString().toUpperCase());
                  else if (filter.operatorValue === 'number_Equals') {
                    return row[filter.columnField] && value && Number(row[filter.columnField]) === Number(value);
                  }
                  else if (filter.operatorValue === 'dateTime_Equals') {
                    if (row[filter.columnField] && value) {

                      // let dateLine = new Date(row[filter.columnField]);
                      // // let dateValue = new Date(value);
                      // let dateValue = new Date(new Date(value).getTime() + Math.abs(new Date().getTimezoneOffset() * 60000));

                      let dateLine = getDateWithoutTimezone(row[filter.columnField]);
                      let dateValue = getDateWithoutTimezone(value);

                      dateLine.setHours(0, 0, 0, 0)
                      dateValue.setHours(0, 0, 0, 0)

                      if (!isNaN(dateLine.getTime()) && !isNaN(dateValue.getTime()) && dateLine.getTime() == dateValue.getTime())
                        return true;
                    }
                  }
                  return undefined;
                });

                if (found !== undefined || found2 !== undefined)
              keepIt = true;
              }
            }
            break;
          }

          case "string_DoesNotEqual":
          case "number_DoesNotEqual":
          case "dateTime_DoesNotEqual": {
            if (filter.value) {
              if (row[filter.columnField] !== null) {

                const found2 = values.find(value => {
                  const params = {
                    formattedValue: row[filter.columnField],
                    field: filter.columnField
                  }
                  for (const line of getInterpretedData(params)) {
                    // if (line && value && line.toString().toUpperCase() === value.toString().toUpperCase())
                    //   return line;
                    if (filter.operatorValue === 'string_DoesNotEqual') {
                      if (line && value && line.toString().toUpperCase() === (value.toString().toUpperCase()))
                        return line;
                    }
                    else if (filter.operatorValue === 'number_DoesNotEqual') {
                      if (line && value && (Number(line) === Number(value)))
                        return line;
                    }
                  }
                  return undefined;
                });

                // Check RAW 
                // const found = values.find(value =>
                //   row[filter.columnField] && value && row[filter.columnField].toString().toUpperCase() === value.toString().toUpperCase()
                // )
                const found = values.find(value => {
                  if (filter.operatorValue === 'string_DoesNotEqual')
                    return row[filter.columnField] && value && row[filter.columnField].toString().toUpperCase() === (value.toString().toUpperCase());
                  else if (filter.operatorValue === 'number_DoesNotEqual') {
                    return row[filter.columnField] && value && Number(row[filter.columnField]) === Number(value);
                  }
                  else if (filter.operatorValue === 'dateTime_DoesNotEqual') {
                    if (row[filter.columnField] && value) {

                      // let dateLine = new Date(row[filter.columnField]);
                      // // let dateValue = new Date(value);
                      // let dateValue = new Date(new Date(value).getTime() + Math.abs(new Date().getTimezoneOffset() * 60000));

                      let dateLine = getDateWithoutTimezone(row[filter.columnField]);
                      let dateValue = getDateWithoutTimezone(value);

                      dateLine.setHours(0, 0, 0, 0)
                      dateValue.setHours(0, 0, 0, 0)

                      if (!isNaN(dateLine.getTime()) && !isNaN(dateValue.getTime()) && dateLine.getTime() == dateValue.getTime())
                        return true;
                    }
                  }
                  return undefined;
                });

                if (found === undefined && found2 === undefined)
                  keepIt = true;
              }
            }
            break;
          }

          case "string_startsWith": {
            if (filter.value) {
              if (row[filter.columnField] !== null) {

                const found2 = values.find(value => {
                  const params = {
                    formattedValue: row[filter.columnField],
                    field: filter.columnField
                  }
                  for (const line of getInterpretedData(params)) {
                    if (line && value && line.toString().toUpperCase().startsWith(value.toUpperCase()))
                      return line;
                  }
                  return undefined;
                });

              const found = values.find(value =>
                  row[filter.columnField] && value && row[filter.columnField].toUpperCase().startsWith(value.toUpperCase())
              )

                if (found !== undefined || found2 !== undefined)
                keepIt = true;
            }
            }
            break;
          }

          case "string_EndsWith": {
            if (filter.value) {
              if (row[filter.columnField] !== null) {

                const found2 = values.find(value => {
                  const params = {
                    formattedValue: row[filter.columnField],
                    field: filter.columnField
                  }
                  for (const line of getInterpretedData(params)) {
                    if (line && value && line.toString().toUpperCase().endsWith(value.toUpperCase()))
                      return line;
                  }
                  return undefined;
                });

              const found = values.find(value =>
                  row[filter.columnField] && value && row[filter.columnField].toUpperCase().endsWith(value.toUpperCase())
              )

                if (found !== undefined || found2 !== undefined)
                keepIt = true;
            }
            }
            break;
          }

          

          case "number_GreaterThanOrEqualTo":
          case "dateTime_OnOrAfter": {
            if (filter.value) {
              if (row[filter.columnField] !== null) {

                const found2 = values.find(value => {
                  const params = {
                    formattedValue: row[filter.columnField],
                    field: filter.columnField
                  }

                  for (const line of getInterpretedData(params)) {

                    if (filter.operatorValue === 'number_GreaterThanOrEqualTo') {
                      if (line && value && (Number(line) >= Number(value)))
                        return line;
                    }
                  }
                  return undefined;
                });

                const found = values.find(value => {
                  if (filter.operatorValue === 'number_GreaterThanOrEqualTo')
                    return row[filter.columnField] && value && Number(row[filter.columnField]) >= Number(value);

                  else if (filter.operatorValue === 'dateTime_OnOrAfter') {

                    if (row[filter.columnField] && value) {

                      // let dateLine = new Date(row[filter.columnField]);
                      // // let dateValue = new Date(value);
                      // let dateValue = new Date(new Date(value).getTime() + Math.abs(new Date().getTimezoneOffset() * 60000));

                      let dateLine = getDateWithoutTimezone(row[filter.columnField]);
                      let dateValue = getDateWithoutTimezone(value);

                      dateLine.setHours(0, 0, 0, 0)
                      dateValue.setHours(0, 0, 0, 0)

                      if (dateLine.getTime() >= dateValue.getTime())
                        return true;
                    }
                  }
                  return false;
                });

                if (found !== undefined || found2 !== undefined)
                  keepIt = true;
              }
            }
            break;
          }

          case "number_GreaterThan":
          case "dateTime_After": {
            if (filter.value) {
              if (row[filter.columnField] !== null) {

                const found2 = values.find(value => {
                  const params = {
                    formattedValue: row[filter.columnField],
                    field: filter.columnField
                  }

                  for (const line of getInterpretedData(params)) {

                    if (filter.operatorValue === 'number_GreaterThan') {
                      if (line && value && ((Number(line) > Number(value))))
                        return line;
                    }
                  }
                  return undefined;
                });

                const found = values.find(value => {
                  if (filter.operatorValue === 'number_GreaterThan')
                    return row[filter.columnField] && value && Number(row[filter.columnField]) > Number(value);

                  else if (filter.operatorValue === 'dateTime_After') {

                    if (row[filter.columnField] && value) {

                      // let dateLine = new Date(row[filter.columnField]);
                      // // let dateValue = new Date(value);
                      // let dateValue = new Date(new Date(value).getTime() + Math.abs(new Date().getTimezoneOffset() * 60000));

                      let dateLine = getDateWithoutTimezone(row[filter.columnField]);
                      let dateValue = getDateWithoutTimezone(value);

                      dateLine.setHours(0, 0, 0, 0)
                      dateValue.setHours(0, 0, 0, 0)

                      if (dateLine.getTime() > dateValue.getTime())
                        return true;
                    }
                  }

                  return false;
                });

                if (found !== undefined || found2 !== undefined)
                  keepIt = true;
              }
            }
            break;
          }

          case "number_LessThanOrEqualTo":
          case "dateTime_OnOrBefore": {
            if (filter.value) {
              if (row[filter.columnField] !== null) {

                const found2 = values.find(value => {
                  const params = {
                    formattedValue: row[filter.columnField],
                    field: filter.columnField
                  }

                  for (const line of getInterpretedData(params)) {

                    if (filter.operatorValue === 'number_LessThanOrEqualTo') {
                      if (line && value && (Number(line) <= Number(value)))
                        return line;
                    }
                  }
                  return undefined;
                });

                const found = values.find(value => {
                  if (filter.operatorValue === 'number_LessThanOrEqualTo')
                    return row[filter.columnField] && value && Number(row[filter.columnField]) <= Number(value);

                  else if (filter.operatorValue === 'dateTime_OnOrBefore') {

                    if (row[filter.columnField] && value) {

                      // let dateLine = new Date(row[filter.columnField]);
                      // // let dateValue = new Date(value);
                      // let dateValue = new Date(new Date(value).getTime() + Math.abs(new Date().getTimezoneOffset() * 60000));

                      let dateLine = getDateWithoutTimezone(row[filter.columnField]);
                      let dateValue = getDateWithoutTimezone(value);

                      dateLine.setHours(0, 0, 0, 0)
                      dateValue.setHours(0, 0, 0, 0)

                      if (dateLine.getTime() <= dateValue.getTime())
                        return true;
                    }
                  }

                  return false;
                });

                if (found !== undefined || found2 !== undefined)
                  keepIt = true;
              }
            }
            break;
          }

          case "number_LessThan":
          case "dateTime_Before": {
            if (filter.value) {
              if (row[filter.columnField] !== null) {

                const found2 = values.find(value => {
                  const params = {
                    formattedValue: row[filter.columnField],
                    field: filter.columnField
                  }

                  for (const line of getInterpretedData(params)) {

                    if (filter.operatorValue === 'number_LessThan') {
                      if (line && value && (Number(line) < Number(value)))
                        return line;
                    }
                  }
                  return undefined;
                });

                const found = values.find(value => {
                  if (filter.operatorValue === 'number_LessThan')
                    return row[filter.columnField] && value && Number(row[filter.columnField]) < Number(value);

                  else if (filter.operatorValue === 'dateTime_Before') {

                    if (row[filter.columnField] && value) {

                      // let dateLine = new Date(row[filter.columnField]);
                      // // let dateValue = new Date(value);
                      // let dateValue = new Date(new Date(value).getTime() + Math.abs(new Date().getTimezoneOffset() * 60000));

                      let dateLine = getDateWithoutTimezone(row[filter.columnField]);
                      let dateValue = getDateWithoutTimezone(value);

                      dateLine.setHours(0, 0, 0, 0)
                      dateValue.setHours(0, 0, 0, 0)

                      if (dateLine.getTime() < dateValue.getTime())
                        return true;
                    }
                  }

                  return false;
                });

                if (found !== undefined || found2 !== undefined)
                  keepIt = true;
              }
            }
            break;
          }

          case "string_IsEmpty":
          case "number_IsEmpty": {
            if (row[filter.columnField] === '' || row[filter.columnField] === undefined || row[filter.columnField] === null)
              keepIt = true;
            break;
          }

          case "string_IsNotEmpty":
          case "number_IsNotEmpty": {
            if (row[filter.columnField] !== '' && row[filter.columnField] !== undefined && row[filter.columnField] !== null)
              keepIt = true;
            break;
          }

          default:
            keepIt = false;
        }
      }
    }
    return keepIt;
  });


  // console.log("14336 - newFilteredRows=", newFilteredRows);
  for (let j = 0, lenj = newFilteredRows.length; j < lenj; j++) {
    const row = newFilteredRows[j];

    for (const key of Array.from(mapDeduplication.keys())) {
      const value = row[key];
      const dataTmp = mapDeduplication.get(key);
      const mapDataTmp = dataTmp.mapData;

      if (mapDataTmp.get(value) !== undefined) {
        const prevId = mapDataTmp.get(value);
        if (row.id > prevId)
          mapDataTmp.set(value, row.id);
      }
      else {
        mapDataTmp.set(value, row.id);
      }
    }
  }
  // console.log("14263 - mapDeduplication=", mapDeduplication, filterModel, linkOperator);

    const deduplicatedRowsLocal = _.filter(newFilteredRows, row => {
    let keep = true;

    for (const key of Array.from(mapDeduplication.keys())) {
      const value = row[key];

      if (value) {
        const dataTmp = mapDeduplication.get(key);
        const mapDataTmp = dataTmp.mapData;

        if (mapDataTmp.get(value) !== undefined) {
          if (row.id !== mapDataTmp.get(value))
            keep = false;
          //keep = (row.id === mapDataTmp.get(value));
        }
      }
    }
    return keep;
  });
  const minRow = (maxRowLines > 12) ? 116 : 52;
  let rowHeight = Math.min(minRow, (20 * maxRowLines) + 12);


    const forcedLocal = (rowHeight * deduplicatedRowsLocal.length) > 10000000;
    if (forcedLocal && !settings.pagination) {
    settings.pagination = true;
    changeSettings(t, 'pagination', true, settings, appDispatch)

    settings.pageSize = 1000;
    changeSettings(t, 'pageSize', 1000, settings, appDispatch)
  }
    setForced(forcedLocal);


  // console.log("14377 - columns=", columns);
  // console.log("14378 - filterOperators=", filterOperators);
  for (let j = 0, lenj = columns.length; j < lenj; j++) {
    const type = columns[j].type;
    columns[j].filterOperators = filterOperators[type] ? filterOperators[type].slice() : [];

    if (
      // columns[j].field === "system_$$_serial_number"

      columns[j].field === "system_$$_serial_number" ||
      (columns[j].field === "network_card_$$_mac" && duplicateNetworkCard) ||
      columns[j].field === "disk_$$_serial_number" ||
      columns[j].field === "disk_wipe_$$_serial" ||
      columns[j].field === "disk_wipe_$$_uuid" ||
      columns[j].field === "disks_wipe_$$_serial" ||
      columns[j].field === "disks_wipe_$$_uuid"

    ) {
      const testFilterOperator = {
        value: 'string_Deduplicate'
      }
      columns[j].filterOperators.push(testFilterOperator);
    }
  }


  // console.log("14395 - deduplicatedColumns=", deduplicatedColumns);
  for (let j = 0, lenj = columns.length; j < lenj; j++) {
    if (deduplicatedColumns.includes(columns[j].field)) {
      columns[j].deduplicated = true;
    }
    else
      columns[j].deduplicated = false;
  }

  const tmpArrayForUnique = [];
  if (scenario) {
      const rowsTmp = deduplicatedRowsLocal;

      const selectedRows = selectionModel.length === 0 ? deduplicatedRowsLocal : deduplicatedRowsLocal.filter((row) => {
        return selectionModel.includes(row.key + 1);
    });
      // console.log("14895 - selectionModel=", selectionModel);

      const filteredDeployments = [];
      for (const row of selectedRows) {
        const dep = deployments[row.key];
        filteredDeployments.push(dep);
        }

      const orderedDeployments = filteredDeployments.sort((a, b) => {
        return a.date < b.date ? 1 : -1;
      });
      // console.log("14889 - orderedDeployments=", orderedDeployments);


      for (const dep of filteredDeployments) {
        //for (const row of selectedRows) {
        // const dep = deduplicatedRowsLocal[row.key];

        const found = tmpArrayForUnique.find(d => {
          if (
            d && dep &&
            (
              (scenario.devicesType === devicesTypeValues.PCs && d.system_serial === dep.system_serial)
              ||
              (scenario.devicesType === devicesTypeValues.disks && d.serial === dep.serial)
            )
          ) {

            const cpuListDep = dep.cpu_data && dep.cpu_data.split('<cpu>');
            let cpuModelDep = "";
            if (cpuListDep) {
              cpuListDep.forEach(cpu => {
                const cpuData = fixAndParse(cpu);
                if (cpuData.model !== "") {
                  if (cpuModelDep !== "")
                    cpuModelDep = cpuModelDep + line_separator;
                  cpuModelDep += cpuData.model;
                }
              });
            }

            const cpuListD = d.cpu_data && d.cpu_data.split('<cpu>');
            let cpuModelD = "";
            if (cpuListD) {
              cpuListD.forEach(cpu => {
                const cpuData = fixAndParse(cpu);
                if (cpuData.model !== "") {
                  if (cpuModelD !== "")
                    cpuModelD = cpuModelD + line_separator;
                  cpuModelD += cpuData.model;
        }
              });
        }

            if (
              d.system_uuid === dep.system_uuid &&
              d.motherboard_model === dep.motherboard_model &&
              cpuModelD === cpuModelDep
            ) {
              return true;
            }
          }
          return false;
        });

        if (!found) {
          tmpArrayForUnique.push(dep);
        }
      }
      setUniqueCount(tmpArrayForUnique.length);
      // console.log("14952 - tmpArrayForUnique=", tmpArrayForUnique);
      setDeduplicatedRows(deduplicatedRowsLocal);
    }
  }, [filterModel, deduplicatedColumns, columns, filteredRows, scenario, deployments, selectionModel]);




  let checkSortModel = true;
  for (const element of activeSortModel) {
    const found = columns.find(o => {
      return element.field === o.field
    })
    if (!found) {
      checkSortModel = false;
    }
  }



  let checkedFilterModel = {
    items: [],
    linkOperator: "and"
  };

  try {    
    if (
      apiRef.current.getLocaleText
      && apiRef.current.getLocaleText("filterOperatorActive")
      && apiRef.current.getLocaleText("filterOperatorValueState")
      && apiRef.current.getLocaleText("filterOperatorString_Contains")
      && apiRef.current.getLocaleText("filterOperatorString_DoesNotContain")
      && apiRef.current.getLocaleText("filterOperatorString_Equals")
      && apiRef.current.getLocaleText("filterOperatorString_DoesNotEqual")
      && apiRef.current.getLocaleText("filterOperatorString_StartsWith")
      && apiRef.current.getLocaleText("filterOperatorString_EndsWith")
      && apiRef.current.getLocaleText("filterOperatorString_IsEmpty")
      && apiRef.current.getLocaleText("filterOperatorString_IsNotEmpty")

      && apiRef.current.getLocaleText("filterOperatorNumber_Equals")
      && apiRef.current.getLocaleText("filterOperatorNumber_DoesNotEqual")
      && apiRef.current.getLocaleText("filterOperatorNumber_GreaterThanOrEqualTo")
      && apiRef.current.getLocaleText("filterOperatorNumber_GreaterThan")
      && apiRef.current.getLocaleText("filterOperatorNumber_LessThanOrEqualTo")
      && apiRef.current.getLocaleText("filterOperatorNumber_LessThan")
      && apiRef.current.getLocaleText("filterOperatorNumber_IsEmpty")
      && apiRef.current.getLocaleText("filterOperatorNumber_IsNotEmpty")
      && apiRef.current.getLocaleText("filterOperatorDateTime_Equals")
      && apiRef.current.getLocaleText("filterOperatorDateTime_DoesNotEqual")
      && apiRef.current.getLocaleText("filterOperatorDateTime_OnOrAfter")
      && apiRef.current.getLocaleText("filterOperatorDateTime_After")
      && apiRef.current.getLocaleText("filterOperatorDateTime_OnOrBefore")
      && apiRef.current.getLocaleText("filterOperatorDateTime_Before")

      && apiRef.current.getLocaleText("filterOperatorString_Deduplicate")
    ) {
      checkedFilterModel = filterModel;
    }
  }
  catch (e) {
    // console.log("11691 - e=", e);
  }

  // if (forceRowIndex) {
  //   console.log("13042 - forceRowIndex=", forceRowIndex, savedRowIndex, newFilteredRows);

  //   try {
  //     if (apiRef && apiRef.current && apiRef.current.scrollToIndexes && newFilteredRows) {
  //       const GridCellIndexCoordinates = {
  //         rowIndex: savedRowIndex
  //       };
  //       setForceRowIndex(false);
  //       console.log("13048 - scrollToIndexes=", GridCellIndexCoordinates);
  //       apiRef.current.scrollToIndexes(GridCellIndexCoordinates);
  //     }
  //   }
  //   catch (e) {
  //     console.log("13039 - e=", e);
  //   }
  // }


  // console.log("15092 - ...");



  // console.log("13352 - user=", user);
  // console.log("13361 - mobileOthersData=", mobileOthersData);


  // console.log("13892 - settings=", settings);
  // console.log("13899 - sidebar=", sidebar);
  // console.log("13894 - user=", user);
  // console.log("13895 - model=", model);
  // console.log("13896 - selectedReport=", selectedReport);
  // console.log("13897 - scenario=", scenario);

  // console.log("14777 - scriptHeaders=", scriptHeaders);


  //const [{ autoApply, canApply}, eventDispatch] = useEventContext();

  // console.log("15116 - columns=", columns);
  // console.log("15116 - deployments=", deployments);
  // console.log("15116 - deduplicatedRows=", deduplicatedRows);

  // console.log("15057 - selectionModel=", selectionModel);


  let toolbarText = "";
  if (cancelled) {
    if (loading)
      toolbarText = t('global.please_wait');
    else
      toolbarText = t('global.dots')
  }
  else {
    if (loading) {
      if (deployments.length > 0) {
        toolbarText = t('global.loading') + ' (' + deployments.length + '...)'
      }
      else {
        toolbarText = t('global.loading')
      }
    }
    else {
      const deduplicatedRowsLength = deduplicatedRows.length;
      const filteredRowsLength = filteredRows.length;
      const selectionModelLength = selectionModel.length;

      // console.log("*********");
      // console.log("15081 - deduplicatedRowsLength=", deduplicatedRowsLength);
      // console.log("15082 - filteredRowsLength=", filteredRowsLength);
      // console.log("15083 - selectionModelLength=", selectionModelLength);
      // console.log("15084 - uniqueCount=", uniqueCount);
      // console.log("*********");

      let deployfilteredCount = deduplicatedRowsLength
      if (selectionModelLength > 0) {
        deployfilteredCount = selectionModelLength;
      }

      // default
      toolbarText = filteredRowsLength;
      if (deployfilteredCount < filteredRowsLength) {
        toolbarText = deployfilteredCount + ' / ' + filteredRowsLength
      }

      if (uniqueCount > 0 && uniqueCount != deployfilteredCount) {
        toolbarText += ' (' + uniqueCount + ' ' + t('reporting.unique') + ')';
      }
      // console.log(">> ", toolbarText);
    }
  }


  // loading ? (t('global.please_wait')) : (t('global.dots'))
  // ) : (
  //   // loading ? (t('global.loading') + (apiRef.current.getVisibleRowModels().size > 0 ? ' (' + apiRef.current.getVisibleRowModels().size + '...)' : '')) : apiRef.current.getVisibleRowModels().size
  //   loading ? (t('global.loading') + (deployments.length > 0 ? ' (' + deployments.length + '...)' : '')) : 
  //   (apiRef.current.getVisibleRowModels().size !== filteredRows.length || selectionModel.length > 0 ? (selectionModel.length > 0 ? selectionModel.length : apiRef.current.getVisibleRowModels().size) + ' / ' + filteredRows.length : apiRef.current.getVisibleRowModels().size) + (uniqueCount > 0 ? ' (' + uniqueCount + ' ' + t('reporting.unique') + ')' : '')
  // )

  let split = null;

  try {
  return (
      <CustomSplitter
        position="horizontal"
        primaryPaneMaxHeight="99%"
        primaryPaneMinHeight="40%"
        primaryPaneHeight={storedPanePrimaryHeight ? storedPanePrimaryHeight : "80%"}
        postPoned={false}
        ref={(node) => split = node}
        onDragFinished={e => {
          if (split && split.panePrimary && split.panePrimary.div && split.panePrimary.div.clientHeight)
            appDispatch({ storedPanePrimaryHeight: split.panePrimary.div.clientHeight })
        }}
      >


    <div className="reporting">
      <StyledDataGrid
          // disableVirtualization={true}

        apiRef={apiRef}
        loading={loading}
            // showCellRightBorder={true}
        checkboxSelection

          sortModel={(showColumnsMenu || loading) && checkSortModel ? [] : activeSortModel}

        // density={'compact'}
        disableSelectionOnClick

        // disableVirtualization
        // autoHeight={true}

        // rowHeight={Math.min(99990, 52 * maxRowLines / 2 + 12)}
          //rowHeight={rowHeight}
          //rowHeight={12}

        // rowCount={fixedRowCount}

          headerHeight={headerLinesRatio * 56}

        // hideFooterRowCount={true}
        // disableColumnReorder={true}

        pageSize={settings.pageSize}
        pagination={settings.pagination}
          rowsPerPageOptions={[25, 50, 100, 200, 500, 1000]}

          // rows={showColumnsMenu ? [] : newFilteredRows}
            rows={deduplicatedRows}

        // disableColumnMenu={true}
          // columns={loading ? lightColumns : columns}
          columns={columns}
            columnTypes={{ DeduplicatedStringColumnType }}
            columnBuffer={6}
        // columnTypes={{ stringFilter: activeGridFilter(t, GridFilterInputValue) }}

        // onSelectionModelChange={selected => setModel({ ...model, selected })}
        onPageSizeChange={pageSize => changeSettings(t, 'pageSize', pageSize, settings, appDispatch)}

        onColumnWidthChange={col => changeReportingColumns({
          columns: reportingColumns,
          setWithExtraColumns: setWithExtraColumns,
            setColumns: setColumns,
          allColumns: columns,
          column: col.colDef.field,
          type: 'width',
            value: col.width, t, dispatch, eventDispatch,
          scenario: scenario,
          module: module,
          mode: settings.mode
        })} // Save custom column width set by the user

        // onColumnOrderChange={col => changeReportingColumns({
        //   columns: reportingColumns, type: 'order', column: col.field,
        //   value: { old: col.oldIndex, new: col.targetIndex }, t, dispatch,
        //   scenario: scenario
        // })} // Save custom column order set by the user

        // onColumnVisibilityChange={o => {
        //   // console.log("8094 - o=", o);

        //   const colId = o && o.colDef && o.colDef.key;
        //   const removeIndex = columns.map(col => col.field).indexOf(colId);
        //   columns.splice(removeIndex, 1);

        //   if (settings.mode === undefined || settings.mode === "scenarios") {

        //     updateColumns(columns, scenario && scenario.id, 'reporting').then(res => {
        //       if (!res.success) {
        //         return toast(t('settings.columns.error'), { type: 'error' });
        //       }
        //       toast(t('settings.columns.success'), { type: 'success' });
        //     });
        //   }
        //   else if (settings.mode === "modules") {

        //     updateColumnsForModule(columns, module, 'reporting').then(res => {
        //       if (!res.success) {
        //         return toast(t('settings.columns.error'), { type: 'error' });
        //       }
        //       toast(t('settings.columns.success'), { type: 'success' });
        //     });
        //   }

        //   let newAllColumns = copy(withExtraColumns);          
        //   const removeIndex2 = newAllColumns.map(col => col.field).indexOf(colId);
        //   newAllColumns.splice(removeIndex2, 1);
        //   setWithExtraColumns(newAllColumns);
        //   console.log("9606 - newAllColumns=", newAllColumns);

        //   dispatch({ reportingColumns: columns });
        // }}

          getRowClassName={(params) => {
            return params.id === highlightedRow ? "highlight" : "";
          }}
          onRowClick={o => {
            if (o.id === highlightedRow)
              setHighlightedRow(null);
            else
              setHighlightedRow(o.id)
          }}

        onRowDoubleClick={o => {
          const d = deployments[o.row.key];

          if (scenario && scenario.devicesType === devicesTypeValues.PCs && d && d.deployment_id && d.system_serial)
            setDeployment(deployments[o.row.key]);
            else {
              if (!d) console.log("13142 - no d");
              if (!scenario) console.log("13143 - no scenario");
              if (scenario.devicesType !== devicesTypeValues.PCs) console.log("13144 - scenario.devicesType=", scenario.devicesType);
              if (d && !d.deployment_id) console.log("13145 - no d.deployment_id");
              if (d && !d.system_serial) console.log("13146 - no d.system_serial");
            }
        }}

        onCellOver={o => {
        }}

          onPageChange={pageNumber => {
            if (!showColumnsMenu && deployment === null) {
              // console.log("13212 - pageNumber=", pageNumber);
              setSavedPageNumber(pageNumber);
            }
          }}


          onViewportRowsChange={(GridViewportRowsChangeParams) => {
            if (!showColumnsMenu && deployment === null) {
              //     console.log("13184 - A) GridViewportRowsChangeParams=", GridViewportRowsChangeParams);
              if (GridViewportRowsChangeParams && GridViewportRowsChangeParams.firstRowIndex > 0)
                setSavedRowIndex(GridViewportRowsChangeParams.firstRowIndex);
            }
            //   else
            //     console.log("13188 - B) GridViewportRowsChangeParams=", GridViewportRowsChangeParams);
          }}

        onSortModelChange={(model) => {
            // console.log("onSortModelChange...", model);
          if (!_.isEqual(model, sortModel) && !_.isEqual(model, activeSortModel)) {

              // console.log("changeReportingSortColumns...");
            changeReportingSortColumns({
              model: model,
              t,
              scenario: scenario,
              module: module,
              mode: settings.mode
            })

              // if (model) {
              //   if (reportingColumnsStatus === "idle" && deploymentsStatus === "idle") {
              //     let newActiveSortModel = [];
              //     for (const element of sortModel) {
              //       const found = columns.find(o => {
              //         return element.field === o.field
              //       })
              //       if (found) {
              //         newActiveSortModel.push(element);
              //       }
              //     }
              //     setActiveSortModel(newActiveSortModel);
              //   }
              // }
              // else
              setActiveSortModel([]);

              // console.log("10192 - setActiveSortModel...", activeSortModel);

            setSortModel(model);
          }
        }}

        onSelectionModelChange={(newSelectionModel) => {
            // console.log("5567 - newSelectionModel=", newSelectionModel);
          setSelectionModel(newSelectionModel);
        }}

        selectionModel={selectionModel}

        localeText={{
          ...(localStorage.getItem('lang') === 'fr' ? frFR : enUS).props.MuiDataGrid.localeText,
          ...translatedGridFilters(t)
        }}

        filterMode="server"
          filterModel={checkedFilterModel}

        onFilterModelChange={(model) => {
              // console.log("14577 - model=", model);

              if (model && model.items) {
                const deduplicatedColumnsTmp = [];

                for (const item of model.items) {
                  if (
                    item.operatorValue === "string_Deduplicate" && (
                      item.columnField === "system_$$_serial_number" ||
                      (item.columnField === "network_card_$$_mac" && duplicateNetworkCard) ||
                      item.columnField === "disk_$$_serial_number" ||
                      item.columnField === "disk_wipe_$$_serial" ||
                      item.columnField === "disk_wipe_$$_uuid"
                    )
                  ) {
                    deduplicatedColumnsTmp.push(item.columnField);
                  }
                }
                setDeduplicatedColumns(deduplicatedColumnsTmp);
              }

          dispatch({ filterModel: model });
        }}
        disableAddFilterButton={false}
          disableMultipleColumnsFiltering={false}


        components={{
          ColumnMenu: CustomColumnMenu,
            ColumnSortedAscendingIcon: () => (
              <div
                class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
                style={{ color: colors.softthinks }}
              >
                arrow_upward
              </div>
            ),
            ColumnSortedDescendingIcon: () => (
              <div
                class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
                style={{ color: colors.softthinks }}
              >
                arrow_downward
              </div>
            ),
            ColumnUnsortedIcon: () => (
              <div
                class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
                style={{ color: colors.softthinks, opacity: '0.4' }}
              >
                remove
              </div>
            ),
          LoadingOverlay,
          Toolbar: () => (
            <div className="content__header">

                {(settings.mode !== "modules" || settings.mode === undefined) && (
                <div>
                  {scenario ? (
                    <h2>{scenario.label + '\u2000\u2013\u2000'}
                      <span style={{ color: colors.softthinks }}>
                            {toolbarText}
                            {/* {cancelled ? (
                            loading ? (t('global.please_wait')) : (t('global.dots'))
                        ) : (
                              loading ? (t('global.loading') + (deployments.length > 0 ? ' (' + deployments.length + '...)' : '')) : (apiRef.current.getVisibleRowModels().size !== filteredRows.length || selectionModel.length > 0 ? (selectionModel.length > 0 ? selectionModel.length : apiRef.current.getVisibleRowModels().size) + ' / ' + filteredRows.length : apiRef.current.getVisibleRowModels().size) + (uniqueCount > 0 ? ' (' + uniqueCount + ' ' + t('reporting.unique') + ')' : '')
                            )} */}
                      </span>
                    </h2>
                  ) : (
                      <h2>{scenariosStatus === 'loading' ? t('global.please_wait') : scenarios ? t('reporting.no_scenario'): ""}</h2>
                  )}
                </div>
              )}

              {settings.mode === "modules" && (
                <div>
                  {module ? (
                    <h2>{t('scenarios.modules.' + module) + '\u2000\u2013\u2000'}
                      <span style={{ color: colors.softthinks }}>
                            {/* {loading ? (t('global.loading') + (deployments.length > 0 ? ' (' + deployments.length + '...)' : '')) : (cancelled ? '(' + t('global.cancelled') + ')' : apiRef.current.getVisibleRowModels().size)} */}
                            {toolbarText}
                      </span>
                    </h2>
                  ) : (
                    <h2>{t('reporting.no_module')}</h2>
                  )}
                </div>
              )}

              <div className="options">
                <GridToolbarContainer>
                    <GridToolbarFilterButton disabled={loading} disableAddFilterButton={false} />
                  <Button
                    disabled={loading}
                    onClick={() => setShowColumnsMenu(true)}
                    className="MuiButton-textPrimary MuiButton-textSizeSmall MuiButton-sizeSmall"
                  >
                    <span className="MuiButton-label">
                      <span className="MuiButton-startIcon MuiButton-iconSizeSmall">
                        <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                          <path d="M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z" />
                        </svg>
                      </span>
                      {t('reporting.columns.title')}
                    </span>
                  </Button>
                </GridToolbarContainer>

                <span className="separation" />

                <div className="actions">
                  {(loading) ? (
                    <button
                      disabled={cancelled}
                      title={t('global.cancel')}
                      className="button icon"
                      onClick={(e) => {
                        cancelation.current = getRandomPassword();
                        console.log("10081 - CANCEL : cancelation.current=", cancelation.current);
                        setCancelled(true);
                      }}>
                      <span className="material-icons-round" style={{ color: (cancelled ? '#222' : '#f22') }}>highlight_off</span>
                    </button>
                  ) : (
                  <button
                    disabled={loading}
                    title={t('global.refresh')}
                    className="button icon"
                        //
                        onClick={() => {
                          if (scenariosStatus === "pending") {
                            eventDispatch({
                              scenariosStatus: "force",
                              canApply: 'off'
                            });
                          }
                          else
                            eventDispatch({ deploymentsStatus: "forceForce", scenariosStatus: "idle", canApply: 'off' });
                        }}>
                    <span className="material-icons-round">cached</span>
                  </button>
                  )}

                  <Export
                        disabled={/*(selectionModel && selectionModel.length === 0) ||*/ deployments.length === 0}
                    apiRef={apiRef}
                    loading={loading}
                    model={model}
                    setModel={setModel}
                    selectionModel={selectionModel}
                    reportingColumns={columns}
                    getInterpretedData={
                      settings.reportingExcelReport !== "raw" ? getInterpretedData : null
                    }
                      label={(settings.mode !== "modules" || settings.mode === undefined) ? scenario && t('reporting.print.scenario') + ": " + scenario.label : t('reporting.print.module') + ": " + t('scenarios.modules.' + module)}
                      labelLight={(settings.mode !== "modules" || settings.mode === undefined) ? scenario && scenario.label : t('scenarios.modules.' + module)}
                        period={period}
                        scenarioType={scenario && scenario.devicesType}

                        deployments={deployments}
                        rows={deduplicatedRows}
                        settings={settings}
                        scenario={scenario}
                        columns={columns}
                      />


                      {/* Excel / PDF Download */}

                  {/* <button
                    disabled={selectionModel.length === 0}
                    className="button icon"
                    onClick={callReportGenerator}
                    title={t('global.actions.print')}
                  >
                    <span className="material-icons-round">print</span>
                  </button> */}
                </div>

                    <ExportToPDF
                      disabled={/*(selectionModel && selectionModel.length === 0) ||*/ deployments.length === 0}
                      apiRef={apiRef}
                      loading={loading}
                      model={model}
                      setModel={setModel}
                      selectionModel={selectionModel}
                      reportingColumns={columns}
                      getInterpretedData={
                        getInterpretedData
                        // settings.reportingExcelReport !== "raw" ? getInterpretedData : null
                      }
                      label={(settings.mode !== "modules" || settings.mode === undefined) ? scenario && t('reporting.print.scenario') + ": " + scenario.label : t('reporting.print.module') + ": " + t('scenarios.modules.' + module)}
                      labelLight={(settings.mode !== "modules" || settings.mode === undefined) ? scenario && scenario.label : t('scenarios.modules.' + module)}

                      deployments={deployments}
                      rows={deduplicatedRows}
                      settings={settings}
                      scenario={scenario}
                      sidebar={sidebar}
                      scenarioType={scenario && scenario.devicesType}
                      columns={columns}

                      uniqueCount={uniqueCount}
                    />

                <span className="separation" />

                <div className="actions">
                  {/* <div className="sidebar__select">
                    <select
                      className="singleSelect"
                      disabled={loading || (reports && reports.length === 0)}
                      label={t('admin.reports.columns.format')}
                      value={selectedReport ? selectedReport : 'choose'}
                      onChange={e => {
                        setSelectedReport(e.target.value)
                      }
                      }
                    >
                      <option value="choose" hidden>{t('reporting.report.choose')}</option>

                      {reports && reports.length > 0 ? (
                        reports.sort(function (a, b) {
                          if (a.name.toLowerCase() < b.name.toLowerCase()) {
                            return -1;
                          }
                          if (b.name.toLowerCase() < a.name.toLowerCase()) {
                            return 1;
                          }
                          return 0;
                        }).map((report, key) => (
                          <option
                            value={report.id}
                            name={report.name}
                            data-subtext="<span class='leftMen pull-left'>Sub Text</span>"
                          >
                            {report.name}
                          </option >
                        ))

                      ) : (
                        <div>
                        </div>
                      )}
                    </select>
                  </div> */}


                  <div className="sidebar__select">
                    <ReportSelect
                      reports={reports}
                      setReports={setReports}
                      selectedReport={selectedReport}
                      setSelectedReport={setSelectedReport}
                      loading={loading}
                        type={scenario && scenario.devicesType}
                    >
                    </ReportSelect>

                    {/* <Select className="sidebar__select"
                      style={{
                        width: '100 %',
                        height: '34px',
                        padding: '0 6px',
                        maxWidth: '100%',
                        outline: '0',
                        cursor: 'pointer',
                        fontSize: '15px',
                        fontWeight: '600',
                        fontFamily: 'inherit',

                        transition: '0.25s',
                        color: 'rgb(var(--accent-color))',
                        borderRadius: 'var(--radius-small)',
                        backgroundColor: 'var(--select-bg)',
                        border: '0 px solid var(--separation-color-light)'
                      }}

                      id='report_selecter'
                      variant='outlined'

                      open={reportsOpen}
                      onClose={() => setReportsOpen(false)}
                      onOpen={() => setReportsOpen(true)}

                      disabled={loading || (reports && reports.length === 0)}
                      labelWidth={0}

                      value={selectedReport ? selectedReport : 'choose'}

                      onChange={e => {
                        console.log("6689 - e=", e);
                        if (e.nativeEvent.target.className === "material-icons-round") {
                          //handleUpdateFavorite()
                        }
                        else {
                          setReportsOpen(false)
                          setSelectedReport(e.target.value)
                        }
                      }}

                      renderValue={value => {
                        if (value === "choose") {
                          return (
                            <span style={{
                              width: "100%",
                              maxWidth: "100%",
                              textAlign: 'left',
                              fontSize: '15px', fontWeight: '600', fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
                              transition: '0.25s',
                              color: (loading || (reports && reports.length === 0)) ? 'rgba(var(--accent-color), 204)' : 'rgb(var(--accent-color))'

                            }}>{t('reporting.report.choose')}
                            </span>
                          )
                        }

                        for (const report of reports) {

                          if (report.id == value) {
                            return (
                              <span style={{
                                width: "100%",
                                maxWidth: "100%",
                                textAlign: 'left',
                                fontSize: '15px', fontWeight: '600', fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
                                transition: '0.25s',
                                color: (loading || (reports && reports.length === 0)) ? 'rgba(var(--accent-color), 204)' : 'rgb(var(--accent-color))'

                              }}>{report.name}</span>

                            )
                          }
                        }
                      }}
                    >
                      <MenuItem value="choose" style={{ display: 'none' }}>{t('reporting.report.choose')}</MenuItem>

                      {reports && reports.length > 0 ? (
                        reports.sort(function (a, b) {
                          if (a.name.toLowerCase() < b.name.toLowerCase()) {
                            return -1;
                          }
                          if (b.name.toLowerCase() < a.name.toLowerCase()) {
                            return 1;
                          }
                          return 0;
                        }).map((report, key) => {

                          return (
                            <MenuItem
                              value={report.id}
                              name={report.name}
                            //data-subtext="<span class='leftMen pull-left'>Sub Text</span>"
                            >
                              <span
                                className={"material-icons"}
                                style={{ textAlign: 'left', width: '8%', fontSize: '20px', color: report.favoriteId === null ? 'rgb(var(--nofavorite-color))' : 'rgb(var(--favorite-color))' }}
                                onClick={(e) => {
                                  //console.log("6785 - e=", e, report.id);
                                  e.stopPropagation();
                                  handleUpdateFavorite(e, report.id)
                                }}
                              >
                                {report.favoriteId === null ? 'star_border' : 'star'}
                              </span>

                              <span
                                style={{
                                  width: "92%",
                                  maxWidth: "100%",
                                  textAlign: 'left',
                                  fontSize: '15px', fontWeight: '600', fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
                                  transition: '0.25s',
                                  color: 'initial;'
                                }}
                              >{report.name}</span>

                            </MenuItem >
                          )
                        }
                        )

                      ) : (
                        <div>
                        </div>
                      )}
                    </Select> */}
                  </div>

                  <button
                      disabled={selectionModel && selectionModel.length === 0 || !selectedReport || reportMaxCount > 0}
                    className="button icon"
                    onClick={o => {
                        callReportGenerator(scenario.devicesType);
                        }}
                      title={reportMaxCount === 0 ? t('global.actions.print_report') : "(" + reportCurrentCount + "/" + reportMaxCount + ")"}
                  >
                    <span className="material-icons-round">assignment</span>
                  </button>
                </div>

                    {/* <span className="separation" /> */}




                {/* {user.roleId !== roles.user && <>
                  <span className="separation" />
                  <Link
                    className="button icon"
                    to="/reporting/settings"
                    title={t('scenarios.title')}
                  >
                    <span className="material-icons-outlined">settings</span>
                  </Link>
                </>} */}
              </div>
            </div>
          ),

          Footer: () => (
            <div className="datagrid__footer">

              <GridFooter />
              <div className="checkbox">
                <input
                    disabled={forced}
                  id="pagination"
                  type="checkbox"
                  defaultChecked={settings.pagination}
                    onChange={() => {
                      if (!settings.pagination) {
                        setSavedPageNumber(0);
                      }
                      changeSettings(t, 'pagination', !settings.pagination, settings, appDispatch);
                    }}
                />
                <label htmlFor="pagination">PAGINATION</label>
              </div>
            </div>
          )
        }}
      />

      {/* {(deployments.length > 0) && <Print apiRef={apiRef} deployments={rowsToPrint()} reportingColumns={columns} />} */}

        {showColumnsMenu &&
          <Columns
            setShowColumnsMenu={setShowColumnsMenu}
            welcomeScreenManualInputs={welcomeScreenManualInputs}
            sdsQuestions={sdsQuestions}
            scriptHeaders={scriptHeaders}
            mobileOthersData={mobileOthersData}
              sdsExtraDiskHealthFlag={sdsExtraDiskHealthFlag}
              sdsExtraDiskPerfFlag={sdsExtraDiskPerfFlag}
          />}

        {deployment !== null && <HistoryDetails deployment={deployment} setDeployment={setDeployment} />}

      <button className="collapse__sidebar" onClick={() => toggleSidebar(sidebar, appDispatch)}>
        <span style={{ transform: `rotateZ(${sidebar ? '0' : '180deg'})` }} className="material-icons-round">chevron_left</span>
      </button>


          {/* <button className="collapse__sidebar" onClick={() => toggleSidebar(sidebar, appDispatch)}>
            <span style={{ transform: `rotateZ(${sidebar ? '0' : '180deg'})` }} className="material-icons-round">chevron_left</span>
          </button> */}
    </div >


        <ReportingSubCharts
          deployments={deployments}
          loading={loading}
          rows={deduplicatedRows}
          settings={settings}
          scenario={scenario}
          columns={columns}
          sidebar={sidebar}
          selectionModel={selectionModel}
        />
      </CustomSplitter>
  );
}
  catch (e) {
    return <></>
  }
}
